
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("VSDnB", function(module, exports) {

$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $162b6b7cff61a519$export$ba05d765b8392e5e);
$parcel$export(module.exports, "getBooleanFF", () => $162b6b7cff61a519$export$470e5c2be1411c89);
$parcel$export(module.exports, "fg", () => $162b6b7cff61a519$export$b40ec24ac8275656);

var $gNWRx = parcelRequire("gNWRx");
function $162b6b7cff61a519$export$ba05d765b8392e5e(flagResolver) {
    (0, $gNWRx.setBooleanResolver)(flagResolver);
}
function $162b6b7cff61a519$export$470e5c2be1411c89(name) {
    return (0, $gNWRx.resolveBooleanFlag)(name);
}
function $162b6b7cff61a519$export$b40ec24ac8275656(name) {
    return (0, $gNWRx.resolveBooleanFlag)(name);
}

});
parcelRegister("gNWRx", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $deb4360f78d10c50$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $deb4360f78d10c50$export$6333b6aff9fc6275);

var $iEN9D = parcelRequire("iEN9D");

var $8z44t = parcelRequire("8z44t");

var $6cAn5 = parcelRequire("6cAn5");
const $deb4360f78d10c50$var$pkgName = '@atlaskit/platform-feature-flags';
const $deb4360f78d10c50$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $deb4360f78d10c50$var$hasProcessEnv = typeof $6cAn5 !== 'undefined' && typeof $6cAn5.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $deb4360f78d10c50$var$ENV_ENABLE_PLATFORM_FF = $deb4360f78d10c50$var$hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $deb4360f78d10c50$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $deb4360f78d10c50$var$hasProcessEnv ? false : false;
const $deb4360f78d10c50$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $deb4360f78d10c50$var$ENV_ENABLE_PLATFORM_FF || $deb4360f78d10c50$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $deb4360f78d10c50$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $deb4360f78d10c50$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98] = $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98] || $deb4360f78d10c50$var$DEFAULT_PFF_GLOBAL;
function $deb4360f78d10c50$export$f2b591175b3e424c(resolver) {
    $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $deb4360f78d10c50$export$6333b6aff9fc6275(flagKey) {
    if ($deb4360f78d10c50$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $8z44t.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $deb4360f78d10c50$var$pkgName, flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ($deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98]?.booleanResolver === undefined || $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $iEN9D.default).checkGate(flagKey);
        const result = $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iEN9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $35b5264e002d74be$export$2e2bcd8739ae039);

var $BptNL = parcelRequire("BptNL");

var $i9mLs = parcelRequire("i9mLs");



var $8ruqY = parcelRequire("8ruqY");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $35b5264e002d74be$var$FeatureGates {
    static{
        this.client = new (0, $BptNL.Client)();
    }
    static{
        this.hasCheckGateErrorOccurred = false;
    }
    static{
        this.hasGetExperimentValueErrorOccurred = false;
    }
    static{
        this.checkGate = (gateName, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                    // Attempt to retrieve an override value for the feature gate
                    const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                    // If an override value is found, return it immediately
                    if (overrideValue !== undefined) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$35b5264e002d74be$var$FeatureGates.hasCheckGateErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                        gateName: gateName,
                        error: error
                    });
                    $35b5264e002d74be$var$FeatureGates.hasCheckGateErrorOccurred = true;
                }
            }
            // Proceed with the main logic if no override is found
            return this.client.checkGate(gateName, options);
        };
    }
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static{
        this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                    const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                    if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$35b5264e002d74be$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    this.hasGetExperimentValueErrorOccurred = true;
                }
                return defaultValue;
            }
            // Proceed with the main logic if no override is found
            return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
        };
    }
    static{
        this.initializeCalled = this.client.initializeCalled.bind(this.client);
    }
    static{
        this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    }
    static{
        this.initialize = this.client.initialize.bind(this.client);
    }
    static{
        this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    }
    static{
        this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    }
    static{
        this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    }
    static{
        this.getExperiment = this.client.getExperiment.bind(this.client);
    }
    static{
        this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    }
    static{
        this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    }
    static{
        this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    }
    static{
        this.overrideGate = this.client.overrideGate.bind(this.client);
    }
    static{
        this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    }
    static{
        this.overrideConfig = this.client.overrideConfig.bind(this.client);
    }
    static{
        this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    }
    static{
        this.setOverrides = this.client.setOverrides.bind(this.client);
    }
    static{
        this.getOverrides = this.client.getOverrides.bind(this.client);
    }
    static{
        this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    }
    static{
        this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    }
    static{
        this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    }
    static{
        this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    }
    static{
        this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    }
    static{
        this.updateUser = this.client.updateUser.bind(this.client);
    }
    static{
        this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    }
    static{
        this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    }
    static{
        this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    }
    static{
        this.getLayer = this.client.getLayer.bind(this.client);
    }
    static{
        this.getLayerValue = this.client.getLayerValue.bind(this.client);
    }
}
let $35b5264e002d74be$var$boundFGJS = $35b5264e002d74be$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $35b5264e002d74be$var$FeatureGates;
    else {
        $35b5264e002d74be$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $35b5264e002d74be$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $i9mLs.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $i9mLs.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $35b5264e002d74be$export$2e2bcd8739ae039 = $35b5264e002d74be$var$boundFGJS;

});
parcelRegister("BptNL", function(module, exports) {

$parcel$export(module.exports, "Client", () => $f5725ccebe8e2f70$export$1f2bb630327ac4b6);

var $1Nxtn = parcelRequire("1Nxtn");

var $9Pvqq = parcelRequire("9Pvqq");

var $hMFzK = parcelRequire("hMFzK");

var $9DDUe = parcelRequire("9DDUe");

var $6jK44 = parcelRequire("6jK44");

var $1VtdU = parcelRequire("1VtdU");

var $l4hNL = parcelRequire("l4hNL");

var $5b5vX = parcelRequire("5b5vX");

var $8ruqY = parcelRequire("8ruqY");

var $GWCtt = parcelRequire("GWCtt");

var $i9mLs = parcelRequire("i9mLs");
const $f5725ccebe8e2f70$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $f5725ccebe8e2f70$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $f5725ccebe8e2f70$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $5b5vX.LOCAL_STORAGE_KEY) } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
	 * True if an initialize method was called and completed, meaning the client is now usable.
	 * However if there was an error during initialization it may have initialized with default
	 * values. Use {@link initCompleted} to check for this.
	 */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $9Pvqq.default)();
        this.dataAdapter = new (0, $l4hNL.NoFetchDataAdapter)();
        /**
	 * Call this if modifying the values being served by the Statsig library since it has its own
	 * memoization cache which will not be updated if the values are changed outside of the library.
	 */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = new (0, $5b5vX.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
	 * @description
	 * This method initializes the client using a network call to fetch the bootstrap values.
	 * If the client is inialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $GWCtt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
	 * @description
	 * This method initializes the client using the provider given to call to fetch the bootstrap values.
	 * If the client is initialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param provider {Provider}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $GWCtt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $i9mLs.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $i9mLs.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $8ruqY.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $GWCtt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
	 * This method updates the user using a network call to fetch the new set of values.
	 * @param fetchOptions {FetcherOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $1VtdU.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
	 * This method updates the user using the provider given on initialisation to get the new set of
	 * values.
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
	 * This method updates the user given a new set of bootstrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @param initializeValues {Record<string,unknown>}
	 */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    /**
	 * Returns the value for a feature gate. Returns false if there are errors.
	 * @param {string} gateName - The name of the feature gate.
	 * @param {Object} options
	 * @param {boolean} options.fireGateExposure
	 *        Whether or not to fire the exposure event for the gate. Defaults to true.
	 *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
	 *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
	 * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
	 * <code>options.fireGateExposure</code> is false.
	 * @param gateName
	 */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
	 * Returns the entire config for a given experiment.
	 *
	 * @param {string} experimentName - The name of the experiment
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns The config for an experiment
	 * @example
	 * ```ts
	 * const experimentConfig = client.getExperiment('example-experiment-name');
	 * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
	 * ```
	 */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $hMFzK.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $hMFzK.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $6jK44.EvaluationReason).Error
            });
        }
    }
    /**
	 * Returns the value of a given parameter in an experiment config.
	 *
	 * @template T
	 * @param {string} experimentName - The name of the experiment
	 * @param {string} parameterName - The name of the parameter to fetch from the experiment config
	 * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
	 * if the returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the
	 * expected type. If this function returns false, then the default value will be returned
	 * instead. This can be set to protect your code from unexpected values being set remotely. By
	 * default, this will be done by asserting that the default value and value are the same primitive
	 * type.
	 * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
	 * default value.
	 * @example
	 ``` ts
	 type ValidColor = 'blue' | 'red' | 'yellow';
	 type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

	 const isValidColor: ValidColorTypeCheck =
			(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

	 const buttonColor: ValidColor = client.getExperimentValue(
			'example-experiment-name',
			'backgroundColor',
			'yellow',
			{
					typeGuard: isValidColor
			}
	 );
	 ```
	*/ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
	 * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
	 * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
	 * @param experimentName
	 */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
	 * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
	 * @param layerName
	 * @param parameterName
	 */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
	 * Adds a new override for the given gate.
	 *
	 * This method is additive, meaning you can call it multiple times with different gate names to
	 * build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearGateOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} gateName
	 * @param {boolean} value
	 */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given gate.
	 */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
	 * Adds a new override for the given config (or experiment).
	 *
	 * This method is additive, meaning you can call it multiple times with different experiment
	 * names to build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearConfigOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} experimentName
	 * @param {object} values
	 */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given experiment.
	 * @param {string} experimentName
	 */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
	 * Set overrides for gates, experiments and layers in batch.
	 *
	 * Note that these overrides are **not** additive and will completely replace any that have been
	 * added via prior calls to {@link Client.overrideConfig} or
	 * {@link Client.overrideGate}.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearAllOverrides} after your tests are completed to remove this
	 * localStorage entry.
	 */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
	 * @returns The current overrides for gates, configs (including experiments) and layers.
	 */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
	 * Clears overrides for all gates, configs (including experiments) and layers.
	 */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
	 * Returns whether the given identifiers and customAttributes align with the current
	 * set that is being used by the client.
	 *
	 * If this method returns false, then the {@link Client.updateUser},
	 * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
	 * methods can be used to re-align these values.
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @returns a flag indicating whether the clients current configuration aligns with the given values
	 */ isCurrentUser(identifiers, customAttributes) {
        return (0, $GWCtt.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $GWCtt.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current checkGate value
	 * @param gateName
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current experiment value
	 * @param experimentName
	 * @param parameterName
	 * @param defaultValue
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
	 * Subscribe so on any update the callback will be called.
	 * NOTE: The callback will be called whenever the values are updated even if the values have not
	 * changed.
	 * @param callback
	 * @returns off function to unsubscribe from updates
	 */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
	 * This method initializes the client using a network call to fetch the bootstrap values for the
	 * given user.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @private
	 */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $1VtdU.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $1VtdU.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
	 * This method initializes the client using a set of boostrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValues
	 * @private
	 */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $GWCtt.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $f5725ccebe8e2f70$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $f5725ccebe8e2f70$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $8ruqY.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        this.sdkKey = sdkKey;
        this.user = (0, $GWCtt.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter
        };
        try {
            this.statsigClient = new (0, $1Nxtn.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $1Nxtn.StatsigClient)($f5725ccebe8e2f70$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
	 * This method updates the user for this client with the bootstrap values returned from a given
	 * Promise.
	 * It uses the customAttributes from fetching experiment values to update the Statsig user but
	 * uses the customAttributes from given input to check if the user has changed.
	 *
	 * @param {Identifiers} identifiers
	 * @param {CustomAttributes} customAttributes
	 * @param {Promise<InitializeValues>} getInitializeValues
	 * @private
	 */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
	 * This method updates the user on the nested Statsig client
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValuesPromise
	 * @private
	 */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = (0, $GWCtt.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
	 * @returns string version of the current package in semver style.
	 */ getPackageVersion() {
        return 0, $i9mLs.CLIENT_VERSION;
    }
    /**
	 * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
	 *
	 * @param {string} layerName - The name of the layer
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns A layer
	 * @example
	 * ```ts
	 * const layer = client.getLayer('example-layer-name');
	 * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
	 * ```
	 */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $9DDUe.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $9DDUe.Layer).fromLayer((0, $1Nxtn._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
	 * Returns the value of a given parameter in a layer config.
	 *
	 * @template T
	 * @param {string} layerName - The name of the layer
	 * @param {string} parameterName - The name of the parameter to fetch from the layer config
	 * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
	 * returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
	 * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
	 * @example
	 * ``` ts
	 * type ValidColor = 'blue' | 'red' | 'yellow';
	 * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
	 *
	 * const isValidColor: ValidColorTypeCheck =
	 *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
	 *
	 * const buttonColor: ValidColor = client.getLayerValue(
	 *    'example-layer-name',
	 *    'backgroundColor',
	 *    'yellow',
	 *    {
	 *        typeGuard: isValidColor
	 *    }
	 * );
	 * ```
	 */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("9Pvqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $713542dc64f11289$export$2e2bcd8739ae039);

var $7n9mn = parcelRequire("7n9mn");
const $713542dc64f11289$export$a66cbd9b2289cd78 = '@all-features';
class $713542dc64f11289$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, $7n9mn.EventEmitter2)();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($713542dc64f11289$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($713542dc64f11289$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($713542dc64f11289$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $713542dc64f11289$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});

parcelRegister("hMFzK", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", () => $142fe0e7679753ac$export$6dc24881a3d96325);

var $GWCtt = parcelRequire("GWCtt");
class $142fe0e7679753ac$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $142fe0e7679753ac$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $GWCtt.migrateEvaluationDetails)(experiment.details), experiment.__evaluation?.secondary_exposures, experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("GWCtt", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", () => $181d0696732d3f0c$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $181d0696732d3f0c$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $181d0696732d3f0c$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $181d0696732d3f0c$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $181d0696732d3f0c$export$18ad168d3dbac899);

var $1Nxtn = parcelRequire("1Nxtn");

var $aIZdc = parcelRequire("aIZdc");

var $6jK44 = parcelRequire("6jK44");

var $8ruqY = parcelRequire("8ruqY");
const $181d0696732d3f0c$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $aIZdc.isFedRamp)() ? (0, $8ruqY.PerimeterType).FEDRAMP_MODERATE : (0, $8ruqY.PerimeterType).COMMERCIAL,
        ...options
    });
const $181d0696732d3f0c$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $181d0696732d3f0c$export$3dad1db244472f32 = (identifiers, customAttributes, sdkKey)=>{
    const user = {
        customIDs: !customAttributes?.stableID && sdkKey ? {
            stableID: (0, $1Nxtn.StableID).get(sdkKey),
            ...identifiers
        } : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
const $181d0696732d3f0c$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $181d0696732d3f0c$var$evaluationReasonMappings = Object.entries((0, $6jK44.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $181d0696732d3f0c$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $181d0696732d3f0c$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $6jK44.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};

});
parcelRegister("aIZdc", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $d33f031e5d50f679$export$64d6499adf9b2e51);

function $d33f031e5d50f679$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $16271ea4123e88a6$export$ce553301d55c2fd8);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
const $16271ea4123e88a6$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $16271ea4123e88a6$export$f005e2e9f707cb5f = 'commercial';
const $16271ea4123e88a6$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $16271ea4123e88a6$export$a739cd5aac835909 = 'stg';
const $16271ea4123e88a6$export$42dd0cdd351a4a9 = 'prod';
const $16271ea4123e88a6$export$404582bc18fe4d9e = 'dev';


parcelRegister("6jK44", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", () => $ebf60ba7eff6038f$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $ebf60ba7eff6038f$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({});

});

parcelRegister("8ruqY", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $2d5b6990a7a5a559$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $2d5b6990a7a5a559$export$c42b7bbc5e7ba555);
var $2d5b6990a7a5a559$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $2d5b6990a7a5a559$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
const $2d5b6990a7a5a559$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("9DDUe", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $263dbcb77497739a$export$936d0764594b6eb3);

var $GWCtt = parcelRequire("GWCtt");
class $263dbcb77497739a$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $263dbcb77497739a$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $GWCtt.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), layer.__evaluation?.secondary_exposures, layer.__evaluation?.undelegated_secondary_exposures, layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
}

});

parcelRegister("1VtdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad1f7bf4f3a697b2$export$2e2bcd8739ae039);

var $8ruqY = parcelRequire("8ruqY");

var $i9mLs = parcelRequire("i9mLs");

var $4BA3W = parcelRequire("4BA3W");
const $ad1f7bf4f3a697b2$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $ad1f7bf4f3a697b2$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $ad1f7bf4f3a697b2$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $ad1f7bf4f3a697b2$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $ad1f7bf4f3a697b2$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $ad1f7bf4f3a697b2$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $ad1f7bf4f3a697b2$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $ad1f7bf4f3a697b2$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $4BA3W.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $4BA3W.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter) {
        if (useGatewayUrl) return $ad1f7bf4f3a697b2$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $8ruqY.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $8ruqY.FeatureGateEnvironment).Production:
                return $ad1f7bf4f3a697b2$export$18c93900db9358a4;
            case (0, $8ruqY.FeatureGateEnvironment).Staging:
                return $ad1f7bf4f3a697b2$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $8ruqY.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $8ruqY.FeatureGateEnvironment).Development:
                return $ad1f7bf4f3a697b2$export$f058dbf75c3bc647;
            case (0, $8ruqY.FeatureGateEnvironment).Staging:
                return $ad1f7bf4f3a697b2$export$942ba04389b0d5a2;
            default:
                return $ad1f7bf4f3a697b2$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $ad1f7bf4f3a697b2$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $ad1f7bf4f3a697b2$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $i9mLs.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}

});
parcelRegister("i9mLs", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $702e4d150695c43b$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $702e4d150695c43b$export$a59f8d67326bd1cb = "0.0.0-use.local";

});

parcelRegister("4BA3W", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $362ced472fdb999d$export$286baf652d0b1206);
class $362ced472fdb999d$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("l4hNL", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", () => $e62c5c62fe23e73a$export$55fffef3474104af);

var $1Nxtn = parcelRequire("1Nxtn");
class $e62c5c62fe23e73a$export$55fffef3474104af extends (0, $1Nxtn.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
	 * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
	 * after the Statsig client has been created!
	 */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $1Nxtn.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1Nxtn._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1Nxtn._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $1Nxtn._getStorageKey)(this._getSdkKey(), user);
        return `${0, $1Nxtn.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("5b5vX", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $a2f699f5738687d1$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $a2f699f5738687d1$export$bcb28fbac1def494);

var $10Gqk = parcelRequire("10Gqk");
const $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $a2f699f5738687d1$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $a2f699f5738687d1$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $a2f699f5738687d1$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $a2f699f5738687d1$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $a2f699f5738687d1$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $a2f699f5738687d1$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $a2f699f5738687d1$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $a2f699f5738687d1$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $a2f699f5738687d1$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($a2f699f5738687d1$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $10Gqk._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$a2f699f5738687d1$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($a2f699f5738687d1$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $a2f699f5738687d1$var$makeEmptyStore();
        window.localStorage.removeItem($a2f699f5738687d1$export$d8474cff104280f3);
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($a2f699f5738687d1$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $10Gqk._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($a2f699f5738687d1$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $10Gqk._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});



parcelRegister("8z44t", function(module, exports) {

$parcel$export(module.exports, "debug", () => $74a930288ce2e8c4$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $74a930288ce2e8c4$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $74a930288ce2e8c4$var$DEBUG_MODE = !$74a930288ce2e8c4$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $74a930288ce2e8c4$export$1c9f709888824e05 = (...args)=>{
    if (!$74a930288ce2e8c4$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});



parcelRegister("6wxJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eee0fd9c3566724$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $2eee0fd9c3566724$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)(null);

});

parcelRegister("gSA3s", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $db1a60e9dc5c9d14$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $db1a60e9dc5c9d14$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $db1a60e9dc5c9d14$export$47fade9662f71000);

var $g0ix0 = parcelRequire("g0ix0");
const $db1a60e9dc5c9d14$export$5b78c989c8db2561 = new Map();
const $db1a60e9dc5c9d14$export$2a5c8df26bb89760 = new Map();
const $db1a60e9dc5c9d14$export$47fade9662f71000 = (featureFlagName, featureFlagValue)=>{
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $g0ix0.redactValue)(featureFlagValue);
    $db1a60e9dc5c9d14$export$5b78c989c8db2561.set(featureFlagName, value);
    $db1a60e9dc5c9d14$export$2a5c8df26bb89760.set(featureFlagName, value);
};

});
parcelRegister("g0ix0", function(module, exports) {

$parcel$export(module.exports, "redactValue", () => $9a4ed2bdd42d469b$export$fcc03ee4c944962f);

const $9a4ed2bdd42d469b$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
const $9a4ed2bdd42d469b$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
const $9a4ed2bdd42d469b$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $9a4ed2bdd42d469b$export$7b4abba432e57989 = (value)=>$9a4ed2bdd42d469b$var$isString(value) && $9a4ed2bdd42d469b$var$startsAsObject(value) || $9a4ed2bdd42d469b$var$isObject(value);
const $9a4ed2bdd42d469b$export$fcc03ee4c944962f = (featureFlagValue)=>$9a4ed2bdd42d469b$export$7b4abba432e57989(featureFlagValue) ? (0, $90de389b166e701f$export$42f4885608027d0c) : featureFlagValue;

});
const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';



parcelRegister("tcn7E", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $e9d8d7e26b2e602d$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $e9d8d7e26b2e602d$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $e9d8d7e26b2e602d$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $e9d8d7e26b2e602d$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $e9d8d7e26b2e602d$export$6e17cce6446848f9);

var $nfArY = parcelRequire("nfArY");
const $e9d8d7e26b2e602d$var$state = {
    context: null
};
const $e9d8d7e26b2e602d$export$295213bc4d0c54ad = ()=>{
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
};
const $e9d8d7e26b2e602d$export$f2e521e495a88544 = (interactionId, experienceType)=>{
    $e9d8d7e26b2e602d$export$a1002be327997103(interactionId.replace(/-/g, ''), $e9d8d7e26b2e602d$export$295213bc4d0c54ad(), experienceType);
};
const $e9d8d7e26b2e602d$export$a1002be327997103 = (traceId, spanId, type)=>{
    $e9d8d7e26b2e602d$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
};
const $e9d8d7e26b2e602d$export$b6ac780db3a3cc77 = ()=>$e9d8d7e26b2e602d$var$state.context || undefined;
const $e9d8d7e26b2e602d$export$17ab21d7be720b = ()=>{
    $e9d8d7e26b2e602d$var$state.context = null;
};
const $e9d8d7e26b2e602d$export$6e17cce6446848f9 = (_url)=>{
    if ($e9d8d7e26b2e602d$var$state.context === null) return null;
    const { traceId: traceId, spanId: spanId } = $e9d8d7e26b2e602d$var$state.context;
    return (0, $nfArY.makeTraceHttpRequestHeaders)(traceId, spanId);
};
const $e9d8d7e26b2e602d$export$a1e7396778592551 = (_url)=>{
    const traceHeaders = $e9d8d7e26b2e602d$export$6e17cce6446848f9(_url);
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
};

});
parcelRegister("nfArY", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $ab54be471bba623c$export$1115c5277eb10d5e);
const $ab54be471bba623c$export$1115c5277eb10d5e = (traceId, spanId)=>({
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    });

});


parcelRegister("1u4q7", function(module, exports) {

$parcel$export(module.exports, "DefaultInteractionID", () => $7e359588695aef0a$export$3109542b68df9ba1);
$parcel$export(module.exports, "default", () => $7e359588695aef0a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $7e359588695aef0a$export$37bca3107733ac1e);

var $5uXOq = parcelRequire("5uXOq");
const $7e359588695aef0a$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$7e359588695aef0a$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)($7e359588695aef0a$export$3109542b68df9ba1);
const $7e359588695aef0a$export$37bca3107733ac1e = ()=>$7e359588695aef0a$export$3109542b68df9ba1;
const $7e359588695aef0a$export$9f6000531b78127e = ()=>$7e359588695aef0a$export$3109542b68df9ba1;

});

parcelRegister("bFU4G", function(module, exports) {

$parcel$export(module.exports, "postInteractionLog", () => $b98c15df5ed39925$export$d8f52e8f804021e8);
$parcel$export(module.exports, "getActiveInteraction", () => $b98c15df5ed39925$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $b98c15df5ed39925$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addMetadata", () => $b98c15df5ed39925$export$12f2b6cb85d59904);
$parcel$export(module.exports, "addCustomData", () => $b98c15df5ed39925$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCustomTiming", () => $b98c15df5ed39925$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $b98c15df5ed39925$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $b98c15df5ed39925$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $b98c15df5ed39925$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "extractModuleName", () => $b98c15df5ed39925$export$f5a8f10de74904da);
$parcel$export(module.exports, "addHold", () => $b98c15df5ed39925$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $b98c15df5ed39925$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $b98c15df5ed39925$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $b98c15df5ed39925$export$2df109852219d16e);
$parcel$export(module.exports, "ModuleLoadingProfiler", () => $b98c15df5ed39925$export$9591b52b33ccc510);
$parcel$export(module.exports, "addError", () => $b98c15df5ed39925$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $b98c15df5ed39925$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $b98c15df5ed39925$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $b98c15df5ed39925$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $b98c15df5ed39925$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $b98c15df5ed39925$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $b98c15df5ed39925$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $b98c15df5ed39925$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $b98c15df5ed39925$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $b98c15df5ed39925$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $b98c15df5ed39925$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $b98c15df5ed39925$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdexToAll", () => $b98c15df5ed39925$export$ad216cc25852d44b);
$parcel$export(module.exports, "addApdex", () => $b98c15df5ed39925$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $b98c15df5ed39925$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $b98c15df5ed39925$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $b98c15df5ed39925$export$d0365e48b58231c3);
$parcel$export(module.exports, "addRedirect", () => $b98c15df5ed39925$export$bbf14d79614d9818);
$parcel$export(module.exports, "interactionSpans", () => $b98c15df5ed39925$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $b98c15df5ed39925$export$5342dcad19138a1c);

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $f38ba = parcelRequire("f38ba");

var $tcn7E = parcelRequire("tcn7E");

var $gSA3s = parcelRequire("gSA3s");

var $1u4q7 = parcelRequire("1u4q7");

var $a0hd6 = parcelRequire("a0hd6");

var $45w2S = parcelRequire("45w2S");

var $bJCAw = parcelRequire("bJCAw");
const $b98c15df5ed39925$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
const $b98c15df5ed39925$export$d8f52e8f804021e8 = new (0, $bJCAw.default)();
const $b98c15df5ed39925$var$interactionQueue = [];
const $b98c15df5ed39925$var$segmentCache = new Map();
const $b98c15df5ed39925$var$CLEANUP_TIMEOUT = 60000;
const $b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
const $b98c15df5ed39925$var$segmentObservers = [];
function $b98c15df5ed39925$export$2b3954d2e8509985() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $45w2S.interactions).get(interactionId.current);
}
function $b98c15df5ed39925$var$isPerformanceTracingEnabled() {
    return (0, $fe1wc.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
function $b98c15df5ed39925$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $b98c15df5ed39925$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $b98c15df5ed39925$var$addSegmentObserver(observer) {
    $b98c15df5ed39925$var$segmentObservers.push(observer);
    for (const segmentInfo of $b98c15df5ed39925$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $b98c15df5ed39925$var$removeSegmentObserver(observer) {
    const index = $b98c15df5ed39925$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $b98c15df5ed39925$var$segmentObservers.splice(index, 1);
}
function $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId) {
    (0, $45w2S.interactions).delete(interactionId);
}
function $b98c15df5ed39925$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $b98c15df5ed39925$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $b98c15df5ed39925$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $b98c15df5ed39925$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(data)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $b98c15df5ed39925$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $b98c15df5ed39925$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $45w2S.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $b98c15df5ed39925$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $b98c15df5ed39925$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $45w2S.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
}
function $b98c15df5ed39925$export$9e04fe1a58571ec(moduleId, timestamp) {
    $b98c15df5ed39925$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $b98c15df5ed39925$export$6f228d1fdc911d7(identifier, start, end) {
    $b98c15df5ed39925$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $b98c15df5ed39925$var$moduleLoadingRequests = {};
function $b98c15df5ed39925$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $b98c15df5ed39925$var$labelStackToString(labelStack), name, startTime);
}
function $b98c15df5ed39925$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $b98c15df5ed39925$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    const id = (0, $7Jxgt.v4)();
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled && experimental) interaction.holdExpActive.set(id, {
            ...holdActive,
            start: start
        });
        if (!experimental) interaction.holdActive.set(id, {
            ...holdActive,
            start: start
        });
        $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, start);
        return ()=>{
            const end = performance.now();
            if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $b98c15df5ed39925$var$removeHoldCriterion(id);
            const currentInteraction = (0, $45w2S.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            const expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push({
                        ...expHold,
                        end: end
                    });
                    interaction.holdExpActive.delete(id);
                }
            }
        };
    }
    return ()=>{};
}
function $b98c15df5ed39925$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, start);
    }
    return ()=>{};
}
function $b98c15df5ed39925$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $45w2S.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $b98c15df5ed39925$var$removeHoldCriterion(id);
        }
    }
}
function $b98c15df5ed39925$export$2df109852219d16e(interactionId) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $b98c15df5ed39925$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $b98c15df5ed39925$export$9e04fe1a58571ec($b98c15df5ed39925$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
            $b98c15df5ed39925$export$6f228d1fdc911d7($b98c15df5ed39925$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $1u4q7.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $b98c15df5ed39925$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $1u4q7.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $b98c15df5ed39925$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $b98c15df5ed39925$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $b98c15df5ed39925$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $45w2S.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
const $b98c15df5ed39925$export$53d6f611de951a13 = (interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime)=>{
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $fe1wc.getConfig)()?.postInteractionLog?.enabled) $b98c15df5ed39925$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
};
const $b98c15df5ed39925$var$pushToQueue = (id, data)=>{
    $b98c15df5ed39925$var$interactionQueue.push({
        id: id,
        data: data
    });
};
let $b98c15df5ed39925$var$handleInteraction = $b98c15df5ed39925$var$pushToQueue;
function $b98c15df5ed39925$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
const $b98c15df5ed39925$var$finishInteraction = (id, data, endTime = performance.now())=>{
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $gSA3s.currentFeatureFlagsAccessed));
    (0, $tcn7E.clearActiveTrace)();
    $b98c15df5ed39925$var$callCleanUpCallbacks(data);
    if ((0, $fe1wc.getConfig)()?.vc?.stopVCAtInteractionFinish) data.vc = (0, $a0hd6.getVCObserver)().getVCRawData();
    if (!(0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) $b98c15df5ed39925$export$cd7f480d6b8286c3(id);
    $b98c15df5ed39925$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $b98c15df5ed39925$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $b98c15df5ed39925$var$handleInteraction(id, data);
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $b98c15df5ed39925$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
};
const $b98c15df5ed39925$export$9e614a29a1ac213e = (sinkFn)=>{
    if ($b98c15df5ed39925$var$handleInteraction === $b98c15df5ed39925$var$pushToQueue) {
        $b98c15df5ed39925$var$handleInteraction = sinkFn;
        $b98c15df5ed39925$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $b98c15df5ed39925$var$interactionQueue.length = 0;
    }
};
const $b98c15df5ed39925$export$8a1ba7bef607358a = (sinkFn)=>{
    $b98c15df5ed39925$export$d8f52e8f804021e8.sinkHandler(sinkFn);
};
// a flag to prevent multiple submitting
let $b98c15df5ed39925$var$activeSubmitted = false;
function $b98c15df5ed39925$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const noMoreExpHolds = interaction.holdExpActive.size === 0;
        const postInteraction = async ()=>{
            if ((0, $fe1wc.getConfig)()?.postInteractionLog?.enabled) {
                let experimentalVC90;
                let experimentalTTAI;
                if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
                    experimentalVC90 = (await (0, $f38ba.getExperimentalVCMetrics)(interaction))?.['metric:experimental:vc90'];
                    const { start: start, end: end } = interaction;
                    experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                }
                $b98c15df5ed39925$export$d8f52e8f804021e8.onInteractionComplete({
                    ...interaction,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                });
            }
            if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
            $b98c15df5ed39925$var$activeSubmitted = false;
        };
        if (noMoreActiveHolds) {
            if (!$b98c15df5ed39925$var$activeSubmitted) {
                $b98c15df5ed39925$var$finishInteraction(interactionId, interaction, endTime);
                $b98c15df5ed39925$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $b98c15df5ed39925$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $b98c15df5ed39925$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        $b98c15df5ed39925$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction);
            $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $b98c15df5ed39925$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        $b98c15df5ed39925$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction);
            $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $b98c15df5ed39925$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $45w2S.interactions).forEach((interaction, interactionId)=>{
        const noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $b98c15df5ed39925$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction);
            $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $b98c15df5ed39925$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $45w2S.interactions).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $b98c15df5ed39925$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    if ((0, $fe1wc.getConfig)()?.postInteractionLog?.enabled) $b98c15df5ed39925$export$d8f52e8f804021e8.reset();
    let previousTime = startTime;
    let timeoutTime = $b98c15df5ed39925$var$CLEANUP_TIMEOUT;
    const timerID = setTimeout(()=>{
        $b98c15df5ed39925$export$5def58af4fd46132(interactionId, 'timeout');
    }, $b98c15df5ed39925$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $b98c15df5ed39925$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $5gx4p.default)((0, $fe1wc.getCapabilityRate)('feature_flag_access'));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $b98c15df5ed39925$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $b98c15df5ed39925$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $gSA3s.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $gSA3s.currentFeatureFlagsAccessed).clear();
    (0, $45w2S.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $b98c15df5ed39925$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $b98c15df5ed39925$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    const awaitBM3TTIList = (0, $fe1wc.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $b98c15df5ed39925$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition') {
        (0, $a0hd6.getVCObserver)().start({
            startTime: startTime
        });
        $b98c15df5ed39925$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $f38ba.experimentalVC).start({
            startTime: startTime
        });
    }
}
function $b98c15df5ed39925$export$4a759336b50e86e3(event) {
    const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') {
            interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $b98c15df5ed39925$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $b98c15df5ed39925$export$ad216cc25852d44b(apdex) {
    (0, $45w2S.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $b98c15df5ed39925$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $b98c15df5ed39925$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $b98c15df5ed39925$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $b98c15df5ed39925$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $b98c15df5ed39925$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $b98c15df5ed39925$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($b98c15df5ed39925$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $b98c15df5ed39925$export$1c43f9ac826b6462(labelStack) {
    const key = $b98c15df5ed39925$var$getSegmentCacheKey(labelStack);
    const existingSegment = $b98c15df5ed39925$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $b98c15df5ed39925$var$segmentCache.set(key, segmentInfo);
        $b98c15df5ed39925$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $b98c15df5ed39925$export$d0365e48b58231c3(labelStack) {
    const key = $b98c15df5ed39925$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $b98c15df5ed39925$var$segmentCache.get(key);
    if (segmentInfo) {
        $b98c15df5ed39925$var$segmentCache.delete(JSON.stringify(labelStack));
        $b98c15df5ed39925$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $b98c15df5ed39925$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
const $b98c15df5ed39925$export$6ce04c7ca6810a7e = [];
const $b98c15df5ed39925$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $b98c15df5ed39925$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $b98c15df5ed39925$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $b98c15df5ed39925$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("5gx4p", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f3dab3adc4e602$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $50f3dab3adc4e602$export$2e2bcd8739ae039(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}

});

parcelRegister("fe1wc", function(module, exports) {

$parcel$export(module.exports, "setUFOConfig", () => $884a08804b0d324c$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $884a08804b0d324c$export$44487a86467333c3);
$parcel$export(module.exports, "getInteractionRate", () => $884a08804b0d324c$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getExperimentalInteractionRate", () => $884a08804b0d324c$export$563f73272328c0d);
$parcel$export(module.exports, "getPostInteractionRate", () => $884a08804b0d324c$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $884a08804b0d324c$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getTypingPerformanceTracingMethod", () => $884a08804b0d324c$export$7e32aae12bf9b50f);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $884a08804b0d324c$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $884a08804b0d324c$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $884a08804b0d324c$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $884a08804b0d324c$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "shouldHandleEditorLnv", () => $884a08804b0d324c$export$808cd22f6b703d66);
let $884a08804b0d324c$var$config;
function $884a08804b0d324c$export$10d6139a8fb42158(newConfig) {
    $884a08804b0d324c$var$config = newConfig;
}
function $884a08804b0d324c$export$44487a86467333c3() {
    return $884a08804b0d324c$var$config;
}
function $884a08804b0d324c$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $884a08804b0d324c$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $884a08804b0d324c$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { experimentalInteractionMetrics: experimentalInteractionMetrics } = $884a08804b0d324c$var$config;
        if (!experimentalInteractionMetrics?.enabled) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $884a08804b0d324c$export$1d459f020c06ae34(name, interactionType) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { postInteractionLog: postInteractionLog } = $884a08804b0d324c$var$config;
        if (!postInteractionLog?.enabled) return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === 'number') return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === 'number') return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $884a08804b0d324c$export$29b9ffb14861a1d(capability) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { capability: capabilityRate } = $884a08804b0d324c$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
const $884a08804b0d324c$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $884a08804b0d324c$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$884a08804b0d324c$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $884a08804b0d324c$var$config;
        if (typingMethod != null && $884a08804b0d324c$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $884a08804b0d324c$export$2d311b3fd18dcab1() {
    try {
        if (!$884a08804b0d324c$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $884a08804b0d324c$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $884a08804b0d324c$export$e2ea675800536898() {
    try {
        if (!$884a08804b0d324c$var$config) return false;
        const { removePageSegmentsUFOPrefixes: removePageSegmentsUFOPrefixes } = $884a08804b0d324c$var$config;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $884a08804b0d324c$export$525ba53ca98e9db() {
    try {
        if (!$884a08804b0d324c$var$config) return false;
        const { removeInteractionsUFOPrefixes: removeInteractionsUFOPrefixes } = $884a08804b0d324c$var$config;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $884a08804b0d324c$export$4f4649ef27b6f5d6() {
    try {
        if (!$884a08804b0d324c$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $884a08804b0d324c$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $884a08804b0d324c$export$3c170167645a0eff() {
    try {
        if (!$884a08804b0d324c$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $884a08804b0d324c$var$config;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $884a08804b0d324c$export$d6dc9444bd15f70f() {
    try {
        if (!$884a08804b0d324c$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $884a08804b0d324c$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
function $884a08804b0d324c$export$808cd22f6b703d66() {
    try {
        return $884a08804b0d324c$var$config?.enableEditorLnvHandler ?? false;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("f38ba", function(module, exports) {

$parcel$export(module.exports, "sinkExperimentalHandler", () => $ae10169b4d4f0485$export$7aa99c40634ac65f);
$parcel$export(module.exports, "onExperimentalInteractionComplete", () => $ae10169b4d4f0485$export$1aed449484dedf63);
$parcel$export(module.exports, "experimentalVC", () => $ae10169b4d4f0485$export$81b28dca2587ec47);
$parcel$export(module.exports, "getExperimentalVCMetrics", () => $ae10169b4d4f0485$export$d17d2b5c5e8d732e);

var $37gc9 = parcelRequire("37gc9");

var $h2sI1 = parcelRequire("h2sI1");
const $ae10169b4d4f0485$var$interactionBuffer = [];
let $ae10169b4d4f0485$var$bufferInteractionData = (interactionId, data)=>{
    $ae10169b4d4f0485$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $ae10169b4d4f0485$var$clearInteractionBuffer() {
    $ae10169b4d4f0485$var$interactionBuffer.length = 0;
}
function $ae10169b4d4f0485$var$appendInteractionData(interactionId, data) {
    $ae10169b4d4f0485$var$bufferInteractionData(interactionId, data);
}
function $ae10169b4d4f0485$export$c8a9e17ae62a073d(handler) {
    for (const { interactionId: interactionId, data: data } of $ae10169b4d4f0485$var$interactionBuffer)handler(interactionId, data);
    $ae10169b4d4f0485$var$clearInteractionBuffer();
    $ae10169b4d4f0485$var$bufferInteractionData = handler;
}
function $ae10169b4d4f0485$export$7aa99c40634ac65f(sinkFn) {
    $ae10169b4d4f0485$export$c8a9e17ae62a073d(sinkFn);
}
function $ae10169b4d4f0485$export$1aed449484dedf63(interactionId, data, endTime = performance.now()) {
    if (data.ufoName) {
        data.end = endTime;
        $ae10169b4d4f0485$var$appendInteractionData(interactionId, data);
        $ae10169b4d4f0485$var$clearInteractionBuffer();
    }
}
class $ae10169b4d4f0485$export$f9a59f57e0282541 {
    initialize(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $h2sI1.VCObserver)({
            ...options,
            isPostInteraction: true
        });
        return this;
    }
    start({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    constructor(){
        this.vcObserver = null;
    }
}
const $ae10169b4d4f0485$export$81b28dca2587ec47 = new $ae10169b4d4f0485$export$f9a59f57e0282541();
const $ae10169b4d4f0485$export$d17d2b5c5e8d732e = async (interaction)=>{
    if ($ae10169b4d4f0485$export$81b28dca2587ec47.vcObserver) {
        const prefix = 'ufo-experimental';
        const result = await $ae10169b4d4f0485$export$81b28dca2587ec47.vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: interaction.apdex?.[0]?.stopTime,
            prefix: prefix,
            vc: interaction.vc
        });
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        const pageVisibilityUpToTTAI = (0, $37gc9.getPageVisibilityState)(interaction.start, interaction.end);
        if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:experimental:vc90': VC['90']
        };
    }
    return null;
};

});
parcelRegister("37gc9", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", () => $9d4714fe1b0ac403$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $9d4714fe1b0ac403$export$768b2008623433e1);

var $cBeZP = parcelRequire("cBeZP");
const $9d4714fe1b0ac403$var$timings = [];
let $9d4714fe1b0ac403$var$wasHiddenFlag;
let $9d4714fe1b0ac403$var$setupFlag = false;
function $9d4714fe1b0ac403$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $9d4714fe1b0ac403$var$SIZE = 50;
let $9d4714fe1b0ac403$var$insertIndex = 0;
function $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, time) {
    $9d4714fe1b0ac403$var$timings[$9d4714fe1b0ac403$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $9d4714fe1b0ac403$var$insertIndex = ($9d4714fe1b0ac403$var$insertIndex + 1) % $9d4714fe1b0ac403$var$SIZE;
    $9d4714fe1b0ac403$var$wasHiddenFlag = isPageHiddenFlag;
}
function $9d4714fe1b0ac403$var$handleChange() {
    const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
        $9d4714fe1b0ac403$var$wasHiddenFlag = true;
    } else {
        if ($9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
        $9d4714fe1b0ac403$var$wasHiddenFlag = false;
    }
}
function $9d4714fe1b0ac403$var$setup() {
    (0, $cBeZP.bind)(window, {
        type: 'pageshow',
        listener: $9d4714fe1b0ac403$var$handleChange
    });
    (0, $cBeZP.bind)(window, {
        type: 'pagehide',
        listener: $9d4714fe1b0ac403$var$handleChange
    });
    (0, $cBeZP.bind)(document, {
        type: 'visibilitychange',
        listener: $9d4714fe1b0ac403$var$handleChange
    });
}
function $9d4714fe1b0ac403$export$554cefe0f0373da4() {
    if (!$9d4714fe1b0ac403$var$setupFlag) {
        const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
        $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, 0);
        $9d4714fe1b0ac403$var$setup();
        $9d4714fe1b0ac403$var$setupFlag = true;
    }
}
function $9d4714fe1b0ac403$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($9d4714fe1b0ac403$var$timings.length === 0) return 'visible';
    const currentSize = $9d4714fe1b0ac403$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $9d4714fe1b0ac403$var$insertIndex;
    let endIdx = $9d4714fe1b0ac403$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($9d4714fe1b0ac403$var$insertIndex + i) % currentSize;
        if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($9d4714fe1b0ac403$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});

parcelRegister("h2sI1", function(module, exports) {

$parcel$export(module.exports, "VCObserver", () => $8281afea1c2bf80e$export$1f70d263701b1d01);

var $VSDnB = parcelRequire("VSDnB");

var $aceO8 = parcelRequire("aceO8");

var $epQcA = parcelRequire("epQcA");

var $6Subd = parcelRequire("6Subd");

var $eZGsd = parcelRequire("eZGsd");

var $joHOM = parcelRequire("joHOM");
const $8281afea1c2bf80e$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $8281afea1c2bf80e$var$UNUSED_SECTOR = 0;
function $8281afea1c2bf80e$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $8281afea1c2bf80e$export$1f70d263701b1d01 {
    static{
        /** config * */ this.VCParts = [
            '25',
            '50',
            '75',
            '80',
            '85',
            '90',
            '95',
            '98',
            '99'
        ];
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.multiHeatmap = null;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                multiHeatmap: this.multiHeatmap,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios, multiHeatmap: multiHeatmap } = rawData;
            if (abortReasonInfo !== null && abortReason.blocking) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                return {
                    [`${fullPrefix}vc:state`]: false,
                    [`${fullPrefix}vc:abort:reason`]: abortReasonInfo,
                    [`${fullPrefix}vc:abort:timestamp`]: abortReason.timestamp
                };
            }
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = $8281afea1c2bf80e$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport
            });
            try {
                if (!this.isPostInteraction) $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                    const duration = VC[key];
                    if (duration !== null && duration !== undefined) performance.measure(`VC${key}`, {
                        start: start,
                        duration: duration
                    });
                });
            } catch (e) {
            /* empty */ }
            let _componentsLog = {};
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            if ((0, $VSDnB.fg)('ufo-remove-vc-component-observations-after-ttai')) Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            else _componentsLog = {
                ...componentsLog
            };
            const vcNext = $8281afea1c2bf80e$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport
            });
            try {
                if (!this.isPostInteraction) $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                    const duration = vcNext.VC[key];
                    if (duration !== null && duration !== undefined) performance.measure(`VC_Next${key}`, {
                        start: start,
                        duration: duration
                    });
                });
            } catch (e) {
            /* empty */ }
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    window.__vc = {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    window.__vcNext = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $8281afea1c2bf80e$var$filterComponentsLog(componentsLog),
                            entries: VCEntries.rel
                        }
                    }));
                }
            } catch (e) {
            /*  do nothing */ }
            const isMultiHeatmapEnabled = (0, $VSDnB.fg)('ufo_vc_multiheatmap');
            const revisionsData = isMultiHeatmapEnabled && multiHeatmap !== null ? {
                [`${fullPrefix}vc:rev`]: multiHeatmap.getPayloadShapedData({
                    VCParts: $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.map((v)=>parseInt(v)),
                    VCCalculationMethods: (0, $joHOM.getRevisions)().map(({ classifier: classifier })=>classifier.VCCalculationMethod),
                    filterComponentsLog: (0, $joHOM.getRevisions)().map(({ classifier: classifier })=>classifier.filterComponentsLog),
                    ttai: stop,
                    ssr: ssr,
                    clean: !abortReasonInfo
                })
            } : null;
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            const isCalcSpeedIndexEnabled = (0, $VSDnB.fg)('ufo-calc-speed-index');
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: !abortReasonInfo,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: vcNext.VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                //...oldDomUpdates,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                [`ufo:speedIndex`]: isCalcSpeedIndexEnabled ? VCEntries.speedIndex : undefined,
                [`ufo:next:speedIndex`]: isCalcSpeedIndexEnabled ? vcNext.VCEntries.speedIndex : undefined
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason)=>{
            this.measureStart();
            this.legacyHandleUpdate(rawTime, intersectionRect, targetName, element, type, ignoreReason);
            if ((0, $VSDnB.fg)('ufo_vc_multiheatmap')) this.onViewportChangeDetected({
                timestamp: rawTime,
                intersectionRect: intersectionRect,
                targetName: targetName,
                element: element,
                type: type,
                ignoreReason: ignoreReason
            });
            this.measureStop();
        };
        this.legacyHandleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                if ((!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason
                });
            }
        };
        this.onViewportChangeDetected = ({ element: element, type: type, ignoreReason: ignoreReason, timestamp: timestamp, targetName: targetName, intersectionRect: intersectionRect })=>{
            if (this.multiHeatmap === null) return;
            // @todo add abort reason handling
            const time = Math.round(timestamp - this.startTime);
            const revisions = (0, $joHOM.getRevisions)();
            const revisionsClassification = revisions.map((revision)=>{
                return revision.classifier.classifyUpdate({
                    element: element,
                    type: type,
                    ignoreReason: ignoreReason
                });
            }, []);
            this.multiHeatmap.handleUpdate({
                time: time,
                targetName: targetName,
                intersectionRect: intersectionRect,
                type: type,
                element: element,
                classification: revisionsClassification,
                onError: (error)=>{
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, error.time, error.error);
                }
            });
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $aceO8.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) {
                Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                    if (time) this.abortReasonCallback(key, time);
                });
                unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                delete window?.__SSR_ABORT_LISTENERS__;
            }
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $eZGsd.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        if ((0, $VSDnB.fg)('ufo_vc_multiheatmap')) this.multiHeatmap = new (0, $6Subd.MultiRevisionHeatmap)({
            viewport: this.viewport,
            revisions: (0, $joHOM.getRevisions)(),
            devToolsEnabled: this.devToolsEnabled
        });
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $8281afea1c2bf80e$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport }) {
        const lastUpdate = {};
        let totalPainted = 0;
        if (ssr !== $8281afea1c2bf80e$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssr]) componentsLog[ssr] = [];
            componentsLog[ssr].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $8281afea1c2bf80e$var$UNUSED_SECTOR && ssr !== $8281afea1c2bf80e$var$UNUSED_SECTOR ? ssr : entry);
                totalPainted += rounded !== $8281afea1c2bf80e$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $8281afea1c2bf80e$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $8281afea1c2bf80e$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $8281afea1c2bf80e$export$1f70d263701b1d01.makeVCReturnObj();
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        const isCalcSpeedIndexEnabled = (0, $VSDnB.fg)('ufo-calc-speed-index');
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            if ((0, $VSDnB.fg)('platform_ufo_fix_vc_observer_rounding_error')) {
                const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                const preciseAccRatio = Math.round(acc * 100);
                VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            }
            const time = v[0];
            $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            if (isCalcSpeedIndexEnabled) {
                const speedIndex = timestamp * ratioDelta;
                acc.speedIndex += speedIndex;
            }
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $8281afea1c2bf80e$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        if ((0, $VSDnB.fg)('ufo_vc_multiheatmap')) this.multiHeatmap = new (0, $6Subd.MultiRevisionHeatmap)({
            viewport: this.viewport,
            revisions: (0, $joHOM.getRevisions)(),
            devToolsEnabled: this.devToolsEnabled
        });
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($8281afea1c2bf80e$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $epQcA.getViewportWidth)();
        this.viewport.h = (0, $epQcA.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, time, `index - ${row}`);
                } catch (e) {
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        this.unbind.forEach((fn)=>fn());
        this.unbind = [];
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("aceO8", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", () => $05d54f94441303a8$export$9010aa71841a6887);

var $cBeZP = parcelRequire("cBeZP");

var $Pu2vb = parcelRequire("Pu2vb");

var $epQcA = parcelRequire("epQcA");
const $05d54f94441303a8$export$9010aa71841a6887 = (window, initialViewPort, callback)=>{
    const unbindWheel = (0, $cBeZP.bind)(window, {
        type: (0, $Pu2vb.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $Pu2vb.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $cBeZP.bind)(window, {
        type: (0, $Pu2vb.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $Pu2vb.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $cBeZP.bind)(window, {
        type: (0, $Pu2vb.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $epQcA.getViewportWidth)() !== initialViewPort.w || (0, $epQcA.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $Pu2vb.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
};

});
parcelRegister("Pu2vb", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", () => $b4a560c0776083f4$export$199edc0307b5587f);
const $b4a560c0776083f4$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("epQcA", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", () => $20743fc2a72ae229$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $20743fc2a72ae229$export$4f01c15d21ef9cc6);
function $20743fc2a72ae229$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $20743fc2a72ae229$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("6Subd", function(module, exports) {

$parcel$export(module.exports, "MultiRevisionHeatmap", () => $e691834d2c757960$export$40923620784ea2c1);
const $e691834d2c757960$var$UNUSED_SECTOR = 0;
class $e691834d2c757960$export$40923620784ea2c1 {
    constructor({ viewport: viewport, revisions: revisions, arraySize: arraySize, devToolsEnabled: devToolsEnabled }){
        this.arraySize = {
            w: 200,
            h: 200
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize.w);
            const t = Math.floor(top / h * this.arraySize.h);
            const r = Math.ceil((left + width) / w * this.arraySize.w);
            const b = Math.ceil((top + height) / h * this.arraySize.h);
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize.w, r),
                b: Math.min(this.arraySize.h, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize.w * this.arraySize.h);
        };
        this.viewport = viewport;
        this.revisions = revisions;
        if (arraySize) this.arraySize = arraySize;
        this.heatmaps = new Array(revisions.length);
        this.componentsLogs = new Array(revisions.length);
        this.vcRatios = new Array(revisions.length);
        this.devToolsEnabled = devToolsEnabled || false;
        revisions.forEach(({}, i)=>{
            this.heatmaps[i] = this.getCleanHeatmap();
            this.componentsLogs[i] = {};
            this.vcRatios[i] = {};
        });
    }
    handleUpdate({ time: time, type: type, classification: classification, intersectionRect: intersectionRect, element: element, targetName: targetName, ignoreReason: ignoreReason, onError: onError }) {
        const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
        const result = this.applyChangesToHeatMap(mappedValues, time, classification);
        if (result !== true) onError(result);
        const componentRatio = this.getElementRatio(mappedValues);
        this.revisions.forEach((_, i)=>{
            if (classification[i]) this.vcRatios[i][targetName] = componentRatio;
            if (!this.componentsLogs[i][time]) this.componentsLogs[i][time] = [];
            this.componentsLogs[i][time].push({
                __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                intersectionRect: intersectionRect,
                targetName: targetName,
                ignoreReason: ignoreReason
            });
        });
    }
    getData() {
        return {
            heatmaps: this.heatmaps
        };
    }
    getPayloadShapedData(args) {
        const result = this.processData(args);
        const payload = this.revisions.map((rev, i)=>{
            const vcDetails = {};
            args.VCParts.forEach((VCPart)=>{
                vcDetails[VCPart] = {
                    t: result[i].VC[VCPart] || 0,
                    e: Array.from(result[i].VCBox[VCPart] || [])
                };
            });
            return {
                revision: rev.name,
                vcDetails: vcDetails,
                clean: args.clean,
                'metric:vc90': null
            };
        });
        return payload;
    }
    processData({ VCParts: VCParts, VCCalculationMethods: VCCalculationMethods, filterComponentsLog: filterComponentsLog, ttai: ttai, ssr: ssr = $e691834d2c757960$var$UNUSED_SECTOR }) {
        return this.heatmaps.map((heatmap, i)=>{
            const lastUpdate = {};
            let totalPainted = 0;
            let componentsLog = this.componentsLogs[i];
            if (ssr !== $e691834d2c757960$var$UNUSED_SECTOR) {
                const element = {
                    __debug__element: new WeakRef(window.document?.body),
                    intersectionRect: {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        x: 0,
                        y: 0,
                        width: this.viewport.w,
                        height: this.viewport.h,
                        toJSON () {
                            return {};
                        }
                    },
                    targetName: 'SSR'
                };
                if (!componentsLog[ssr]) componentsLog[ssr] = [];
                componentsLog[ssr].push(element);
            }
            for(let i = 0; i < heatmap.length; i++){
                const rounded = Math.floor(heatmap[i] === $e691834d2c757960$var$UNUSED_SECTOR && ssr !== $e691834d2c757960$var$UNUSED_SECTOR ? ssr : heatmap[i]);
                totalPainted += rounded !== $e691834d2c757960$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $e691834d2c757960$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            }
            const entries = Object.entries(lastUpdate).map((a)=>[
                    parseInt(a[0], 10),
                    a[1]
                ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
            // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
            componentsLog = filterComponentsLog[i]({
                componentsLog: componentsLog,
                ttai: ttai
            });
            const { VC: VC, VCBox: VCBox } = VCCalculationMethods[i]({
                VCParts: VCParts,
                componentsLog: componentsLog,
                entries: entries,
                totalPainted: totalPainted
            });
            const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
                const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
                const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                const logEntry = componentsLog[timestamp]?.map((v)=>v.targetName);
                acc.abs.push([
                    timestamp,
                    currentlyPainted
                ]);
                acc.rel.push({
                    time: timestamp,
                    vc: currentlyPaintedRatio,
                    elements: logEntry
                });
                return acc;
            }, {
                abs: [],
                rel: []
            });
            return {
                VC: VC,
                VCBox: VCBox,
                VCEntries: VCEntries,
                totalPainted: totalPainted
            };
        });
    }
    applyChangesToHeatMap(a, time, classification) {
        const { l: l, t: t, r: r, b: b } = a;
        const size = classification.length;
        for(let row = t; row < b; row++){
            if (this.heatmaps[0][row] === undefined) try {
                return {
                    error: `index - ${row}`,
                    time: time
                };
            } catch (e) {
                return {
                    error: 'row error',
                    time: time
                };
            }
            else {
                for(let heatmapIndex = 0; heatmapIndex < size; heatmapIndex++)if (classification[heatmapIndex]) this.heatmaps[heatmapIndex].fill(time, this.getIndex(l, row), this.getIndex(r, row));
            }
        }
        return true;
    }
    getIndex(x, y) {
        return x + this.arraySize.w * y;
    }
    getCleanHeatmap() {
        return new Int32Array(this.arraySize.w * this.arraySize.h);
    }
    static makeVCReturnObj(VCParts) {
        const vc = {};
        VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
}

});

parcelRegister("eZGsd", function(module, exports) {

$parcel$export(module.exports, "Observers", () => $aa3fefb78ef7f562$export$b65d046240060e78);

var $VSDnB = parcelRequire("VSDnB");

var $fe1wc = parcelRequire("fe1wc");

var $1HYUt = parcelRequire("1HYUt");

var $l7hoT = parcelRequire("l7hoT");

var $flJpT = parcelRequire("flJpT");
const $aa3fefb78ef7f562$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $aa3fefb78ef7f562$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
function $aa3fefb78ef7f562$var$isInsideEditorContainer(target) {
    if (!target || typeof target.closest !== 'function') return false;
    return Boolean(target.closest('.ProseMirror'));
}
class $aa3fefb78ef7f562$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $aa3fefb78ef7f562$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type
            });
        };
        this.selectorConfig = {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $flJpT.SSRPlaceholderHandlers)();
        this.editorLnvHandler = new (0, $l7hoT.EditorLnvHandler)();
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $aa3fefb78ef7f562$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: (0, $VSDnB.fg)('platform-ufo-vc-observe-attributes') ? [
                'hidden',
                'style',
                'src',
                'class'
            ] : [
                'hidden',
                'style',
                'src'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
        this.editorLnvHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $aa3fefb78ef7f562$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        const shouldHandleEditorLnvLocal = (0, $fe1wc.shouldHandleEditorLnv)();
        return this.isBrowserSupported() ? new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $aa3fefb78ef7f562$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $aa3fefb78ef7f562$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $aa3fefb78ef7f562$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $aa3fefb78ef7f562$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $1HYUt.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (shouldHandleEditorLnvLocal) {
                                if (this.editorLnvHandler.shouldHandleAddedNode(node)) {
                                    this.editorLnvHandler.handleAddedNode(node).then(({ shouldIgnore: shouldIgnore })=>{
                                        this.observeElement(node, mutation, 'html', shouldIgnore ? 'editor-lazy-node-view' : ignoreReason);
                                    });
                                    return;
                                }
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        if ((0, $VSDnB.fg)('platform-ufo-vc-observe-attributes')) this.observeElement(mutation.target, mutation, 'attr', ignoreReason);
                    }
                }
            });
            this.measureStop();
        }) : null;
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch (e) {
            return 'error';
        }
    }
    getIntersectionObserver() {
        return this.isBrowserSupported() ? new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if ((0, $VSDnB.fg)('platform-ufo-invisible-element-vc-calculations')) {
                        if (!$aa3fefb78ef7f562$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    }
                    if ((0, $VSDnB.fg)('platform_editor_ed-25937_ignore_mutations_for_ttvc')) {
                        if ($aa3fefb78ef7f562$var$isInsideEditorContainer(target)) data.ignoreReason = 'editor-container-mutation';
                    }
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch (e) {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        }) : null;
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("1HYUt", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $dac8a3c213f349f7$export$f61fbc3b9c4a9019);

var $lr1Nm = parcelRequire("lr1Nm");
const $dac8a3c213f349f7$export$f61fbc3b9c4a9019 = (node)=>{
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $lr1Nm.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
};

});
parcelRegister("lr1Nm", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $71e1e5daed4f23b4$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $71e1e5daed4f23b4$export$7028e9efe569888c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $71e1e5daed4f23b4$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $71e1e5daed4f23b4$export$7028e9efe569888c = {
    [$71e1e5daed4f23b4$export$7674290405cc25b0]: true
};
function $71e1e5daed4f23b4$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...$71e1e5daed4f23b4$export$7028e9efe569888c,
        children: children
    });
}

});


parcelRegister("l7hoT", function(module, exports) {

$parcel$export(module.exports, "EditorLnvHandler", () => $8aa0ab1e2555bba9$export$569bcb41b9a84ec8);
const $8aa0ab1e2555bba9$var$placeholderDataKey = 'editorLnvPlaceholder'; // data-editor-lnv-placeholder
const $8aa0ab1e2555bba9$var$replaceDataKey = 'editorLnvPlaceholderReplace'; // data-editor-lnv-placeholder-replace
class $8aa0ab1e2555bba9$export$569bcb41b9a84ec8 {
    constructor(){
        this.placeholders = new Map();
        this.getSizeCallbacks = new Map();
        this.isAddedPlaceholderMatchingSizeCallbacks = new Map();
        this.isAddedReplaceMatchingSizeCallbacks = new Map();
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) return;
            const placeholderId = target.dataset?.[$8aa0ab1e2555bba9$var$placeholderDataKey];
            if (placeholderId && this.getSizeCallbacks.has(placeholderId)) {
                const resolve = this.getSizeCallbacks.get(placeholderId);
                this.getSizeCallbacks.delete(placeholderId);
                if (!resolve) return;
                resolve({
                    x: boundingClientRect.x,
                    y: boundingClientRect.y,
                    width: boundingClientRect.width,
                    height: boundingClientRect.height
                });
                return;
            }
            if (placeholderId && this.isAddedPlaceholderMatchingSizeCallbacks.has(placeholderId)) {
                const resolve = this.isAddedPlaceholderMatchingSizeCallbacks.get(placeholderId);
                this.isAddedPlaceholderMatchingSizeCallbacks.delete(placeholderId);
                if (!resolve) return;
                const placeholder = this.placeholders.get(placeholderId);
                if (!placeholder) {
                    resolve(false);
                    return;
                }
                resolve(this.areRectsSameSize(placeholder, boundingClientRect));
                return;
            }
            const replaceId = target.dataset?.[$8aa0ab1e2555bba9$var$replaceDataKey];
            if (replaceId && this.isAddedReplaceMatchingSizeCallbacks.has(replaceId)) {
                const resolve = this.isAddedReplaceMatchingSizeCallbacks.get(replaceId);
                this.isAddedReplaceMatchingSizeCallbacks.delete(replaceId);
                if (!resolve) return;
                const placeholder = this.placeholders.get(replaceId);
                if (!placeholder) {
                    resolve(false);
                    return;
                }
                this.placeholders.delete(replaceId);
                resolve(this.areRectsSameSize(placeholder, boundingClientRect));
                return;
            }
        };
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
    }
    shouldHandleAddedNode(el) {
        return el.dataset?.[$8aa0ab1e2555bba9$var$placeholderDataKey] || el.dataset?.[$8aa0ab1e2555bba9$var$replaceDataKey];
    }
    handleAddedNode(el) {
        // If it placeholder does not already exist, add it to the map
        const placeholderId = el.dataset?.[$8aa0ab1e2555bba9$var$placeholderDataKey];
        if (placeholderId) return this.handleAddedPlaceholderNode(el, placeholderId);
        const replaceId = el.dataset?.[$8aa0ab1e2555bba9$var$replaceDataKey];
        if (replaceId) return this.handleAddedReplaceNode(el, replaceId);
        return Promise.resolve({
            shouldIgnore: false
        });
    }
    clear() {
        this.placeholders.clear();
        this.intersectionObserver.disconnect();
    }
    handleAddedPlaceholderNode(el, placeholderId) {
        if (this.isExistingPlaceholder(placeholderId)) return this.isAddedPlaceholderMatchingSize(el, placeholderId).then((isMatching)=>({
                shouldIgnore: isMatching
            }));
        return this.registerPlaceholder(el, placeholderId).then(()=>({
                shouldIgnore: false
            }));
    }
    handleAddedReplaceNode(el, placeholderId) {
        if (this.isExistingPlaceholder(placeholderId)) return this.isAddedReplaceMatchingSize(el, placeholderId).then((isMatching)=>({
                shouldIgnore: isMatching
            }));
        return Promise.resolve({
            shouldIgnore: false
        });
    }
    isExistingPlaceholder(placeholderId) {
        return this.placeholders.has(placeholderId);
    }
    registerPlaceholder(el, placeholderId) {
        return this.getSize(el, placeholderId).then((size)=>{
            this.placeholders.set(placeholderId, size);
        });
    }
    getSize(el, placeholderId) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(placeholderId, resolve);
            this.intersectionObserver.observe(el);
        });
    }
    isAddedPlaceholderMatchingSize(el, placeholderId) {
        return new Promise((resolve)=>{
            this.isAddedPlaceholderMatchingSizeCallbacks.set(placeholderId, resolve);
            this.intersectionObserver.observe(el);
        });
    }
    isAddedReplaceMatchingSize(el, placeholderId) {
        return new Promise((resolve)=>{
            this.isAddedReplaceMatchingSizeCallbacks.set(placeholderId, resolve);
            this.intersectionObserver.observe(el);
        });
    }
    areRectsSameSize(a, b) {
        return Math.abs(a.width - b.width) < 1 && Math.abs(a.height - b.height) < 1;
    }
}

});

parcelRegister("flJpT", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $8867921f8b6036b7$export$c0102f1a1198d10f);
const $8867921f8b6036b7$var$EQUALITY_THRESHOLD = 0.1;
const $8867921f8b6036b7$var$ANCESTOR_LOOKUP_LIMIT = 10;
class $8867921f8b6036b7$export$c0102f1a1198d10f {
    constructor(){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = target.dataset.ssrPlaceholder || '';
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = target.getBoundingClientRect();
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = target.dataset.ssrPlaceholderReplace || '';
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = target.getBoundingClientRect();
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        if (window.document) try {
            const existingElements = document.querySelectorAll('[data-ssr-placeholder]');
            existingElements.forEach((el)=>{
                if (el instanceof HTMLElement && el?.dataset?.ssrPlaceholder) {
                    let width = -1;
                    let height = -1;
                    let x = -1;
                    let y = -1;
                    const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[el.dataset.ssrPlaceholder];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    this.intersectionObserver.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    isPlaceholder(element) {
        return Boolean(element.dataset.ssrPlaceholder);
    }
    isPlaceholderReplacement(element) {
        return Boolean(element.dataset.ssrPlaceholderReplace);
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $8867921f8b6036b7$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = el.dataset.ssrPlaceholder || '';
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver.observe(el);
            }
        });
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(el.dataset.ssrPlaceholder || '', resolve);
            this.intersectionObserver.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = el.dataset.ssrPlaceholderReplace || '';
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver.observe(el);
            }
        });
    }
    hasSameSizePosition(rect, boundingClientRect) {
        return rect && Math.abs(rect.x - boundingClientRect.x) < $8867921f8b6036b7$var$EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < $8867921f8b6036b7$var$EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < $8867921f8b6036b7$var$EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < $8867921f8b6036b7$var$EQUALITY_THRESHOLD || false;
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});


parcelRegister("joHOM", function(module, exports) {

$parcel$export(module.exports, "getRevisions", () => $661e71f007ef70c7$export$3a6bcaa2795a58f8);

var $fxqmJ = parcelRequire("fxqmJ");

var $2YVdr = parcelRequire("2YVdr");
const $661e71f007ef70c7$var$Revisions = [
    {
        name: 'fy25.01',
        classifier: (0, $fxqmJ.revFY25_01Classifier)
    },
    {
        name: 'fy25.02',
        classifier: (0, $2YVdr.revFY25_02Classifier)
    }
];
let $661e71f007ef70c7$var$revisionResultCache = null;
const $661e71f007ef70c7$export$3a6bcaa2795a58f8 = ()=>{
    if ($661e71f007ef70c7$var$revisionResultCache !== null) return $661e71f007ef70c7$var$revisionResultCache;
    $661e71f007ef70c7$var$revisionResultCache = [
        ...$661e71f007ef70c7$var$Revisions
    ];
    return $661e71f007ef70c7$var$revisionResultCache;
};

});
parcelRegister("fxqmJ", function(module, exports) {

$parcel$export(module.exports, "FY25_01Classifier", () => $f82147c2ef7ad89b$export$1287fed0f253eee5);
$parcel$export(module.exports, "revFY25_01Classifier", () => $f82147c2ef7ad89b$export$d822caadc9ee5453);

var $VSDnB = parcelRequire("VSDnB");

var $jPXob = parcelRequire("jPXob");
const $f82147c2ef7ad89b$var$legacyIgnoreReasons = [
    'image',
    'ssr-hydration',
    'editor-lazy-node-view',
    'editor-container-mutation'
];
class $f82147c2ef7ad89b$export$1287fed0f253eee5 extends (0, $jPXob.ViewportUpdateClassifier) {
    VCCalculationMethod({ VCParts: VCParts, entries: entries, totalPainted: totalPainted, componentsLog: componentsLog }) {
        const VC = {};
        const VCBox = {};
        entries.reduce((acc = 0, v)=>{
            let VCRatio = v[1] / totalPainted + acc;
            const time = v[0];
            if ((0, $VSDnB.fg)('platform_ufo_fix_vc_observer_rounding_error')) {
                // @todo apply fix to include small changes into accumulator
                const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                const preciseAccRatio = Math.round(acc * 100);
                VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            }
            VCParts.forEach((value)=>{
                if ((VC[value] === null || VC[value] === undefined) && VCRatio >= value / 100) {
                    VC[value] = time;
                    VCBox[value] = new Set();
                    componentsLog[time]?.forEach((v)=>VCBox[value]?.add(v.targetName));
                }
            });
            return VCRatio;
        }, 0);
        return {
            VC: VC,
            VCBox: VCBox
        };
    }
    constructor(){
        super(), this.revision = 'fy25.01', this.types = [
            'html',
            'text'
        ], this.filters = [
            {
                name: 'default-ignore-reasons',
                filter: ({ type: type, ignoreReason: ignoreReason })=>{
                    return !ignoreReason || !$f82147c2ef7ad89b$var$legacyIgnoreReasons.includes(ignoreReason);
                }
            }
        ];
        this.mergeConfig();
    }
}
const $f82147c2ef7ad89b$export$d822caadc9ee5453 = new $f82147c2ef7ad89b$export$1287fed0f253eee5();

});
parcelRegister("jPXob", function(module, exports) {

$parcel$export(module.exports, "ViewportUpdateClassifier", () => $503d28df6b954812$export$66a5f74f04eab7df);
class $503d28df6b954812$export$66a5f74f04eab7df {
    VCCalculationMethod(_) {
        return {
            VC: {},
            VCBox: {}
        };
    }
    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
    filterComponentsLog({ componentsLog: componentsLog }) {
        return componentsLog;
    }
    mergeConfig() {
        this.__combinedTypes = [
            ...this.types,
            ...this?.__combinedTypes || []
        ];
        const previousFilters = this.removedFilters.length === 0 ? this.__combinedFilters : this.__combinedFilters.filter((filter)=>!this.removedFilters.includes(filter.name));
        this.__combinedFilters = [
            ...this.filters,
            ...previousFilters
        ];
    }
    classifyUpdate({ element: element, type: type, tags: tags, ignoreReason: ignoreReason }) {
        if (!this.__combinedTypes.includes(type)) return false;
        return this.__combinedFilters.every(({ filter: filter, name: name })=>{
            return filter({
                type: type,
                tags: tags,
                ignoreReason: ignoreReason
            });
        });
    }
    constructor(){
        this.types = [];
        this.filters = [];
        this.removedFilters = [];
        this.__combinedTypes = [];
        this.__combinedFilters = [];
    }
}

});


parcelRegister("2YVdr", function(module, exports) {

$parcel$export(module.exports, "revFY25_02Classifier", () => $de8b48bc6201ce8c$export$624b2c3760a5ab41);

var $VSDnB = parcelRequire("VSDnB");

var $fxqmJ = parcelRequire("fxqmJ");
class $de8b48bc6201ce8c$export$d8e8ccb82df07b7c extends (0, $fxqmJ.FY25_01Classifier) {
    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
    filterComponentsLog({ componentsLog: componentsLog, ttai: ttai }) {
        let _componentsLog = {};
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('ufo-remove-vc-component-observations-after-ttai')) Object.entries(componentsLog).forEach(([_timestamp, value])=>{
            const timestamp = Number(_timestamp);
            if (ttai > timestamp) _componentsLog[timestamp] = value;
        });
        else _componentsLog = {
            ...componentsLog
        };
        return _componentsLog;
    }
    constructor(){
        super(), this.revision = 'fy25.02', this.types = [
            'attr'
        ], this.filters = [
            {
                name: 'not-visible',
                filter: ({ type: type, ignoreReason: ignoreReason })=>{
                    return !ignoreReason?.includes('not-visible');
                }
            }
        ], this.removedFilters = [];
        this.mergeConfig();
    }
}
const $de8b48bc6201ce8c$export$624b2c3760a5ab41 = new $de8b48bc6201ce8c$export$d8e8ccb82df07b7c();

});




parcelRegister("a0hd6", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", () => $fa52152d064ec067$export$b3bc47985717b49e);

var $VSDnB = parcelRequire("VSDnB");

var $h2sI1 = parcelRequire("h2sI1");

var $cmAu5 = parcelRequire("cmAu5");
class $fa52152d064ec067$var$VCObserverWrapper {
    constructor(opts = {}){
        this.oldVCObserver = new (0, $h2sI1.VCObserver)(opts);
        this.newVCObserver = null;
        const isNewVCObserverEnabled = (0, $VSDnB.fg)('platform_ufo_vc_observer_new');
        if (isNewVCObserverEnabled) this.newVCObserver = new (0, $cmAu5.default)({
            selectorConfig: opts.selectorConfig
        });
    }
    start(startArg) {
        this.oldVCObserver?.start(startArg);
        this.newVCObserver?.start();
    }
    stop() {
        this.oldVCObserver?.stop();
        this.newVCObserver?.stop();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const oldResult = await this.oldVCObserver?.getVCResult(param);
        const newResult = await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: (0, $VSDnB.fg)('platform_ufo_vc_ttai_on_paint') ? param.stop : performance.now()
        });
        if (oldResult && !newResult) return oldResult;
        return {
            ...oldResult ?? {},
            'ufo:vc:rev': [
                ...oldResult?.['ufo:vc:rev'] ?? [],
                ...newResult ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
}
const $fa52152d064ec067$export$b3bc47985717b49e = (opts = {})=>{
    if (!globalThis.__vcObserver) globalThis.__vcObserver = new $fa52152d064ec067$var$VCObserverWrapper(opts);
    return globalThis.__vcObserver;
};

});
parcelRegister("cmAu5", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a174c05d81ba02$export$2e2bcd8739ae039);

var $7JcwI = parcelRequire("7JcwI");

var $ijRKb = parcelRequire("ijRKb");

var $9XWZI = parcelRequire("9XWZI");

var $1OMZa = parcelRequire("1OMZa");

var $ePAog = parcelRequire("ePAog");
const $56a174c05d81ba02$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $56a174c05d81ba02$export$2e2bcd8739ae039 {
    constructor(config){
        this.startTime = 0;
        this.viewportObserver = null;
        this.windowEventObserver = null;
        this.entriesTimeline = new (0, $7JcwI.default)();
        this.selectorConfig = config.selectorConfig ?? $56a174c05d81ba02$var$DEFAULT_SELECTOR_CONFIG;
        this.viewportObserver = new (0, $1OMZa.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                this.entriesTimeline.push({
                    time: time,
                    type: type,
                    data: {
                        elementName: elementName,
                        rect: rect,
                        previousRect: previousRect,
                        visible: visible,
                        attributeName: mutationData?.attributeName
                    }
                });
            }
        });
        this.windowEventObserver = new (0, $ePAog.default)({
            onEvent: ({ time: time, type: type })=>{
                this.entriesTimeline.push({
                    time: time,
                    type: 'window:event',
                    data: {
                        eventType: type
                    }
                });
            }
        });
    }
    start() {
        this.viewportObserver?.start();
        this.windowEventObserver?.start();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
    }
    async getVCResult(param) {
        const { start: start, stop: stop } = param;
        const results = [];
        const calculator_fy25_03 = new (0, $9XWZI.default)();
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries
        });
        if (fy25_03) results.push(fy25_03);
        return results;
    }
    getElementName(element) {
        return (0, $ijRKb.default)(this.selectorConfig, element);
    }
}

});
parcelRegister("7JcwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $eddbcb024948b44d$export$2e2bcd8739ae039);
class $eddbcb024948b44d$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
        this.unorderedEntries = [];
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("ijRKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41a358eae106edf$export$2e2bcd8739ae039);
const $c41a358eae106edf$var$nameCache = new WeakMap();
function $c41a358eae106edf$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${encodeURIComponent(attrValue)}"]`;
}
function $c41a358eae106edf$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $c41a358eae106edf$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    while(currentElement && currentElement.localName !== 'body'){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id) selectorPart += `#${encodeURIComponent(currentElement.id)}`;
        else if (selectorConfig.dataVC) selectorPart += $c41a358eae106edf$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $c41a358eae106edf$var$getAttributeSelector(currentElement, 'data-testid') || $c41a358eae106edf$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $c41a358eae106edf$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).map(encodeURIComponent).join('.');
            if (classNames) selectorPart += `.${classNames}`;
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ');
        if ($c41a358eae106edf$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
    }
    const potentialSelector = parts.join(' > ');
    if (!$c41a358eae106edf$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) {
            const siblingIndex = Array.from(parentElement.children).indexOf(element) + 1;
            return `${potentialSelector}:nth-child(${siblingIndex})`;
        }
    }
    return potentialSelector;
}
function $c41a358eae106edf$export$2e2bcd8739ae039(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $c41a358eae106edf$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $c41a358eae106edf$var$getUniqueSelector(selectorConfig, element);
    $c41a358eae106edf$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}

});

parcelRegister("9XWZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fcf1b81943b604c$export$2e2bcd8739ae039);

var $Z0DvF = parcelRequire("Z0DvF");

var $aXT4C = parcelRequire("aXT4C");
const $7fcf1b81943b604c$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $7fcf1b81943b604c$var$REVISION_NO = 'fy25.03';
const $7fcf1b81943b604c$var$CONSIDERED_ENTRY_TYPE = [
    'mutation:child-element',
    'mutation:element',
    'mutation:attribute',
    'layout-shift',
    'window:event'
];
class $7fcf1b81943b604c$export$2e2bcd8739ae039 extends (0, $Z0DvF.default) {
    constructor(){
        super($7fcf1b81943b604c$var$REVISION_NO);
    }
    isEntryIncluded(entry) {
        if (!$7fcf1b81943b604c$var$CONSIDERED_ENTRY_TYPE.includes(entry.type)) return false;
        if (entry.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName) return false;
            return true;
        }
        if ((0, $aXT4C.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    isVCClean(filteredEntries) {
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.type === 'window:event') {
                const data = entry.data;
                if ($7fcf1b81943b604c$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) return true;
            }
            return false;
        });
        return !hasAbortEvent;
    }
}

});
parcelRegister("Z0DvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $de18581208359322$export$2e2bcd8739ae039);

var $8c8Ex = parcelRequire("8c8Ex");

var $6RK1A = parcelRequire("6RK1A");

var $dF9Lu = parcelRequire("dF9Lu");
class $de18581208359322$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    async calculate({ orderedEntries: orderedEntries }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry);
        });
        const isVCClean = this.isVCClean(filteredEntries);
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false
        };
        const vcDetails = await (0, $8c8Ex.default)({
            viewport: {
                width: (0, $dF9Lu.default)(),
                height: (0, $6RK1A.default)()
            },
            orderedEntries: filteredEntries,
            percentiles: [
                25,
                50,
                75,
                80,
                85,
                90,
                95,
                98,
                99
            ]
        });
        return {
            revision: this.revisionNo,
            vcDetails: vcDetails ?? undefined,
            clean: isVCClean,
            'metric:vc90': vcDetails?.['90']?.t ?? null
        };
    }
}

});
parcelRegister("8c8Ex", function(module, exports) {

$parcel$export(module.exports, "default", () => $17901c826f2eaa4d$export$2e2bcd8739ae039);

var $2Fqls = parcelRequire("2Fqls");

var $7YUd0 = parcelRequire("7YUd0");

var $aBSWp = parcelRequire("aBSWp");
async function $17901c826f2eaa4d$export$2e2bcd8739ae039(arg) {
    const algo = 'canvas_heatmap';
    if (algo === 'canvas_heatmap') {
        const vcDetails = await (0, $2Fqls.default)(arg);
        return vcDetails;
    }
    if (algo === 'rect_sweeping') {
        const vcDetails = await (0, $aBSWp.default)(arg);
        return vcDetails;
    }
    if (algo === 'old_heatmap') {
        const vcDetails = await (0, $7YUd0.default)(arg);
        return vcDetails;
    }
    throw new Error('unexpected Error algo not chosen correctly');
}

});
parcelRegister("2Fqls", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadfe5c88ea5db2d$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $a6vME = parcelRequire("a6vME");
async function $aadfe5c88ea5db2d$export$2e2bcd8739ae039({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles }) {
    const canvas = new (0, $a6vME.ViewportCanvas)(viewport, (0, $VSDnB.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const viewportTotalPixels = viewport.width * viewport.height;
    return $aadfe5c88ea5db2d$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, viewportTotalPixels);
}
function $aadfe5c88ea5db2d$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Number(time),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    // Fill in any missing percentiles
    for (const percentile of percentiles)if (!(percentile in results)) results[`${percentile}`] = {
        t: 0,
        e: []
    };
    return results;
}

});
parcelRegister("a6vME", function(module, exports) {

$parcel$export(module.exports, "ViewportCanvas", () => $0e1e69660e38aacc$export$3e59ac9de7402fb1);

var $ctFNJ = parcelRequire("ctFNJ");
class $0e1e69660e38aacc$export$3e59ac9de7402fb1 {
    /**
	 * Creates a new ViewportCanvas instance.
	 * @param viewport - The dimensions of the viewport
	 * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
	 * @throws {Error} If canvas context cannot be obtained
	 */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        // Calculate scaled dimensions
        this.scaledWidth = Math.ceil(viewport.width * scaleFactor);
        this.scaledHeight = Math.ceil(viewport.height * scaleFactor);
        this.scaleX = this.scaledWidth / viewport.width;
        this.scaleY = this.scaledHeight / viewport.height;
        // Initialize OffscreenCanvas with scaled dimensions
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.scaledWidth;
        this.canvas.height = this.scaledHeight;
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            willReadFrequently: true,
            colorSpace: 'srgb'
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = "source-over";
        this.clear();
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
	 * Clears the entire canvas by removing all drawn content.
	 * @private
	 */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
	 * Generates a unique RGB color from an incrementing counter.
	 * Uses a 24-bit color space (16,777,216 possible colors).
	 *
	 * @private
	 * @returns A unique RGB color string
	 *
	 * @example
	 * // Example bit operations for color 0x00FF8040:
	 * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
	 * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
	 * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
	 */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $0e1e69660e38aacc$export$54591583ed0b20ce(rgbColor);
    }
    /**
	 * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
	 * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
	 *
	 * @param rect - The rectangle dimensions to draw
	 * @param timestamp - The timestamp to associate with this drawing operation
	 */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
	 * Calculates the number of pixels drawn for each timestamp.
	 * This method:
	 * 1. Reads the pixel data from the canvas
	 * 2. Counts pixels of each unique color
	 * 3. Maps colors back to their timestamps
	 * 4. Adjusts counts based on the scale factor
	 *
	 * @returns A Map containing timestamp to pixel count mappings
	 */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $0e1e69660e38aacc$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $0e1e69660e38aacc$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}
function $0e1e69660e38aacc$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $0e1e69660e38aacc$export$fafc9be44839f9c8(imageData, scaleFactor, arraySize) {
    const data = imageData.data;
    const scaleCompensation = Math.round(1 / (scaleFactor * scaleFactor));
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + scaleCompensation;
        }
        if (i % 10000 === 0) await (0, $ctFNJ.default)();
    }
    return arr;
}

});
parcelRegister("ctFNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7427e932608e9a3e$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $7427e932608e9a3e$export$2e2bcd8739ae039() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}

});



parcelRegister("7YUd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1907482eac6f531$export$2e2bcd8739ae039);

var $aXT4C = parcelRequire("aXT4C");

var $ctFNJ = parcelRequire("ctFNJ");
const $d1907482eac6f531$var$MAX_HEATMAP_SIZE = 1000;
function $d1907482eac6f531$var$createEmptyHeatmapEntry() {
    return {
        head: null,
        previousEntries: []
    };
}
function $d1907482eac6f531$var$createEmptyMap(heatmapWidth, heatmapHeight) {
    return Array.from({
        length: heatmapHeight
    }).map(()=>Array.from({
            length: heatmapWidth
        }).map($d1907482eac6f531$var$createEmptyHeatmapEntry));
}
function $d1907482eac6f531$var$isRectInside(a, b) {
    if (!a || !b) return false;
    // Check if all corners of rectangle a are within the bounds of rectangle b
    return a.left >= b.left && a.right <= b.right && a.top >= b.top && a.bottom <= b.bottom;
}
class $d1907482eac6f531$var$Heatmap {
    constructor({ viewport: viewport, heatmapSize: heatmapSize }){
        // TODO timeOrigin? do we need? for SSR??
        this.viewport = viewport;
        const safeSize = Math.min(heatmapSize, $d1907482eac6f531$var$MAX_HEATMAP_SIZE);
        if (viewport.width === 0 || viewport.height === 0) {
            this.width = safeSize;
            this.height = safeSize;
            this.scaleX = 1;
            this.scaleY = 1;
            this.heatmapAreaSize = 0;
            this.map = $d1907482eac6f531$var$createEmptyMap(safeSize, safeSize);
            return;
        }
        const aspectRatio = viewport.width / viewport.height;
        if (aspectRatio > 1) {
            // Landscape orientation
            this.width = safeSize;
            this.height = Math.round(safeSize / aspectRatio);
        } else {
            // Portrait orientation
            this.width = safeSize;
            this.height = Math.round(safeSize * aspectRatio);
        }
        this.scaleX = this.width / viewport.width;
        this.scaleY = this.height / viewport.height;
        this.heatmapAreaSize = this.width * this.height;
        this.map = $d1907482eac6f531$var$createEmptyMap(this.width, this.height);
    }
    getHeatmap() {
        return this.map;
    }
    getCell(row, col) {
        return this.map[row]?.[col];
    }
    /**
	 * Map Dom Rect to Heatmap Rect, rounded up to occupy full cell.
	 * @param rect DOM Rect
	 * @returns
	 */ mapDOMRectToHeatmap(rect) {
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        return {
            left: Math.floor(scaledX),
            right: Math.ceil(scaledX + scaledWidth),
            top: Math.floor(scaledY),
            bottom: Math.ceil(scaledY + scaledHeight)
        };
    }
    /**
	 * Calculate the ratio of a HeatmapRect compared to the full heatmap
	 *
	 * This function determines what fraction of the heatmap is covered by the given heatmap rectangle.
	 *
	 * @param rect
	 */ getRatio(rect) {
        if (this.viewport.width === 0 || this.viewport.height === 0) return 0;
        const { right: right, left: left, bottom: bottom, top: top } = rect;
        const rectWidth = right - left;
        const rectHeight = bottom - top;
        const rectArea = rectWidth * rectHeight;
        const ratio = rectArea / this.heatmapAreaSize;
        if (ratio > 1) return 1;
        return ratio;
    }
    async applyEntriesToHeatmap(entries) {
        for(let i = 0; i < entries.length; i++){
            const entry = entries[i];
            const { time: time, type: type, data: data } = entry;
            if ((0, $aXT4C.default)(data)) {
                const rect = this.mapDOMRectToHeatmap(data.rect);
                const ratio = this.getRatio(rect);
                const heatmapEntryData = {
                    time: time,
                    elementName: data.elementName,
                    ratio: ratio ?? null,
                    rect: rect,
                    source: type
                };
                const roundedTop = Math.floor(rect.top);
                const roundedBottom = Math.min(rect.bottom, this.height);
                const roundedLeft = Math.floor(rect.left);
                const roundedRight = Math.min(rect.right, this.width);
                for(let row = roundedTop; row < roundedBottom; row++)for(let col = roundedLeft; col < roundedRight; col++){
                    const cell = this.getCell(row, col);
                    if (!cell) continue;
                    const previousEntry = cell.head;
                    // When elements are added at the same time
                    // we try to keep the inner element changes as the head
                    if (previousEntry?.time === entry.time && $d1907482eac6f531$var$isRectInside(previousEntry.rect, heatmapEntryData.rect)) {
                        cell.previousEntries.push({
                            ...heatmapEntryData,
                            source: 'mutation:parent-mounted'
                        });
                        continue;
                    }
                    cell.head = {
                        ...heatmapEntryData,
                        source: heatmapEntryData.source || null
                    };
                    if (previousEntry !== null) cell.previousEntries.push(previousEntry);
                }
            }
            // Every 100 events processed
            // we give the browser the power
            // to process any other high priority task
            if (i % 100 === 0) await (0, $ctFNJ.default)();
        }
    }
    async getVCPercentMetrics(vcPercentCheckpoint) {
        const sortedCheckpoints = [
            ...vcPercentCheckpoint
        ].sort((a, b)=>a - b);
        const flattenHeatmap = this.map.flat();
        const totalCells = flattenHeatmap.length;
        const timestampMap = new Map();
        for(let i = 0; i < flattenHeatmap.length; i++){
            const cell = flattenHeatmap[i];
            const cellHead = cell.head;
            const timestamp = Math.trunc(cellHead?.time ?? 0);
            const elementName = cellHead?.elementName;
            const curr = timestampMap.get(timestamp) ?? {
                cellCount: 0,
                domElements: new Set()
            };
            curr.cellCount += 1;
            if (elementName) curr.domElements.add(elementName);
            timestampMap.set(timestamp, curr);
            // Every 10000 heatmap entries processed
            // we give the browser the power
            // to process any other high priority task
            if (i > 10000 && i % 10000 === 0) await (0, $ctFNJ.default)();
        }
        const sortedTimings = [
            ...timestampMap.keys()
        ].sort((a, b)=>a - b);
        let totalCellPainted = 0;
        const result = {};
        let domElementsBuffer = new Set();
        for(let i = 0; i < sortedTimings.length; i++){
            const timestamp = sortedTimings[i];
            const timestampInfo = timestampMap.get(timestamp);
            if (!timestampInfo) throw new Error('unexpected timestampInfo not found');
            const { cellCount: cellCount, domElements: domElements } = timestampInfo;
            totalCellPainted += cellCount;
            const currVCRatio = totalCellPainted / totalCells;
            const currVCPercent = Math.round(currVCRatio * 100);
            domElements.forEach((domElement)=>{
                domElementsBuffer.add(domElement);
            });
            let matchesAnyCheckpoints = false;
            while(sortedCheckpoints.length > 0 && currVCPercent >= sortedCheckpoints[0]){
                const checkpoint = sortedCheckpoints.shift();
                const domElements = [
                    ...domElementsBuffer
                ];
                if (!checkpoint) break;
                matchesAnyCheckpoints = true;
                result[checkpoint.toString()] = {
                    t: timestamp,
                    e: domElements
                };
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (i % 500 === 0) await (0, $ctFNJ.default)();
        }
        return result;
    }
}
async function $d1907482eac6f531$export$2e2bcd8739ae039({ orderedEntries: orderedEntries, viewport: viewport, percentiles: percentiles }) {
    const heatmap = new $d1907482eac6f531$var$Heatmap({
        viewport: viewport,
        heatmapSize: 200
    });
    await heatmap.applyEntriesToHeatmap(orderedEntries);
    const vcDetails = await heatmap.getVCPercentMetrics(percentiles);
    return vcDetails;
}

});
parcelRegister("aXT4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a3a0b9cd58731c0$export$2e2bcd8739ae039);
function $1a3a0b9cd58731c0$export$2e2bcd8739ae039(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}

});


parcelRegister("aBSWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f28caeda438a786$export$2e2bcd8739ae039);

var $aXT4C = parcelRequire("aXT4C");

var $ctFNJ = parcelRequire("ctFNJ");

var $4SPdL = parcelRequire("4SPdL");
async function $4f28caeda438a786$export$2e2bcd8739ae039({ orderedEntries: orderedEntries, viewport: viewport, percentiles: percentiles }) {
    const sortedPercentiles = [
        ...percentiles
    ].sort((a, b)=>a - b);
    const viewportArea = viewport.width * viewport.height;
    const checkpoints = {};
    let activeRects = orderedEntries.filter((e)=>(0, $aXT4C.default)(e.data)).map((e)=>e.data.rect);
    const removeActiveRect = (rectToRemove)=>{
        const index = activeRects.indexOf(rectToRemove);
        // Check if the element exists in the array
        if (index !== -1) // Remove the element at the found index
        activeRects.splice(index, 1);
    };
    let domElementsBuffer = new Set();
    for(let i = 0; i < orderedEntries.length; i++){
        const iEntry = orderedEntries[i];
        const iEntryData = iEntry.data;
        if (!(0, $aXT4C.default)(iEntryData)) continue;
        const { rect: rect, elementName: elementName } = iEntryData;
        domElementsBuffer.add(elementName);
        removeActiveRect(rect);
        const exclusionArea = (0, $4SPdL.default)(activeRects);
        const currentArea = viewportArea - exclusionArea;
        const currVCPercent = Math.round(currentArea / viewportArea * 100);
        let matchesAnyCheckpoints = false;
        while(sortedPercentiles.length > 0 && currVCPercent >= sortedPercentiles[0]){
            const checkpoint = sortedPercentiles.shift();
            const domElements = [
                ...domElementsBuffer
            ];
            if (!checkpoint) break;
            matchesAnyCheckpoints = true;
            checkpoints[checkpoint.toString()] = {
                t: iEntry.time,
                e: domElements
            };
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (i % 500 === 0) await (0, $ctFNJ.default)();
    }
    return checkpoints;
}

});
parcelRegister("4SPdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $35172c167051c304$export$2e2bcd8739ae039);
function $35172c167051c304$export$2e2bcd8739ae039(rectangles) {
    // Step 1: Create sweep line events
    const events = $35172c167051c304$var$createSweepLineEvents(rectangles);
    // Step 2: Process events to calculate total area
    const activeIntervals = new Map();
    let totalArea = 0;
    let previousX = 0;
    for (const event of events){
        // Calculate height at current x-position
        const currentHeight = $35172c167051c304$var$calculateActiveHeight(activeIntervals);
        // Add area since last x-position
        totalArea += currentHeight * (event.x - previousX);
        // Update x-position
        previousX = event.x;
        // Update active intervals
        $35172c167051c304$var$updateActiveIntervals(activeIntervals, event);
    }
    return totalArea;
}
function $35172c167051c304$var$createSweepLineEvents(rectangles) {
    const events = [];
    for (const rect of rectangles){
        // Create start and end events for each rectangle
        events.push({
            x: rect.left,
            type: 'start',
            top: rect.top,
            bottom: rect.bottom
        });
        events.push({
            x: rect.right,
            type: 'end',
            top: rect.top,
            bottom: rect.bottom
        });
    }
    // Sort events by x-coordinate (and type as tiebreaker)
    return events.sort((a, b)=>a.x === b.x ? a.type === 'end' ? 1 : -1 : a.x - b.x);
}
function $35172c167051c304$var$calculateActiveHeight(intervals) {
    if (intervals.size === 0) return 0;
    // Get all unique y-coordinates
    const coordinates = [];
    for (const [key] of intervals){
        const [start, end] = key.split(',').map(Number);
        coordinates.push(start, end);
    }
    // Sort coordinates
    const sortedCoords = [
        ...new Set(coordinates)
    ].sort((a, b)=>a - b);
    let totalHeight = 0;
    // Check each segment between consecutive coordinates
    for(let i = 0; i < sortedCoords.length; i++){
        const y1 = sortedCoords[i];
        const y2 = sortedCoords[i + 1];
        // Check if this segment is covered by any active interval
        let covered = false;
        for (const [key, count] of intervals){
            if (count <= 0) continue;
            const [start, end] = key.split(',').map(Number);
            if (start <= y1 && end >= y2) {
                covered = true;
                break;
            }
        }
        if (covered) totalHeight += y2 - y1;
    }
    return totalHeight;
}
function $35172c167051c304$var$updateActiveIntervals(intervals, event) {
    const key = `${event.top},${event.bottom}`;
    if (event.type === 'start') intervals.set(key, (intervals.get(key) || 0) + 1);
    else {
        const count = intervals.get(key) || 0;
        if (count > 1) intervals.set(key, count - 1);
        else intervals.delete(key);
    }
}

});



parcelRegister("6RK1A", function(module, exports) {

$parcel$export(module.exports, "default", () => $6076bc8255230f24$export$2e2bcd8739ae039);
function $6076bc8255230f24$export$2e2bcd8739ae039(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});

parcelRegister("dF9Lu", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f98cb8540d04a5$export$2e2bcd8739ae039);
function $50f98cb8540d04a5$export$2e2bcd8739ae039(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}

});



parcelRegister("1OMZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $924a5faf49f93f96$export$2e2bcd8739ae039);

var $1HYUt = parcelRequire("1HYUt");

var $aS5cI = parcelRequire("aS5cI");

var $4b2DW = parcelRequire("4b2DW");

var $aq5g1 = parcelRequire("aq5g1");
function $924a5faf49f93f96$var$isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-expect-error
            visibilityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}
function $924a5faf49f93f96$var$sameRectSize(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height;
}
function $924a5faf49f93f96$var$sameRectDimensions(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height && a.x === b.x && a.y === b.y;
}
class $924a5faf49f93f96$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange }){
        this.mapVisibleNodeRects = new WeakMap();
        this.intersectionObserver = (0, $aS5cI.createIntersectionObserver)({
            onEntry: ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
                const visible = $924a5faf49f93f96$var$isElementVisible(target);
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                this.mapVisibleNodeRects.set(target, rect);
                onChange({
                    time: time,
                    type: type,
                    elementRef: new WeakRef(target),
                    visible: visible,
                    rect: rect,
                    previousRect: lastElementRect,
                    mutationData: mutationData
                });
            }
        });
        this.mutationObserver = (0, $4b2DW.default)({
            onChildListMutation: ({ addedNodes: addedNodes, removedNodes: removedNodes })=>{
                const removedNodeRects = removedNodes?.map((n)=>this.mapVisibleNodeRects.get(n)) ?? [];
                addedNodes.forEach((addedNode)=>{
                    // for (const elem of addedNode.querySelectorAll('*')) {
                    // 	this.intersectionObserver?.watchAndTag(elem, 'mutation:child-element');
                    // }
                    const sameDeletedNode = removedNodes.find((n)=>n.isEqualNode(addedNode));
                    if (sameDeletedNode) {
                        this.intersectionObserver?.watchAndTag(addedNode, 'mutation:remount');
                        return;
                    }
                    if ((0, $1HYUt.isContainedWithinMediaWrapper)(addedNode)) {
                        this.intersectionObserver?.watchAndTag(addedNode, 'mutation:media');
                        return;
                    }
                    this.intersectionObserver?.watchAndTag(addedNode, ({ rect: rect })=>{
                        const wasDeleted = removedNodeRects.some((nr)=>$924a5faf49f93f96$var$sameRectDimensions(nr, rect));
                        if (wasDeleted) return 'mutation:element-replacement';
                        return 'mutation:element';
                    });
                });
            },
            onAttributeMutation: ({ target: target, attributeName: attributeName })=>{
                this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                    if ((0, $1HYUt.isContainedWithinMediaWrapper)(target)) return {
                        type: 'mutation:media',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    const lastElementRect = this.mapVisibleNodeRects.get(target);
                    if (lastElementRect && $924a5faf49f93f96$var$sameRectSize(rect, lastElementRect)) return {
                        type: 'mutation:attribute:no-layout-shift',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    return {
                        type: 'mutation:attribute',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                });
            }
        });
        this.performanceObserver = (0, $aq5g1.default)({
            onLayoutShift: ({ time: time, changedRects: changedRects })=>{
                for (const changedRect of changedRects)onChange({
                    time: time,
                    elementRef: new WeakRef(changedRect.node),
                    visible: true,
                    rect: changedRect.rect,
                    previousRect: changedRect.previousRect,
                    type: 'layout-shift'
                });
            }
        });
    }
    start() {
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore-error
            durationThreshold: 30
        });
    }
    stop() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
    }
}

});
parcelRegister("aS5cI", function(module, exports) {

$parcel$export(module.exports, "createIntersectionObserver", () => $aed46d2ac193da35$export$c3799d33e0ae80a5);
function $aed46d2ac193da35$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $aed46d2ac193da35$export$c3799d33e0ae80a5(args) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement) || !$aed46d2ac193da35$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            args.onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        args.onObserved?.({
            time: startTime,
            elements: validEntries
        });
    });
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});

parcelRegister("4b2DW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b967497fd95af45c$export$2e2bcd8739ae039);
function $b967497fd95af45c$export$2e2bcd8739ae039({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const observer = new MutationObserver((mutations)=>{
        const addedNodes = [];
        const removedNodes = [];
        const targets = [];
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if (mut.type === 'attributes') {
                onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown'
                });
                continue;
            } else if (mut.type === 'childList') {
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) addedNodes.push(node);
                });
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) removedNodes.push(node);
                });
            }
            targets.push(mut.target);
        }
        onChildListMutation({
            addedNodes: addedNodes,
            removedNodes: removedNodes
        });
        onMutationFinished?.({
            targets: targets
        });
    });
    return observer;
}

});

parcelRegister("aq5g1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f4470e0f19f214$export$2e2bcd8739ae039);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $a0f4470e0f19f214$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $a0f4470e0f19f214$export$2e2bcd8739ae039(args) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const { onLayoutShift: onLayoutShift } = args;
    const observer = new PerformanceObserver((entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift') {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $a0f4470e0f19f214$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $a0f4470e0f19f214$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    });
    return observer;
}

});


parcelRegister("ePAog", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e5589b99c2bea9$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");
class $91e5589b99c2bea9$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $cBeZP.bind)(window, {
            type: type,
            listener: (event)=>{
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});



parcelRegister("45w2S", function(module, exports) {

$parcel$export(module.exports, "interactions", () => $689164667c3e99b9$export$cc97b17ef9aeb088);
const $689164667c3e99b9$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("bJCAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $34ef004db30d88d6$export$2e2bcd8739ae039);

var $fe1wc = parcelRequire("fe1wc");

var $h2sI1 = parcelRequire("h2sI1");
const $34ef004db30d88d6$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $34ef004db30d88d6$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $h2sI1.VCObserver)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
	 * Set the VC result as per the last interaction
	 * Used to compare diffs of VC updates vs post interaction VC observer
	 * @param result - VC result as calculated by UFO create payload
	 */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
	 * Set the fn that would be invoked to process / send the observation data
	 */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
	 * Reset state of the log
	 */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
	 * Check if there is data in the log
	 */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
	 * Send the log if there is data
	 */ async sendPostInteractionLog() {
        if (!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) this.vcObserver?.stop();
            return;
        }
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            prefix: 'ufo',
            ...this.vcObserverSSRConfig
        });
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
            postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
        });
        this.reset();
    }
    /**
	 * This fn should be invoked when an interaction has finished
	 * Basic details about the finished interaction will be recorded
	 * A timeout will be setup to send the post interaction observation after some time.
	 */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, experimentalTTAI: experimentalTTAI, experimentalVC90: experimentalVC90 }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            experimentalTTAI: experimentalTTAI,
            experimentalVC90: experimentalVC90
        };
        const timeout = (0, $fe1wc.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $34ef004db30d88d6$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
	 * This fn should be invoked when a React render happens after interaction has finished
	 */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    constructor(){
        /**
	 * Basic info about interaction that has just finished
	 */ this.lastInteractionFinish = null;
        /**
	 * Array of observed react render timings
	 */ this.reactProfilerTimings = [];
        /**
	 * Store the scheduled sink timeout Id so that it can be cancelled when needed
	 */ this.sinkTimeoutId = null;
        /**
	 * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
	 */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
	 * Handler function to process / send the observation data
	 */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("kRatU", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("9PqPj")).default);

var $9PqPj = parcelRequire("9PqPj");

var $bECnN = parcelRequire("bECnN");

});
parcelRegister("9PqPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0fec51a21ec5a78$export$2e2bcd8739ae039);

var $bECnN = parcelRequire("bECnN");

var $jSerw = parcelRequire("jSerw");

var $furey = parcelRequire("furey");

var $bo3Uw = parcelRequire("bo3Uw");
class $b0fec51a21ec5a78$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $jSerw.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $jSerw.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $bo3Uw.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $furey.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $bECnN.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $bECnN.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $bECnN.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $jSerw.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $jSerw.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $bECnN.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $jSerw.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $bECnN.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("bECnN", function(module, exports) {

$parcel$export(module.exports, "ExposureTriggerReason", () => $0ceddc1f24830f6f$export$2c20ffeba7dbc068);
var $0ceddc1f24830f6f$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("jSerw", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $8918e231cb30b34e$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $8918e231cb30b34e$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $8918e231cb30b34e$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $8918e231cb30b34e$export$891630e169ca14a4);
const $8918e231cb30b34e$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $8918e231cb30b34e$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $8918e231cb30b34e$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $8918e231cb30b34e$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $8918e231cb30b34e$var$validateFlag = (flagKey, flag)=>{
    if ($8918e231cb30b34e$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $8918e231cb30b34e$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$8918e231cb30b34e$var$validateFlag(key, flags[key]));
};

});

parcelRegister("furey", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7101c4822b75c1$export$2e2bcd8739ae039);
const $7c7101c4822b75c1$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $7c7101c4822b75c1$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $7c7101c4822b75c1$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("bo3Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7d7cbcbf7ac517$export$2e2bcd8739ae039);

var $bECnN = parcelRequire("bECnN");
class $9b7d7cbcbf7ac517$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $bECnN.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $bECnN.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});



parcelRegister("buAWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2554ad786286b0a$export$2e2bcd8739ae039);

var $bXrHm = parcelRequire("bXrHm");

var $iZhen = parcelRequire("iZhen");

var $hI2MJ = parcelRequire("hI2MJ");

var $kljjv = parcelRequire("kljjv");

var $fNiuW = parcelRequire("fNiuW");

var $76MW0 = parcelRequire("76MW0");

var $ibWJJ = parcelRequire("ibWJJ");

var $fHcqB = parcelRequire("fHcqB");

var $cxufL = parcelRequire("cxufL");

var $2xy0c = parcelRequire("2xy0c");

var $cT8IU = parcelRequire("cT8IU");

var $4NslB = parcelRequire("4NslB");

var $lbyTT = parcelRequire("lbyTT");

var $5cwz8 = parcelRequire("5cwz8");

var $3ErS8 = parcelRequire("3ErS8");

var $fOR5Q = parcelRequire("fOR5Q");

var $edTAR = parcelRequire("edTAR");

var $d7bc1 = parcelRequire("d7bc1");

var $j7FCN = parcelRequire("j7FCN");

var $iNSWY = parcelRequire("iNSWY");
const $a2554ad786286b0a$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $a2554ad786286b0a$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $a2554ad786286b0a$export$48361b6ed38f1b0 {
    static callback(response) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) {
            if (response.getEventResponseList().length === 0) // eslint-disable-next-line no-console
            console.debug('Event(s) submitted to GASv3');
            else response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else if (statusCode === 400 || statusCode === 404) {
            // eslint-disable-next-line no-console
            console.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            // eslint-disable-next-line no-console
            console.info('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $a2554ad786286b0a$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._endsWith = (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1;
        this._changeInternalUserId = (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $kljjv.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $kljjv.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($a2554ad786286b0a$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($a2554ad786286b0a$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($a2554ad786286b0a$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $iZhen.eventType).UI:
                case (0, $iZhen.eventType).OPERATIONAL:
                case (0, $iZhen.eventType).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $iZhen.eventType).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $iZhen.eventType).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
   * Calling this function in the intialisation of the client in product
   * captures specified 'origin tracing' URL params and fires a single origin landed event
   * <p>
   * This function expects a mapping between the keys for any URL parameters
   *  that should be captured and removed for origin tracing
   * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
   * Each handler function should return an object with two items
   * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
   * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
   *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
   * </p>
   * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
   * e.g. from a share or email
   *
   * An example calling this function using an external decoding library, with taskSessionId specified to persist
   * analyticsWebClient.setOriginTracingHandlers({
        atlOrigin: encodedOrigin => {
            const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
            return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
        },
    });
   *
   * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
   * @this {AnalyticsWebClient}
   */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $iZhen.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $iZhen.isType)((0, $iZhen.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $iZhen.objectValues)((0, $iZhen.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $ibWJJ.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $iZhen.isType)((0, $iZhen.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $iZhen.objectValues)((0, $iZhen.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $iZhen.isType)((0, $iZhen.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $iZhen.objectValues)((0, $iZhen.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $iZhen.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
	 * @deprecated
	 * please use {@link sendScreenEvent instead)
	 */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
	 * send screen event
	 * @param event The event / For retrocompatibility event name is still supported here.
	 * @param callback
	 * @param attributes. Deprecated, will get ignored if using an event object as first param.
	 */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $ibWJJ.validateScreenEvent)(screenName);
            (0, $ibWJJ.validateContainers)(screenContainers);
            const builtEvent = (0, $fNiuW.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $j7FCN.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $ibWJJ.validateTrackEvent)(event);
            const builtEvent = (0, $fNiuW.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $iZhen.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $fNiuW.buildActionName)(event), builtEvent, this._context, (0, $j7FCN.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $ibWJJ.validateUIEvent)(event);
            const builtEvent = (0, $fNiuW.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $iZhen.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $fNiuW.buildActionName)(event), builtEvent, this._context, (0, $j7FCN.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $ibWJJ.validateOperationalEvent)(event);
            const builtEvent = (0, $fNiuW.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $iZhen.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $fNiuW.buildActionName)(event), builtEvent, this._context, (0, $j7FCN.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $edTAR.default)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $iZhen.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $iZhen.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $iZhen.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $iZhen.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $iZhen.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $iZhen.objectValues)((0, $iZhen.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this.eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $iZhen.isType)((0, $iZhen.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $iZhen.objectValues)((0, $iZhen.envType))}]`);
        if (productInfo.perimeter && !(0, $iZhen.isType)((0, $iZhen.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $iZhen.objectValues)((0, $iZhen.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $iZhen.originType).WEB;
        else if (!(0, $iZhen.isType)((0, $iZhen.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $iZhen.objectValues)((0, $iZhen.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $iZhen.originType).WEB ? (0, $iZhen.platformType).WEB : (0, $iZhen.platformType).DESKTOP;
        else (0, $ibWJJ.validatePlatform)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $fNiuW.buildContext)(this._productInfo);
        this._safeSessionStorage = new (0, $lbyTT.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $cT8IU.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $iNSWY.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $fHcqB.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $a2554ad786286b0a$export$48361b6ed38f1b0.callback
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $2xy0c.default)();
        this._tabTracking = new (0, $5cwz8.default)();
        this._sessionTracking = new (0, $4NslB.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $3ErS8.default)();
        this.originTracing = new (0, $cxufL.default)();
        // Init Apdex
        this._apdexEvent = new (0, $hI2MJ.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $d7bc1.defaultHistoryReplaceFn);
        this.eventDelayQueue = new (0, $76MW0.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $fOR5Q.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
}

});
parcelRegister("iZhen", function(module, exports) {

$parcel$export(module.exports, "envType", () => $cc3cc1fbdc8ce7b5$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $cc3cc1fbdc8ce7b5$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $cc3cc1fbdc8ce7b5$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $cc3cc1fbdc8ce7b5$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $cc3cc1fbdc8ce7b5$export$496f06ac2a964da2);
$parcel$export(module.exports, "userType", () => $cc3cc1fbdc8ce7b5$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $cc3cc1fbdc8ce7b5$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $cc3cc1fbdc8ce7b5$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $cc3cc1fbdc8ce7b5$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $cc3cc1fbdc8ce7b5$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $cc3cc1fbdc8ce7b5$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $cc3cc1fbdc8ce7b5$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $cc3cc1fbdc8ce7b5$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $cc3cc1fbdc8ce7b5$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $cc3cc1fbdc8ce7b5$export$e73680b18d9b7c6e);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $cc3cc1fbdc8ce7b5$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $cc3cc1fbdc8ce7b5$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $cc3cc1fbdc8ce7b5$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $cc3cc1fbdc8ce7b5$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $cc3cc1fbdc8ce7b5$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $cc3cc1fbdc8ce7b5$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $cc3cc1fbdc8ce7b5$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $cc3cc1fbdc8ce7b5$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $cc3cc1fbdc8ce7b5$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $cc3cc1fbdc8ce7b5$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $cc3cc1fbdc8ce7b5$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $cc3cc1fbdc8ce7b5$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $cc3cc1fbdc8ce7b5$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $cc3cc1fbdc8ce7b5$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $cc3cc1fbdc8ce7b5$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $cc3cc1fbdc8ce7b5$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("hI2MJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $14beea5fd4f9cf3d$export$2e2bcd8739ae039);

var $iZhen = parcelRequire("iZhen");

var $2xy0c = parcelRequire("2xy0c");

var $acAer = parcelRequire("acAer");
class $14beea5fd4f9cf3d$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $iZhen.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
		 * For initialLoad type:
		 * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
		 *
		 * For transition type:
		 * 1. active status is tracked in active events map (_isActiveEvents)
		 *
		 * For any type, if startTime or stopTime is specified:
		 * 1. If currently active (!_isHidden)
		 */ if (event.type === (0, $iZhen.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $iZhen.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $iZhen.isType)((0, $iZhen.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
		 * For a transition, if the startTime was not specified,
		 * the start event should have been present.
		 */ if (!event.startTime && event.type === (0, $iZhen.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $2xy0c.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $acAer.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("2xy0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e5fbd7ed6f3ccee$export$2e2bcd8739ae039);
class $3e5fbd7ed6f3ccee$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("acAer", function(module, exports) {

$parcel$export(module.exports, "default", () => $73261f1aa6ec2e2d$export$2e2bcd8739ae039);
class $73261f1aa6ec2e2d$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("kljjv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa7c27f9f910a27$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $4aa7c27f9f910a27$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $4aa7c27f9f910a27$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($4aa7c27f9f910a27$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("fNiuW", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", () => $f88fb9a422872384$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $f88fb9a422872384$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $f88fb9a422872384$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $f88fb9a422872384$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $f88fb9a422872384$export$7bf451af4a8e3dd9);

var $iZhen = parcelRequire("iZhen");

var $eB7xz = parcelRequire("eB7xz");
const $f88fb9a422872384$var$libraryVersion = "0.0.0-use.local";
function $f88fb9a422872384$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $f88fb9a422872384$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $f88fb9a422872384$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $f88fb9a422872384$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $f88fb9a422872384$var$buildAliases(aliases) {
    if ($f88fb9a422872384$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $f88fb9a422872384$var$buildGroups(groups) {
    if ($f88fb9a422872384$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $f88fb9a422872384$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $f88fb9a422872384$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $f88fb9a422872384$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $f88fb9a422872384$var$getProductField(productInfo.env, overrides.env);
    const product = $f88fb9a422872384$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $f88fb9a422872384$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $f88fb9a422872384$var$getProductField(productInfo.version, overrides.version);
    const origin = $f88fb9a422872384$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $f88fb9a422872384$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $f88fb9a422872384$var$isNotEmptyObject(obj) {
    return (0, $eB7xz.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $f88fb9a422872384$var$buildAttributesWithName(name, attrObject) {
    return $f88fb9a422872384$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $f88fb9a422872384$var$buildAttributes(attributes) {
    return $f88fb9a422872384$var$buildAttributesWithName('attributes', attributes);
}
function $f88fb9a422872384$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $f88fb9a422872384$export$f045f238d77c002a(containers) {
    if ($f88fb9a422872384$var$isNotEmptyObject(containers)) {
        const validContainers = $f88fb9a422872384$export$3f5115a568819c1a(containers);
        return $f88fb9a422872384$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $f88fb9a422872384$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$f88fb9a422872384$export$f045f238d77c002a(event.containers)
    };
}
function $f88fb9a422872384$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $f88fb9a422872384$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $f88fb9a422872384$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $f88fb9a422872384$var$buildProductFields(productInfo);
    const tenantFields = $f88fb9a422872384$var$buildTenantFields(tenantInfo);
    const userFields = $f88fb9a422872384$var$buildUserFields(userInfo);
    const orgFields = $f88fb9a422872384$var$buildOrgFields(orgInfo);
    const workspaceFields = $f88fb9a422872384$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $iZhen.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$f88fb9a422872384$var$buildAttributes(attributes),
        ...$f88fb9a422872384$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$f88fb9a422872384$export$f045f238d77c002a(containers),
        ...$f88fb9a422872384$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$f88fb9a422872384$var$buildAliases(aliases),
        ...$f88fb9a422872384$var$buildGroups(groups)
    };
}
function $f88fb9a422872384$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $f88fb9a422872384$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $f88fb9a422872384$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $f88fb9a422872384$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $f88fb9a422872384$var$libraryVersion
            },
            validationMode: $f88fb9a422872384$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $f88fb9a422872384$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $f88fb9a422872384$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $f88fb9a422872384$var$buildProductFields(productInfo, $f88fb9a422872384$export$e3d99b4bfec06f6e(event));
    const tenantFields = $f88fb9a422872384$var$buildTenantFields(tenantInfo);
    const orgFields = $f88fb9a422872384$var$buildOrgFields(orgInfo);
    const workspaceFields = $f88fb9a422872384$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $f88fb9a422872384$var$buildUserFields(userInfo);
    const actionFields = $f88fb9a422872384$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$f88fb9a422872384$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$f88fb9a422872384$var$buildAliases(aliases),
        ...$f88fb9a422872384$var$buildGroups(groups)
    };
}

});
parcelRegister("eB7xz", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $e2842dac7ef4c0ca$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $e2842dac7ef4c0ca$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $e2842dac7ef4c0ca$var$isObjectObject(o) {
    return $e2842dac7ef4c0ca$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $e2842dac7ef4c0ca$export$53b83ca8eaab0383(o) {
    if ($e2842dac7ef4c0ca$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($e2842dac7ef4c0ca$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("76MW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4995e34560b65b19$export$2e2bcd8739ae039);


var $rwsom = parcelRequire("rwsom");

var $fqOJ4 = parcelRequire("fqOJ4");
class $4995e34560b65b19$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $b2e0d12d54fddedd$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $b2e0d12d54fddedd$export$8575e30be0feb909)) : (0, $b2e0d12d54fddedd$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $fqOJ4.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $fqOJ4.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $rwsom.default)(fireDelayedEvent, compressors);
    }
}

});
const $b2e0d12d54fddedd$export$cf090d5281b5ae06 = 10000;
const $b2e0d12d54fddedd$export$8575e30be0feb909 = 30000;

parcelRegister("rwsom", function(module, exports) {

$parcel$export(module.exports, "default", () => $471ee136644d53ae$export$2e2bcd8739ae039);

var $fNiuW = parcelRequire("fNiuW");

var $gYqa8 = parcelRequire("gYqa8");

var $59vML = parcelRequire("59vML");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $471ee136644d53ae$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $471ee136644d53ae$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $471ee136644d53ae$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $471ee136644d53ae$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $471ee136644d53ae$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $gYqa8.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $gYqa8.equals)(group.userInfo, args.userInfo) && (0, $gYqa8.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $fNiuW.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $59vML.default)(compressionRules);
    }
}

});
parcelRegister("gYqa8", function(module, exports) {

$parcel$export(module.exports, "mapKeys", () => $45e0b808c9dc848d$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $45e0b808c9dc848d$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $45e0b808c9dc848d$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $45e0b808c9dc848d$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $45e0b808c9dc848d$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $45e0b808c9dc848d$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $45e0b808c9dc848d$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $45e0b808c9dc848d$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $45e0b808c9dc848d$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $45e0b808c9dc848d$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $45e0b808c9dc848d$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $45e0b808c9dc848d$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $45e0b808c9dc848d$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$45e0b808c9dc848d$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $45e0b808c9dc848d$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});

parcelRegister("59vML", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0d93e47c2e6a6a2$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $fNiuW = parcelRequire("fNiuW");

var $gYqa8 = parcelRequire("gYqa8");

var $fYgl8 = parcelRequire("fYgl8");
class $c0d93e47c2e6a6a2$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $fNiuW.buildActionFields)(event, event.eventType);
                    contextFields = (0, $gYqa8.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $gYqa8.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $fYgl8.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("fYgl8", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", () => $ec49cb044e2703e6$export$89b3253ddfd2e6e8);

var $ibWJJ = parcelRequire("ibWJJ");

var $gYqa8 = parcelRequire("gYqa8");
class $ec49cb044e2703e6$export$89b3253ddfd2e6e8 {
    /**
	 * @callback EventPredicate
	 * @param {object} event An analytics event
	 * @returns {boolean} A flag indicating whether or not the event matches the conditions
	 */ /**
	 * @callback CompressionFunction
	 * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
	 * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
	 */ /**
	 * This constructor defines a new rule for compressing analytics events.
	 * @param {EventPredicate} predicate
	 * @param {CompressionFunction} compressFn
	 */ constructor(predicate, compressFn){
        /**
	 * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
	 * @param event
	 * @returns {boolean}
	 */ this.canCompress = (event)=>{
            try {
                return event && (0, $ibWJJ.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
	 * This function compresses as many events in the given collection as possible.<p>
	 * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
	 * appended to the end of the resulting array.
	 *
	 * @param events A collection of analytic events to compress
	 * @returns {Array.<Object>} The action fields for the resulting compressed events
	 */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $gYqa8.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $ibWJJ.validateActionEventType)(event.eventType);
                (0, $ibWJJ.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("ibWJJ", function(module, exports) {

$parcel$export(module.exports, "validateContainers", () => $e3b790962f90cf08$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $e3b790962f90cf08$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $e3b790962f90cf08$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $e3b790962f90cf08$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $e3b790962f90cf08$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $e3b790962f90cf08$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateDwellBaseEvent", () => $e3b790962f90cf08$export$39d6334da9a44984);
$parcel$export(module.exports, "validateUIEvent", () => $e3b790962f90cf08$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $e3b790962f90cf08$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $e3b790962f90cf08$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $e3b790962f90cf08$export$801b46c35394d316);

var $iZhen = parcelRequire("iZhen");

var $eB7xz = parcelRequire("eB7xz");
const $e3b790962f90cf08$var$actionEventTypes = Object.freeze([
    (0, $iZhen.eventType).OPERATIONAL,
    (0, $iZhen.eventType).TRACK,
    (0, $iZhen.eventType).UI
]);
function $e3b790962f90cf08$export$df8ff30e3c960006(container) {
    if (!(0, $eB7xz.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $e3b790962f90cf08$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$e3b790962f90cf08$export$df8ff30e3c960006(container));
}
function $e3b790962f90cf08$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $iZhen.eventType).OPERATIONAL:
        case (0, $iZhen.eventType).TRACK:
        case (0, $iZhen.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $e3b790962f90cf08$export$4a8d7476662aebcc(type) {
    if (!$e3b790962f90cf08$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$e3b790962f90cf08$var$actionEventTypes}]`);
    return true;
}
function $e3b790962f90cf08$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $e3b790962f90cf08$export$e63ea5d8477971d3(event.containers);
}
function $e3b790962f90cf08$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $e3b790962f90cf08$export$8c014fd74b0c8b99(event) {
    $e3b790962f90cf08$export$e0c121325c66ed4c(event);
}
function $e3b790962f90cf08$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $e3b790962f90cf08$export$e5bac0930c812e90(event) {
    $e3b790962f90cf08$export$e0c121325c66ed4c(event);
}
function $e3b790962f90cf08$export$1e561554275607ef(event) {
    $e3b790962f90cf08$export$e0c121325c66ed4c(event);
}
function $e3b790962f90cf08$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $iZhen.isType)((0, $iZhen.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $iZhen.objectValues)((0, $iZhen.userType))}]`);
}
function $e3b790962f90cf08$export$801b46c35394d316(productInfo) {
    if (!(0, $iZhen.isType)((0, $iZhen.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $iZhen.objectValues)((0, $iZhen.platformType))}]`);
    if (productInfo.origin === (0, $iZhen.originType).DESKTOP && !(0, $iZhen.isType)((0, $iZhen.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $iZhen.originType).WEB && !(0, $iZhen.isType)((0, $iZhen.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("fqOJ4", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $bd02218c2e0bc4f2$export$fa6e3729c21cb8f);
var $bd02218c2e0bc4f2$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("fHcqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $17fa72493f4c4ecf$export$2e2bcd8739ae039);

var $bXrHm = parcelRequire("bXrHm");

var $hFrZh = parcelRequire("hFrZh");

var $6xafg = parcelRequire("6xafg");

var $kM7SS = parcelRequire("kM7SS");

var $57AWV = parcelRequire("57AWV");

var $kG09p = parcelRequire("kG09p");

var $cdwq4 = parcelRequire("cdwq4");

var $gjgR4 = parcelRequire("gjgR4");

var $9Mu5e = parcelRequire("9Mu5e");

var $1T3jD = parcelRequire("1T3jD");
class $17fa72493f4c4ecf$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports;
    }
}
class $17fa72493f4c4ecf$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $17fa72493f4c4ecf$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $17fa72493f4c4ecf$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $17fa72493f4c4ecf$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $17fa72493f4c4ecf$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $17fa72493f4c4ecf$export$2e2bcd8739ae039 {
    constructor(options){
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount
            };
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            const localResponseCallback = this.responseCallback;
            try {
                const response = await (0, $cdwq4.sendEvents)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                if (localResponseCallback !== null && response !== null) {
                    const analyticsAPIResponse = await response.clone().json();
                    const analyticsResponse = $17fa72493f4c4ecf$var$BatchInterceptor.toAnalyticsResponse(items, null, analyticsAPIResponse);
                    localResponseCallback(analyticsResponse);
                }
            } catch (error) {
                callback(error, null);
                if (localResponseCallback !== null && error !== null) {
                    const analyticsResponse = $17fa72493f4c4ecf$var$BatchInterceptor.toAnalyticsResponse(items, error, null);
                    localResponseCallback(analyticsResponse);
                }
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $57AWV.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        };
        this.user = new (0, $9Mu5e.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $6xafg.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $hFrZh.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $gjgR4.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $gjgR4.SegmentEventTypes).TRACK,
            properties: (0, $1T3jD.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $gjgR4.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $gjgR4.SegmentEventTypes).PAGE,
            properties: (0, $1T3jD.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $gjgR4.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $gjgR4.SegmentEventTypes).IDENTIFY,
            traits: (0, $1T3jD.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $1T3jD.prepareEventProperties)(context);
        const segmentContext = (0, $1T3jD.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $kM7SS.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
}
class $17fa72493f4c4ecf$var$BatchInterceptor {
    static{
        this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    }
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $17fa72493f4c4ecf$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $17fa72493f4c4ecf$export$133650fcdde1b226(success, statusCode, (0, $kG09p.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $kG09p.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $kG09p.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $kG09p.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $17fa72493f4c4ecf$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $17fa72493f4c4ecf$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error.message !== null) {
            const match = error.message.match($17fa72493f4c4ecf$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $17fa72493f4c4ecf$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $17fa72493f4c4ecf$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $17fa72493f4c4ecf$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $17fa72493f4c4ecf$export$133650fcdde1b226(false, -1, (0, $kG09p.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("hFrZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd231604eac6729b$export$2e2bcd8739ae039);

var $jChFm = parcelRequire("jChFm");

var $bd231604eac6729b$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $jChFm.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("jChFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $39d95da3d6d99845$export$2e2bcd8739ae039);

var $k3k8u = parcelRequire("k3k8u");
var $dviIT = parcelRequire("dviIT");

var $fKoyL = parcelRequire("fKoyL");
var $42k5W = parcelRequire("42k5W");
var $2A2TO = parcelRequire("2A2TO");

var $6xafg = parcelRequire("6xafg");

var $1LZzU = parcelRequire("1LZzU");

var $38r8F = parcelRequire("38r8F");
var $aRK7K = parcelRequire("aRK7K");

var $ePz85 = parcelRequire("ePz85");
const $39d95da3d6d99845$var$ONE_MINUTE = 60000;
const $39d95da3d6d99845$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $39d95da3d6d99845$var$ONE_MINUTE,
    minRetryDelay: $39d95da3d6d99845$var$ONE_MINUTE,
    maxRetryDelay: $39d95da3d6d99845$var$ONE_MINUTE
};
const $39d95da3d6d99845$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $39d95da3d6d99845$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $42k5W.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $38r8F.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $38r8F.default)({
            ...$39d95da3d6d99845$var$LONG_POLLING_OPTIONS,
            waitInterval: $39d95da3d6d99845$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $6xafg.default)();
        this.networkStatus = new (0, $1LZzU.default)((status)=>{
            if (status === (0, $ePz85.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $2A2TO.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $ePz85.NetworkStatusEnum).OFFLINE) {
            done((0, $aRK7K.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $fKoyL.CallbackProcessingErrorName)) {
                done((0, $aRK7K.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $k3k8u.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $dviIT.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $2A2TO.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $aRK7K.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $aRK7K.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $aRK7K.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $39d95da3d6d99845$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $39d95da3d6d99845$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $39d95da3d6d99845$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $39d95da3d6d99845$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $39d95da3d6d99845$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: options?.maxItems || $39d95da3d6d99845$export$d219df4fe04c04a7.maxItems,
            maxAttempts: options?.maxAttempts || $39d95da3d6d99845$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $39d95da3d6d99845$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $39d95da3d6d99845$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("k3k8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd76f1476c4f2479$export$2e2bcd8739ae039);

var $i1Orc = parcelRequire("i1Orc");

var $eswaT = parcelRequire("eswaT");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $fd76f1476c4f2479$var$validSuffixs = Object.values((0, $i1Orc.LocalStorageKeySuffix));
var $fd76f1476c4f2479$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $fd76f1476c4f2479$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $i1Orc.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $eswaT.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("i1Orc", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", () => $393cf75dcd124cc1$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $393cf75dcd124cc1$export$8bb2c1fb2b1765a9);
var $393cf75dcd124cc1$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $393cf75dcd124cc1$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("eswaT", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", () => $43898d43f8cc5c71$export$8433d54f767cbec5);

var $i1Orc = parcelRequire("i1Orc");
const $43898d43f8cc5c71$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $i1Orc.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).ACK}`,
        [(0, $i1Orc.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).QUEUE}`,
        [(0, $i1Orc.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $i1Orc.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $i1Orc.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("dviIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23d944238e95a41$export$2e2bcd8739ae039);

var $bXrHm = parcelRequire("bXrHm");

var $i1Orc = parcelRequire("i1Orc");

var $eswaT = parcelRequire("eswaT");
const $c23d944238e95a41$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $c23d944238e95a41$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $i1Orc.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $i1Orc.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $c23d944238e95a41$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $c23d944238e95a41$var$promisedSetTimeout((0, $i1Orc.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $i1Orc.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $c23d944238e95a41$var$promisedSetTimeout((0, $i1Orc.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $i1Orc.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $c23d944238e95a41$var$reclaim(options, callback);
};
const $c23d944238e95a41$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $c23d944238e95a41$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $c23d944238e95a41$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $c23d944238e95a41$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $c23d944238e95a41$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
    const queuesToReclaim = $c23d944238e95a41$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$c23d944238e95a41$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $eswaT.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("fKoyL", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", () => $f964b3c84933dfcd$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $f964b3c84933dfcd$export$2e2bcd8739ae039);
const $f964b3c84933dfcd$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $f964b3c84933dfcd$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f964b3c84933dfcd$export$2e2bcd8739ae039.prototype);
        this.name = $f964b3c84933dfcd$export$a409c8de90e11e14;
    }
}

});

parcelRegister("42k5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0cb9a64b4ca8416$export$2e2bcd8739ae039);

var $hEfNx = parcelRequire("hEfNx");

var $2A2TO = parcelRequire("2A2TO");

var $fKoyL = parcelRequire("fKoyL");
var $f0cb9a64b4ca8416$export$2e2bcd8739ae039 = (0, $hEfNx.default);

});
parcelRegister("hEfNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1270c8838eaac632$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $5tWx3 = parcelRequire("5tWx3");
var $2oiOa = parcelRequire("2oiOa");

var $3q6DL = parcelRequire("3q6DL");

var $lGyYf = parcelRequire("lGyYf");

var $iYeWv = parcelRequire("iYeWv");
class $1270c8838eaac632$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $iYeWv.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $3q6DL.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $5tWx3.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $lGyYf.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $2oiOa.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $2A2TO.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $lGyYf.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $2A2TO.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("2A2TO", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $81274d443ac00760$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $81274d443ac00760$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $81274d443ac00760$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $81274d443ac00760$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $81274d443ac00760$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $81274d443ac00760$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $81274d443ac00760$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $81274d443ac00760$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $81274d443ac00760$export$7710d69e6f450f20);
const $81274d443ac00760$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $81274d443ac00760$export$8cad224051643259 = 'analytics-web-client';
const $81274d443ac00760$export$3d8420be07b276ab = 'analytics-resilience';
const $81274d443ac00760$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $81274d443ac00760$export$89d9c1ff8ac91862 = 'timeAdded';
const $81274d443ac00760$export$a37d385bcd713809 = 'retryAttempts';
const $81274d443ac00760$export$6d8635fed0e4b14d = 15000;
var $81274d443ac00760$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $81274d443ac00760$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("5tWx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd5196ce2007ee4$export$2e2bcd8739ae039);
const $7cd5196ce2007ee4$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $7cd5196ce2007ee4$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $7cd5196ce2007ee4$export$2e2bcd8739ae039.prototype);
        this.name = $7cd5196ce2007ee4$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("2oiOa", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $87139c67bec8a68b$export$74101021e0969375);

var $3pkX4 = parcelRequire("3pkX4");

var $fKoyL = parcelRequire("fKoyL");

var $3HwLa = parcelRequire("3HwLa");
const $87139c67bec8a68b$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $3pkX4.AbandonWriteErrorName) || errorWithName.name === (0, $fKoyL.CallbackProcessingErrorName) || errorWithName.name === (0, $3HwLa.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("3pkX4", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", () => $7d73589f9d57753a$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $7d73589f9d57753a$export$2e2bcd8739ae039);
const $7d73589f9d57753a$export$ba95206613c96b28 = 'AbandonWriteError';
class $7d73589f9d57753a$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $7d73589f9d57753a$export$2e2bcd8739ae039.prototype);
        this.name = $7d73589f9d57753a$export$ba95206613c96b28;
    }
}

});

parcelRegister("3HwLa", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", () => $bbb2589fd5297db7$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $bbb2589fd5297db7$export$2e2bcd8739ae039);
const $bbb2589fd5297db7$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $bbb2589fd5297db7$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $bbb2589fd5297db7$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("3q6DL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0125edab3e8ecd13$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $aUIZi = parcelRequire("aUIZi");

var $fKoyL = parcelRequire("fKoyL");
var $3HwLa = parcelRequire("3HwLa");
var $5tWx3 = parcelRequire("5tWx3");
var $2oiOa = parcelRequire("2oiOa");

var $cyn6r = parcelRequire("cyn6r");

var $iYeWv = parcelRequire("iYeWv");
class $0125edab3e8ecd13$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $5tWx3.default)());
                    }, (0, $2A2TO.INDEXEDDB_TIMEOUT));
                    /*
				 * The database version number can never change.
				 * An upgrade transaction is limited to only one connection to the database.
				 * Once this is done, we cannot open any connections with older versions of the schema.
				 * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
				 *
				 * Due to the nature of how AWC is used (multiple tabs that are very long lived),
				 * we will not be able to run version upgrades via indexeddb.
				 *
				 * This does not mean we cant change what is stored in the tables,
				 * this limitation just prevents us from:
				 *   - Creating new ObjectStores in this database connection, and
				 *   - Creating new indexes on our ObjectStores
				 *
				 * Any upgrades we wish to run in the future will have to create a new database,
				 * and migrate all the data from older databases.
				 *
				 * This also means any migrations we make will have to be supported until we have evidence
				 * that no events are coming from old versions of the database.
				 * This may take a long time.
				 */ const request = window.indexedDB.open((0, $2A2TO.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $2A2TO.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $2A2TO.TIME_TO_PROCESS_AFTER_INDEX), (0, $2A2TO.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $2A2TO.RETRY_INDEX), (0, $2A2TO.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $2A2TO.TIME_ADDED_INDEX), (0, $2A2TO.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $2A2TO.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $5tWx3.default)());
                    };
                    try {
                        await (0, $iYeWv.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $5tWx3.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $5tWx3.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $2A2TO.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $iYeWv.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $2A2TO.GuardPolicy).IGNORE) throw new (0, $3HwLa.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $2oiOa.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $2A2TO.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $iYeWv.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $2oiOa.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $aUIZi.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $aUIZi.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $2A2TO.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $aUIZi.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $iYeWv.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $iYeWv.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $iYeWv.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $iYeWv.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $2A2TO.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $iYeWv.requestToPromise)(request);
            await (0, $iYeWv.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $aUIZi.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $fKoyL.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $iYeWv.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $2A2TO.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $2A2TO.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $iYeWv.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $5tWx3.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
		 *
		 * This class will enforce the number of analytics events we can store in our IndexedDB object store
		 * if asked before adding items to the object store.
		 */ this.globalEventLimitGuard = new (0, $cyn6r.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $2A2TO.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("aUIZi", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", () => $d15942d15e8d8a11$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $d15942d15e8d8a11$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $d15942d15e8d8a11$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $d15942d15e8d8a11$export$1188664dfff364c8);
const $d15942d15e8d8a11$export$b6df3d334cec060f = 7;
const $d15942d15e8d8a11$export$14ef152a03a4b6ee = 60000;
const $d15942d15e8d8a11$export$da9ab7b2fd5998e8 = 10;
const $d15942d15e8d8a11$export$1188664dfff364c8 = 5000;

});

parcelRegister("cyn6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b27e310e15cd9a$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $3pkX4 = parcelRequire("3pkX4");

var $iYeWv = parcelRequire("iYeWv");
class $31b27e310e15cd9a$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
	 * This query fetches the oldest events currently stored in AWC IndexedDb object store
	 * and deletes them sequentially
	 */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $2A2TO.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $iYeWv.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
	 * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
	 *
	 * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ async insertItems(objectStore, items, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $2A2TO.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $2A2TO.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $2A2TO.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $iYeWv.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $iYeWv.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $3pkX4.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
	 * This query returns the count of items held in AWC IndexedDB object store per product.
	 */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $2A2TO.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $iYeWv.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("iYeWv", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", () => $26ace48ea3baf04e$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $26ace48ea3baf04e$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $26ace48ea3baf04e$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $26ace48ea3baf04e$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $26ace48ea3baf04e$export$342d941b6f724995);

var $bXrHm = parcelRequire("bXrHm");

var $aUIZi = parcelRequire("aUIZi");
const $26ace48ea3baf04e$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $26ace48ea3baf04e$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $aUIZi.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $aUIZi.EVENT_COUNT_LIMIT)
    });
const $26ace48ea3baf04e$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $26ace48ea3baf04e$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $26ace48ea3baf04e$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $26ace48ea3baf04e$export$2a5213bce1720b42(transaction);
};
const $26ace48ea3baf04e$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("lGyYf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d75680abe8fa453$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $aUIZi = parcelRequire("aUIZi");

var $fKoyL = parcelRequire("fKoyL");
var $3HwLa = parcelRequire("3HwLa");

var $fb8pT = parcelRequire("fb8pT");

var $iYeWv = parcelRequire("iYeWv");
class $0d75680abe8fa453$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $iYeWv.createOptionsWithDefaults)(options);
        /**
		 * This class will enforce the number of analytics events we can store in our MemoryDb
		 */ this.globalEventLimitGuard = new (0, $fb8pT.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
	 * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
	 * to removes oldest events when limit is reached.
	 */ async addItem(item, options = {}, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        if (policy === (0, $2A2TO.GuardPolicy).IGNORE) throw new (0, $3HwLa.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $iYeWv.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $iYeWv.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
	 * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
	 */ bulkAddItemWrapperType(items, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $aUIZi.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $aUIZi.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $aUIZi.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $aUIZi.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $fKoyL.default)(error);
        }
    }
    storeType() {
        return (0, $2A2TO.StoreType).MEMORY;
    }
    /**
	 * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
	 * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
	 * memoryStore much faster.
	 *
	 * @param itemsToAdd
	 */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
	 * This function checks the number of events currently in AWC MemoryDb and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("fb8pT", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe04ff9e61a40bc$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $3pkX4 = parcelRequire("3pkX4");
class $afe04ff9e61a40bc$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
	 * Unlike IndexedDb, we cannot take advantage of any index. So we are,
	 * treating the memory store as a sorted set when adding items.
	 */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $2A2TO.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $2A2TO.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $2A2TO.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $3pkX4.default)((0, $2A2TO.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("6xafg", function(module, exports) {

$parcel$export(module.exports, "default", () => $36af94c5b8051ee1$export$2e2bcd8739ae039);

var $ePz85 = parcelRequire("ePz85");
class $36af94c5b8051ee1$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $ePz85.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $36af94c5b8051ee1$var$cachedMetricsClient = null;
var $36af94c5b8051ee1$export$2e2bcd8739ae039 = ()=>{
    if (!$36af94c5b8051ee1$var$cachedMetricsClient) $36af94c5b8051ee1$var$cachedMetricsClient = new $36af94c5b8051ee1$export$4b62ee5120ab50a8();
    return $36af94c5b8051ee1$var$cachedMetricsClient;
};

});
parcelRegister("ePz85", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", () => $d9ff0adc42a1d4e7$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $d9ff0adc42a1d4e7$export$ee138fa712d11b84);
var $d9ff0adc42a1d4e7$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $d9ff0adc42a1d4e7$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("1LZzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93f5ad08a797773$export$2e2bcd8739ae039);

var $ePz85 = parcelRequire("ePz85");
class $d93f5ad08a797773$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>networkChangeCallback((0, $ePz85.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>networkChangeCallback((0, $ePz85.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $ePz85.NetworkStatusEnum).ONLINE;
        return (0, $ePz85.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("38r8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0bd718b1da09b89$export$2e2bcd8739ae039);

var $dL792 = parcelRequire("dL792");

var $aRK7K = parcelRequire("aRK7K");
const $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $c0bd718b1da09b89$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $c0bd718b1da09b89$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $aRK7K.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $aRK7K.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $dL792.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $aRK7K.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $dL792.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("dL792", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", () => $5dc3863f86ce6ade$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $5dc3863f86ce6ade$export$590a718599f8f8b3);
var $5dc3863f86ce6ade$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $5dc3863f86ce6ade$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $5dc3863f86ce6ade$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("aRK7K", function(module, exports) {

$parcel$export(module.exports, "DoneState", () => $6981e064cf5eaab0$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $6981e064cf5eaab0$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("kM7SS", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", () => $9d12fe3c013c2adb$export$c21270cab66ab290);

var $gjgR4 = parcelRequire("gjgR4");
function $9d12fe3c013c2adb$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $gjgR4.SegmentEventTypes).PAGE || item.msg.type === (0, $gjgR4.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $gjgR4.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $9d12fe3c013c2adb$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$9d12fe3c013c2adb$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("gjgR4", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", () => $46dd75a741c58f9d$export$ddf929981dc6feb3);
var $46dd75a741c58f9d$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $46dd75a741c58f9d$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $46dd75a741c58f9d$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("57AWV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $2b3e54d72b8de01e$export$9175ce0e1c95daf2);
const $2b3e54d72b8de01e$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("kG09p", function(module, exports) {

$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $e60573b530fe86c6$export$ba118f9de1e5ac63);
const $e60573b530fe86c6$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("cdwq4", function(module, exports) {

$parcel$export(module.exports, "sendEvents", () => $c518ad8962a188f2$export$8e8f0180c1b41fad);

var $8QpSo = parcelRequire("8QpSo");
const $c518ad8962a188f2$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $c518ad8962a188f2$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $c518ad8962a188f2$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $c518ad8962a188f2$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $c518ad8962a188f2$var$getCorsForUrl = (0, $8QpSo.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("9Mu5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $a63cf0c99f90bef2$export$2e2bcd8739ae039);

var $4mBKK = parcelRequire("4mBKK");

var $bXrHm = parcelRequire("bXrHm");

var $hDpfo = parcelRequire("hDpfo");
var $dITTJ = parcelRequire("dITTJ");

var $KX1VQ = parcelRequire("KX1VQ");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $a63cf0c99f90bef2$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $a63cf0c99f90bef2$var$SAFE = 'SAFE';
const $a63cf0c99f90bef2$var$UNSAFE = 'UNSAFE';
const $a63cf0c99f90bef2$var$NOT_FOUND = 'NOT_FOUND';
const $a63cf0c99f90bef2$var$COOKIE = 'COOKIE';
const $a63cf0c99f90bef2$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $a63cf0c99f90bef2$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $KX1VQ.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $dITTJ.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
		 * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
		 * If not set in localStorage, check cookies. Also set localStorage for future attempts.
		 * If not in cookies, generate a new one. Set both cookie and localStorage keys.
		 */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $hDpfo.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $hDpfo.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $a63cf0c99f90bef2$var$LOCAL_STORAGE ? this.store.getItem((0, $hDpfo.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $hDpfo.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $a63cf0c99f90bef2$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $a63cf0c99f90bef2$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
				 * Segments new Analytics-next client will store strings as strings without stringifing.
				 * The legacy Segment client and AWC always stringify and parse cookies and values.
				 * If the new Segment analytics-client stores a cookie and local storage value first, it will
				 * breaking old clients.
				 *
				 * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
				 *
				 * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
				 */ return unsafeValue;
            }
        }
        return {
            type: $a63cf0c99f90bef2$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($a63cf0c99f90bef2$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $4mBKK.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $a63cf0c99f90bef2$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $a63cf0c99f90bef2$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $a63cf0c99f90bef2$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $a63cf0c99f90bef2$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($a63cf0c99f90bef2$var$COOKIE);
        switch(cookieValue.type){
            case $a63cf0c99f90bef2$var$SAFE:
            case $a63cf0c99f90bef2$var$UNSAFE:
                this.store.setItem((0, $hDpfo.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $a63cf0c99f90bef2$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("hDpfo", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", () => $69f86d587451d1d5$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $69f86d587451d1d5$export$d4cb17942ea57c95);
var $69f86d587451d1d5$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $69f86d587451d1d5$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $69f86d587451d1d5$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $69f86d587451d1d5$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $69f86d587451d1d5$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $69f86d587451d1d5$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $69f86d587451d1d5$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $69f86d587451d1d5$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $69f86d587451d1d5$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $69f86d587451d1d5$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("dITTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7ba5c42c42aa6b$export$2e2bcd8739ae039);

var $eYli8 = parcelRequire("eYli8");

var $hDpfo = parcelRequire("hDpfo");

var $axlw3 = parcelRequire("axlw3");

var $aXi7r = parcelRequire("aXi7r");
class $7b7ba5c42c42aa6b$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $aXi7r.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))) : new (0, $axlw3.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $hDpfo.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $hDpfo.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $hDpfo.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $aXi7r.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $hDpfo.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $hDpfo.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $hDpfo.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $hDpfo.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("axlw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecfcde579a576a11$export$2e2bcd8739ae039);

var $KX1VQ = parcelRequire("KX1VQ");
class $ecfcde579a576a11$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $KX1VQ.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("KX1VQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42b1f8ae9ae72bb$export$2e2bcd8739ae039);

var $8TsCv = parcelRequire("8TsCv");

var $5jnRh = parcelRequire("5jnRh");
class $a42b1f8ae9ae72bb$export$2e2bcd8739ae039 extends (0, $5jnRh.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $8TsCv.default);
        } catch (err) {
            storageToUse = (0, $8TsCv.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("8TsCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2876d84234385448$export$2e2bcd8739ae039);
class $2876d84234385448$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$2876d84234385448$export$2e2bcd8739ae039 = new $2876d84234385448$export$90e3e001bcac59c7();

});

parcelRegister("5jnRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8496869f39880b37$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $iZhen = parcelRequire("iZhen");

var $8TsCv = parcelRequire("8TsCv");
const $8496869f39880b37$export$41c06fdd37b7e9a5 = 'awc';
const $8496869f39880b37$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $8496869f39880b37$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $8496869f39880b37$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $8496869f39880b37$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($8496869f39880b37$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $8TsCv.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($8496869f39880b37$export$48c17662a6902497(window[$8496869f39880b37$export$770aa8bc07b3de03])) inMemoryStorage = window[$8496869f39880b37$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $8TsCv.default);
                if (!window[$8496869f39880b37$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$8496869f39880b37$export$770aa8bc07b3de03] = (0, $8TsCv.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($8496869f39880b37$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $iZhen.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($8496869f39880b37$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("aXi7r", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", () => $e056f358404ee1a8$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $e056f358404ee1a8$export$de6821eed3d5f32d);

var $eYli8 = parcelRequire("eYli8");

var $8QpSo = parcelRequire("8QpSo");

var $hDpfo = parcelRequire("hDpfo");
const $e056f358404ee1a8$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $e056f358404ee1a8$export$eb80e1beaa8dacf8 = (0, $hDpfo.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $e056f358404ee1a8$export$19164982d36535d8 = 'tld_test';
const $e056f358404ee1a8$export$de6821eed3d5f32d = (0, $8QpSo.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set($e056f358404ee1a8$export$eb80e1beaa8dacf8, $e056f358404ee1a8$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get($e056f358404ee1a8$export$eb80e1beaa8dacf8) === $e056f358404ee1a8$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).remove($e056f358404ee1a8$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("1T3jD", function(module, exports) {

$parcel$export(module.exports, "buildContext", () => $50d6a5cf3019b770$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventProperties", () => $50d6a5cf3019b770$export$44d22e5fb02cc68e);
// @ts-ignore

var $1m0iJ = parcelRequire("1m0iJ");
const $50d6a5cf3019b770$export$3a7fe28f9bf4f3d9 = (context)=>{
    return {
        ...context.context,
        userAgent: navigator.userAgent
    };
};
const $50d6a5cf3019b770$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $50d6a5cf3019b770$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1m0iJ)))(propertiesWithoutUndefined);
};
const $50d6a5cf3019b770$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $50d6a5cf3019b770$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$50d6a5cf3019b770$export$2250ccecd1e040fd(i));
            else if (typeof value === 'object' && value !== null) clone[key] = $50d6a5cf3019b770$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $50d6a5cf3019b770$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});


parcelRegister("cxufL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b6cb20f24034e63$export$2e2bcd8739ae039);

var $iZhen = parcelRequire("iZhen");

var $d7bc1 = parcelRequire("d7bc1");
class $4b6cb20f24034e63$export$2e2bcd8739ae039 {
    constructor(){
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $iZhen.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $d7bc1.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        };
        this._originStore = {};
    }
}

});
parcelRegister("d7bc1", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $48efccf7b35993ac$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $48efccf7b35993ac$export$2e2bcd8739ae039);

var $dFA29 = parcelRequire("dFA29");

var $gYqa8 = parcelRequire("gYqa8");
const $48efccf7b35993ac$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $48efccf7b35993ac$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $48efccf7b35993ac$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $dFA29.parseUrl)(removedFragmentURL);
    const captureParams = (0, $gYqa8.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $gYqa8.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $dFA29.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $48efccf7b35993ac$export$2e2bcd8739ae039 = $48efccf7b35993ac$var$urlParamExtractor;

});
parcelRegister("dFA29", function(module, exports) {

$parcel$export(module.exports, "extract", () => $9f3b0e3f738c0c19$export$f9380c9a627682d3, (v) => $9f3b0e3f738c0c19$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $9f3b0e3f738c0c19$export$98e6a39c04603d36, (v) => $9f3b0e3f738c0c19$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $9f3b0e3f738c0c19$export$fac44ee5b035f737, (v) => $9f3b0e3f738c0c19$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $9f3b0e3f738c0c19$export$7a5253c0f62e0150, (v) => $9f3b0e3f738c0c19$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $9f3b0e3f738c0c19$export$a8c1621ea79325d3, (v) => $9f3b0e3f738c0c19$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $9f3b0e3f738c0c19$export$357523c63a2253b9, (v) => $9f3b0e3f738c0c19$export$357523c63a2253b9 = v);
var $9f3b0e3f738c0c19$export$f9380c9a627682d3;
var $9f3b0e3f738c0c19$export$98e6a39c04603d36;
var $9f3b0e3f738c0c19$export$fac44ee5b035f737;
var $9f3b0e3f738c0c19$export$7a5253c0f62e0150;
var $9f3b0e3f738c0c19$export$a8c1621ea79325d3;
var $9f3b0e3f738c0c19$export$357523c63a2253b9;
var $9f3b0e3f738c0c19$export$44c361b8ec72ef7f;
'use strict';

var $hlggt = parcelRequire("hlggt");

var $aCrRe = parcelRequire("aCrRe");

var $gjKya = parcelRequire("gjKya");

var $cNVkY = parcelRequire("cNVkY");
const $9f3b0e3f738c0c19$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $9f3b0e3f738c0c19$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $9f3b0e3f738c0c19$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '[',
                            $9f3b0e3f738c0c19$var$encode(index, options),
                            ']=',
                            $9f3b0e3f738c0c19$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '[]=',
                            $9f3b0e3f738c0c19$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            ':list=',
                            $9f3b0e3f738c0c19$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $9f3b0e3f738c0c19$var$encode(key, options),
                                keyValueSep,
                                $9f3b0e3f738c0c19$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $9f3b0e3f738c0c19$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $9f3b0e3f738c0c19$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '=',
                            $9f3b0e3f738c0c19$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $9f3b0e3f738c0c19$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $9f3b0e3f738c0c19$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $9f3b0e3f738c0c19$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$9f3b0e3f738c0c19$var$decode(item, options)) : value === null ? value : $9f3b0e3f738c0c19$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $9f3b0e3f738c0c19$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$9f3b0e3f738c0c19$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $9f3b0e3f738c0c19$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $9f3b0e3f738c0c19$var$encode(value, options) {
    if (options.encode) return options.strict ? $hlggt(value) : encodeURIComponent(value);
    return value;
}
function $9f3b0e3f738c0c19$var$decode(value, options) {
    if (options.decode) return $aCrRe(value);
    return value;
}
function $9f3b0e3f738c0c19$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $9f3b0e3f738c0c19$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $9f3b0e3f738c0c19$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $9f3b0e3f738c0c19$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $9f3b0e3f738c0c19$var$extract(input) {
    input = $9f3b0e3f738c0c19$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $9f3b0e3f738c0c19$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $9f3b0e3f738c0c19$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $9f3b0e3f738c0c19$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $9f3b0e3f738c0c19$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $gjKya(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $9f3b0e3f738c0c19$var$decode(value, options);
        formatter($9f3b0e3f738c0c19$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $9f3b0e3f738c0c19$var$parseValue(value[k], options);
        else ret[key] = $9f3b0e3f738c0c19$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $9f3b0e3f738c0c19$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$9f3b0e3f738c0c19$export$f9380c9a627682d3 = $9f3b0e3f738c0c19$var$extract;
$9f3b0e3f738c0c19$export$98e6a39c04603d36 = $9f3b0e3f738c0c19$var$parse;
$9f3b0e3f738c0c19$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $9f3b0e3f738c0c19$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $9f3b0e3f738c0c19$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $9f3b0e3f738c0c19$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $9f3b0e3f738c0c19$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $9f3b0e3f738c0c19$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $9f3b0e3f738c0c19$var$encode(key, options) + '=' + $9f3b0e3f738c0c19$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$9f3b0e3f738c0c19$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $gjKya(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $9f3b0e3f738c0c19$var$parse($9f3b0e3f738c0c19$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $9f3b0e3f738c0c19$var$decode(hash, options)
    } : {});
};
$9f3b0e3f738c0c19$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$9f3b0e3f738c0c19$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $9f3b0e3f738c0c19$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $9f3b0e3f738c0c19$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $9f3b0e3f738c0c19$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $9f3b0e3f738c0c19$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $9f3b0e3f738c0c19$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$9f3b0e3f738c0c19$var$encodeFragmentIdentifier] ? $9f3b0e3f738c0c19$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$9f3b0e3f738c0c19$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$9f3b0e3f738c0c19$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $9f3b0e3f738c0c19$export$7a5253c0f62e0150(input, options);
    return $9f3b0e3f738c0c19$export$a8c1621ea79325d3({
        url: url,
        query: $cNVkY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$9f3b0e3f738c0c19$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $9f3b0e3f738c0c19$export$357523c63a2253b9(input, exclusionFilter, options);
};

});



parcelRegister("cT8IU", function(module, exports) {

$parcel$export(module.exports, "selectHost", () => $271f084adaa9086b$export$18c0b81944902eae);

var $iZhen = parcelRequire("iZhen");
const $271f084adaa9086b$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $271f084adaa9086b$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $271f084adaa9086b$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $271f084adaa9086b$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $271f084adaa9086b$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $271f084adaa9086b$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $271f084adaa9086b$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $271f084adaa9086b$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $271f084adaa9086b$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $271f084adaa9086b$var$handleFedRampStagingDirect = ()=>{
    return $271f084adaa9086b$var$FEDRAMP_STAGING_HOST;
};
const $271f084adaa9086b$var$handleFedRampStagingStargate = ()=>{
    return $271f084adaa9086b$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $271f084adaa9086b$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $iZhen.envType).LOCAL || env === (0, $iZhen.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $iZhen.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$FEDRAMP_PROD_HOST : $271f084adaa9086b$var$handleFedRampStagingDirect();
    if (useLegacyUrl) return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$STARGATE_FEDRAMP_PROD_HOST : $271f084adaa9086b$var$handleFedRampStagingStargate();
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $271f084adaa9086b$var$STARGATE_PROXY_PATH;
};
const $271f084adaa9086b$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$PROD_HOST : $271f084adaa9086b$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$STARGATE_PROD_HOST : $271f084adaa9086b$var$STARGATE_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $271f084adaa9086b$var$STARGATE_PROXY_PATH;
};
function $271f084adaa9086b$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $iZhen.perimeterType).FEDRAMP_MODERATE) return $271f084adaa9086b$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $271f084adaa9086b$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});

parcelRegister("4NslB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4edf0393cec4b422$export$2e2bcd8739ae039);

var $KX1VQ = parcelRequire("KX1VQ");
const $4edf0393cec4b422$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $4edf0393cec4b422$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $4edf0393cec4b422$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $4edf0393cec4b422$export$285f6bddd927a06d = 1800000; // 30 minutes
const $4edf0393cec4b422$export$a92e915d70316eb2 = 5000; // 5 seconds
const $4edf0393cec4b422$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $4edf0393cec4b422$export$5702a91a6f42969f = ()=>{};
class $4edf0393cec4b422$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($4edf0393cec4b422$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($4edf0393cec4b422$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $4edf0393cec4b422$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $4edf0393cec4b422$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $4edf0393cec4b422$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $4edf0393cec4b422$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $KX1VQ.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($4edf0393cec4b422$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($4edf0393cec4b422$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$4edf0393cec4b422$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("lbyTT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dab3cde056915e8$export$2e2bcd8739ae039);

var $8TsCv = parcelRequire("8TsCv");

var $5jnRh = parcelRequire("5jnRh");
class $3dab3cde056915e8$export$2e2bcd8739ae039 extends (0, $5jnRh.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $8TsCv.default);
        } catch (err) {
            storageToUse = (0, $8TsCv.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("5cwz8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cc99fb31715affb$export$2e2bcd8739ae039);

var $bXrHm = parcelRequire("bXrHm");

var $lbyTT = parcelRequire("lbyTT");
const $1cc99fb31715affb$var$STORAGE_KEY = 'tab.id';
class $1cc99fb31715affb$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
            this._safeSessionStorage.setItem($1cc99fb31715affb$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $lbyTT.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($1cc99fb31715affb$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("3ErS8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c958a1cb0049824$export$2e2bcd8739ae039);

var $dFA29 = parcelRequire("dFA29");

var $bXrHm = parcelRequire("bXrHm");

var $iZhen = parcelRequire("iZhen");

var $gYqa8 = parcelRequire("gYqa8");

var $lbyTT = parcelRequire("lbyTT");

var $d7bc1 = parcelRequire("d7bc1");
const $8c958a1cb0049824$var$STORAGE_KEY = 'taskSessions';
const $8c958a1cb0049824$var$INIT_KEY = 'taskSessionsInit';
const $8c958a1cb0049824$var$AWC_PARAM_PREFIX = 'awc.';
const $8c958a1cb0049824$var$TASK_SESSION_RELOAD_TIME = 3000;
class $8c958a1cb0049824$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($8c958a1cb0049824$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($8c958a1cb0049824$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($8c958a1cb0049824$var$INIT_KEY) || '0', 10) < currentTimestamp - $8c958a1cb0049824$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($8c958a1cb0049824$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($8c958a1cb0049824$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($8c958a1cb0049824$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($8c958a1cb0049824$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $dFA29.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $gYqa8.pick)(currentState, includedTaskSessions) : (0, $gYqa8.omit)(currentState, Object.values((0, $iZhen.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $gYqa8.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$8c958a1cb0049824$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $dFA29.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $gYqa8.mapKeys)((0, $d7bc1.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $lbyTT.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($8c958a1cb0049824$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("fOR5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $de63b39d39935d35$export$2e2bcd8739ae039);

var $eYli8 = parcelRequire("eYli8");

var $hDpfo = parcelRequire("hDpfo");
const $de63b39d39935d35$var$MAX_CACHE_SIZE = 100;
const $de63b39d39935d35$var$COOKIE_NAME = (0, $hDpfo.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $de63b39d39935d35$var$DEBUG_TAG = 'synthetic';
const $de63b39d39935d35$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get($de63b39d39935d35$var$COOKIE_NAME) || 'false');
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).remove($de63b39d39935d35$var$COOKIE_NAME);
    }
    return false;
};
class $de63b39d39935d35$var$TestingCache {
    constructor(){
        this._bind = ()=>{
            if (typeof window === 'undefined' || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem('awc.ui.viewed.last.sent');
                        localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                        localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                        localStorage.removeItem('awc-local.ui.viewed.last.sent');
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        };
        this._cache = (event)=>{
            if (typeof window === 'undefined') return;
            if (window.testAnalytics.eventCache.length >= $de63b39d39935d35$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        };
        this._shouldCacheEvent = ()=>this._isDebugCookieEnabled;
        this.saveEvent = (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($de63b39d39935d35$var$DEBUG_TAG);
                else event.tags = [
                    $de63b39d39935d35$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        };
        this._isDebugCookieEnabled = $de63b39d39935d35$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $de63b39d39935d35$export$2e2bcd8739ae039 = $de63b39d39935d35$var$TestingCache;

});

parcelRegister("edTAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fcb679b12390b8a$export$2e2bcd8739ae039);

var $iZhen = parcelRequire("iZhen");

var $KX1VQ = parcelRequire("KX1VQ");
const $7fcb679b12390b8a$var$DEFAULT_DELAY = 2000; // 2 seconds
const $7fcb679b12390b8a$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $7fcb679b12390b8a$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
class $7fcb679b12390b8a$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $iZhen.tenantType).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        };
        this._handleInterval = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: 'ui',
                action: 'viewed',
                actionSubject: 'ui',
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $7fcb679b12390b8a$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $7fcb679b12390b8a$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $7fcb679b12390b8a$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $KX1VQ.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("j7FCN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4efcab6452689b70$export$2e2bcd8739ae039);
function $4efcab6452689b70$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("iNSWY", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", () => $087b35ad0bdaa6e1$export$fbe53bbbe682bcdd);

var $4LmqD = parcelRequire("4LmqD");
const $087b35ad0bdaa6e1$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $4LmqD.createTimeoutXid)()), (0, $4LmqD.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $4LmqD.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("4LmqD", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", () => $ef5896d1f0db8e24$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $ef5896d1f0db8e24$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $ef5896d1f0db8e24$export$fa341d0c750d705b);

var $cLbOk = parcelRequire("cLbOk");
const $ef5896d1f0db8e24$export$545bcbd53afabfa3 = 5000;
const $ef5896d1f0db8e24$export$af4087e36d63846 = ()=>[
        {
            type: (0, $cLbOk.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $cLbOk.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $ef5896d1f0db8e24$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $cLbOk.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $cLbOk.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("cLbOk", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", () => $b05a497c89498e1b$export$92ca0438bcb0d396);
var $b05a497c89498e1b$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $b05a497c89498e1b$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("2gQ83", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa6ca1de5bed78b$export$2e2bcd8739ae039);

var $bXrHm = parcelRequire("bXrHm");

var $lu9OT = parcelRequire("lu9OT");

var $aWBhb = parcelRequire("aWBhb");
const $3fa6ca1de5bed78b$var$packageVersion = "0.0.0-use.local";
const $3fa6ca1de5bed78b$var$originParamName = 'atlOrigin';
const $3fa6ca1de5bed78b$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$3fa6ca1de5bed78b$var$packageVersion}`
};
class $3fa6ca1de5bed78b$export$2e2bcd8739ae039 {
    constructor({ id: id = $3fa6ca1de5bed78b$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $3fa6ca1de5bed78b$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $3fa6ca1de5bed78b$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $aWBhb.getEnv)()).URLSearchParams();
        $3fa6ca1de5bed78b$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $aWBhb.getEnv)()).URLSearchParams(queryString);
        });
        return $3fa6ca1de5bed78b$export$2e2bcd8739ae039.fromEncoded(params.get($3fa6ca1de5bed78b$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $3fa6ca1de5bed78b$export$2e2bcd8739ae039.createEmpty();
        try {
            return $3fa6ca1de5bed78b$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $3fa6ca1de5bed78b$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $3fa6ca1de5bed78b$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $aWBhb.getEnv)()).URLSearchParams(queryString);
            params.delete($3fa6ca1de5bed78b$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $lu9OT.decode)(encodedOrigin);
        return new $3fa6ca1de5bed78b$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $lu9OT.encode)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $3fa6ca1de5bed78b$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $aWBhb.getEnv)()).URLSearchParams(originalQueryString);
            params.set($3fa6ca1de5bed78b$var$originParamName, this.encode());
            return params.toString();
        });
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$3fa6ca1de5bed78b$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$3fa6ca1de5bed78b$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$3fa6ca1de5bed78b$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
}
class $3fa6ca1de5bed78b$var$EmptyOriginTracer extends $3fa6ca1de5bed78b$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$3fa6ca1de5bed78b$var$originVersioningAttributes
        };
    }
}
class $3fa6ca1de5bed78b$var$MalformedOriginTracer extends $3fa6ca1de5bed78b$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$3fa6ca1de5bed78b$var$originVersioningAttributes
        };
    }
}
function $3fa6ca1de5bed78b$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}

});
parcelRegister("lu9OT", function(module, exports) {

$parcel$export(module.exports, "encode", () => $c6803b60c51754ac$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $c6803b60c51754ac$export$2f872c0f2117be69);

var $8FuSo = parcelRequire("8FuSo");

var $aWBhb = parcelRequire("aWBhb");
const $c6803b60c51754ac$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $c6803b60c51754ac$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($c6803b60c51754ac$export$4bc4b533a565aabe(originData));
    const base64 = (0, $aWBhb.getEnv)().btoa(json);
    return (0, $8FuSo.base64ToBase64Url)(base64);
}
function $c6803b60c51754ac$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $8FuSo.base64UrlToBase64)(encodedOriginString);
    const json = (0, $aWBhb.getEnv)().atob(base64);
    return $c6803b60c51754ac$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $c6803b60c51754ac$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $c6803b60c51754ac$var$productShorthands ? $c6803b60c51754ac$var$productShorthands[product] : product
    };
}
function $c6803b60c51754ac$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $c6803b60c51754ac$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $c6803b60c51754ac$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($c6803b60c51754ac$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $c6803b60c51754ac$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("8FuSo", function(module, exports) {

$parcel$export(module.exports, "base64ToBase64Url", () => $232e5bc3d2389a2f$export$3b91e21dac1023c6);
$parcel$export(module.exports, "base64UrlToBase64", () => $232e5bc3d2389a2f$export$47c5265a25535d02);
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $232e5bc3d2389a2f$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $232e5bc3d2389a2f$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("aWBhb", function(module, exports) {

$parcel$export(module.exports, "getEnv", () => $1a7c166c1d080aee$export$4bd44a2aa29d3d6e);

var $5k7LC = parcelRequire("5k7LC");

const $1a7c166c1d080aee$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $5k7LC.Buffer) !== 'undefined' && ((encoded)=>(0, $5k7LC.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $5k7LC.Buffer) !== 'undefined' && ((str)=>(0, $5k7LC.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("6vAaw")).URLSearchParams)
    });
let $1a7c166c1d080aee$var$env;
const $1a7c166c1d080aee$export$4bd44a2aa29d3d6e = ()=>$1a7c166c1d080aee$var$env || ($1a7c166c1d080aee$var$env = $1a7c166c1d080aee$var$validateEnv($1a7c166c1d080aee$export$d3cd91e0fdbfdbc0()));
const $1a7c166c1d080aee$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};

});



parcelRegister("cm6fz", function(module, exports) {

$parcel$export(module.exports, "canCompress", () => $1cdc0562980ed846$export$ec3662f84d9f778c);
$parcel$export(module.exports, "buildCompressionFunction", () => $1cdc0562980ed846$export$20de0576abb0bcc5);
const $1cdc0562980ed846$export$ec3662f84d9f778c = (event)=>event.actionSubject === 'feature' && event.action === 'exposed' && event.eventType === 'operational' && event.attributes && event.tags && event.tags.includes('measurement') && !event.tags.includes('hasCustomAttributes');
const $1cdc0562980ed846$export$ca25d5d7792a4f37 = (events, batchSize = 50)=>{
    if (!events || events.length <= 0) return [];
    if (batchSize <= 0) throw new Error('Batch size must be greater than 0');
    // Extract evaluations and reduce into a single array
    const flagEvaluations = events.map((currentEvent)=>{
        const { flagKey: flagKey, value: value, reason: reason, ruleId: ruleId, errorKind: errorKind } = currentEvent.attributes;
        return {
            key: flagKey,
            value: value,
            ...reason && {
                reason: reason
            },
            ...ruleId && {
                ruleId: ruleId
            },
            ...errorKind && {
                errorKind: errorKind
            }
        };
    });
    // Batch evaluations into specified batchSize
    return $1cdc0562980ed846$var$createBatches(flagEvaluations, batchSize);
};
const $1cdc0562980ed846$var$createBatches = (array, batchSize)=>{
    let compressedEvaluations = [];
    for(let i = 0; i < array.length; i += batchSize){
        let evaluationBatch = array.slice(i, i + batchSize);
        compressedEvaluations.push({
            actionSubject: 'features',
            action: 'exposed',
            eventType: 'operational',
            attributes: {
                evaluations: evaluationBatch
            },
            tags: [
                'measurement'
            ],
            source: '@atlassian/exposure-events-compressor'
        });
    }
    return compressedEvaluations;
};
const $1cdc0562980ed846$export$20de0576abb0bcc5 = (batchSize)=>(events)=>$1cdc0562980ed846$export$ca25d5d7792a4f37(events, batchSize);

});

parcelRegister("5bWbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e546a6b546e21170$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $f1t8h = parcelRequire("f1t8h");

var $4qJHz = parcelRequire("4qJHz");

var $5pZVQ = parcelRequire("5pZVQ");
const $e546a6b546e21170$var$EngagementProviderWithEvents = (0, $cb25w.default)()((0, $5pZVQ.EngagementProvider));
const $e546a6b546e21170$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e546a6b546e21170$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $4qJHz.default)(props.config)
    });
};
var $e546a6b546e21170$export$2e2bcd8739ae039 = (0, $f1t8h.default)($e546a6b546e21170$var$EngagementProviderWithDefaultStore);

});
parcelRegister("f1t8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad0ae17a77d9b94$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $2ad0ae17a77d9b94$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, $2OMIu.jsx)(PreventNestedInstancesContext.Consumer, {
            children: (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, $2OMIu.jsx)(PreventNestedInstancesContext.Provider, {
                    value: true,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                        ...props
                    })
                })
        }));
    };
}

});

parcelRegister("4qJHz", function(module, exports) {

$parcel$export(module.exports, "store", () => $d623685d32003ec6$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $d623685d32003ec6$export$2e2bcd8739ae039);

var $ajpes = parcelRequire("ajpes");

var $3f2cs = parcelRequire("3f2cs");

var $9JnaK = parcelRequire("9JnaK");

var $7CfdH = parcelRequire("7CfdH");

var $kjEZw = parcelRequire("kjEZw");

var $aS5YT = parcelRequire("aS5YT");
const $d623685d32003ec6$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $d623685d32003ec6$var$processMessagesCancellationToken = (0, $9JnaK.createCancellationToken)();
function $d623685d32003ec6$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $d623685d32003ec6$export$6f57813fe9f31bf9 = (0, $3f2cs.createStore)((state = $d623685d32003ec6$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $kjEZw.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $kjEZw.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $kjEZw.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $d623685d32003ec6$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $kjEZw.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $kjEZw.RESET_STORE:
            return $d623685d32003ec6$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $d623685d32003ec6$export$2e2bcd8739ae039 = (config)=>{
    const state = $d623685d32003ec6$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $d623685d32003ec6$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $d623685d32003ec6$var$processMessagesCancellationToken.isCancelled = true;
        $d623685d32003ec6$var$processMessagesCancellationToken = (0, $9JnaK.createCancellationToken)();
        $d623685d32003ec6$export$6f57813fe9f31bf9.dispatch((0, $kjEZw.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $d623685d32003ec6$export$6f57813fe9f31bf9.dispatch((0, $kjEZw.initialize)(newConfig));
    if ((0, $7CfdH.isMessagingEnabled)()) (0, $aS5YT.processMessages)($d623685d32003ec6$export$6f57813fe9f31bf9, newConfig, $d623685d32003ec6$var$processMessagesCancellationToken);
    return $d623685d32003ec6$export$6f57813fe9f31bf9;
};

});
parcelRegister("9JnaK", function(module, exports) {

$parcel$export(module.exports, "createCancellationToken", () => $5392f8ffa29adec8$export$eac027797b968991);
function $5392f8ffa29adec8$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("7CfdH", function(module, exports) {

$parcel$export(module.exports, "isMessagingEnabled", () => $ea3b9aec0dd8c076$export$a77934ac158768dd);

var $aIZdc = parcelRequire("aIZdc");
function $ea3b9aec0dd8c076$export$a77934ac158768dd() {
    return !(0, $aIZdc.isFedRamp)();
}

});

parcelRegister("kjEZw", function(module, exports) {

$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $6bb038d2cae8e000$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $6bb038d2cae8e000$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $6bb038d2cae8e000$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $6bb038d2cae8e000$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $6bb038d2cae8e000$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $6bb038d2cae8e000$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $6bb038d2cae8e000$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $6bb038d2cae8e000$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $6bb038d2cae8e000$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $6bb038d2cae8e000$export$96105f873ade39d7);
const $6bb038d2cae8e000$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $6bb038d2cae8e000$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $6bb038d2cae8e000$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $6bb038d2cae8e000$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $6bb038d2cae8e000$export$a9319af002a4c677 = 'SET_CURRENT';
const $6bb038d2cae8e000$export$a20a1205b2a2b7e4 = ()=>({
        type: $6bb038d2cae8e000$export$874c5149d7f0e3b8
    });
const $6bb038d2cae8e000$export$2a47f398eeff8b01 = (config)=>({
        type: $6bb038d2cae8e000$export$eacd3ec165715d8,
        config: config
    });
const $6bb038d2cae8e000$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $6bb038d2cae8e000$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $6bb038d2cae8e000$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $6bb038d2cae8e000$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $6bb038d2cae8e000$export$96105f873ade39d7() {
    return {
        type: $6bb038d2cae8e000$export$cb5041d68cb18859
    };
}

});

parcelRegister("aS5YT", function(module, exports) {

$parcel$export(module.exports, "processMessages", () => $c38f3c5bf4ee4a6a$export$d2e92820f98a2592);

var $1gxex = parcelRequire("1gxex");

var $kjEZw = parcelRequire("kjEZw");

var $4qJHz = parcelRequire("4qJHz");
const $c38f3c5bf4ee4a6a$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $c38f3c5bf4ee4a6a$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $4qJHz.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $1gxex.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $c38f3c5bf4ee4a6a$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $kjEZw.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $c38f3c5bf4ee4a6a$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});
parcelRegister("1gxex", function(module, exports) {

$parcel$export(module.exports, "getMessages", () => $175a1c1c29f80349$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $175a1c1c29f80349$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $175a1c1c29f80349$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $175a1c1c29f80349$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $175a1c1c29f80349$export$3683393f780c6905);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths -- Preventing pre-commit error from being thrown when importing NO_CONTENT from controllers folder*/ 
var $M4Zg0 = parcelRequire("M4Zg0");

var $k8luc = parcelRequire("k8luc");


var $5Xk79 = parcelRequire("5Xk79");
const $175a1c1c29f80349$export$f4d1b02d312560f5 = '2';
const $175a1c1c29f80349$var$inProductMessagesUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
async function $175a1c1c29f80349$export$8c20ab16ac9cf14f(cloudId, stargateUrl, product, locale) {
    return (0, $5Xk79.stargateFetch)(`${stargateUrl}${$175a1c1c29f80349$var$inProductMessagesUrlTemplate.expand({
        cloudId: cloudId,
        product: product,
        schema: $175a1c1c29f80349$export$f4d1b02d312560f5,
        locale: locale
    })}`).then((0, $5Xk79.errorIfNotOk)).then((r)=>r.json().then((messages)=>({
                messages: messages,
                interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
            })));
}
function $175a1c1c29f80349$var$handleStartStopMessageResponse(response) {
    return response.status === (0, $da88f8f66d8f0f0a$export$3288b14b6745c572);
}
const $175a1c1c29f80349$var$startMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
const $175a1c1c29f80349$var$startMessageWithVariationIdUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
const $175a1c1c29f80349$var$stopMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
var $175a1c1c29f80349$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $175a1c1c29f80349$var$choreographerPlugin;
async function $175a1c1c29f80349$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options?.enableChoreographer) return $175a1c1c29f80349$var$startMessageWithChoreographer(startMessageConfig, options);
    return $175a1c1c29f80349$var$startMessageWithCoordination(startMessageConfig);
}
async function $175a1c1c29f80349$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options?.enableChoreographer) return $175a1c1c29f80349$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $175a1c1c29f80349$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $175a1c1c29f80349$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$175a1c1c29f80349$var$choreographerPlugin) $175a1c1c29f80349$var$choreographerPlugin = new (0, $k8luc.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $175a1c1c29f80349$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$175a1c1c29f80349$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $175a1c1c29f80349$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$175a1c1c29f80349$var$choreographerPlugin) $175a1c1c29f80349$var$choreographerPlugin = new (0, $k8luc.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $175a1c1c29f80349$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$175a1c1c29f80349$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $175a1c1c29f80349$var$startMessageWithCoordination(startMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: startMessageConfig.cloudId,
        orgId: startMessageConfig.orgId,
        workspaceId: startMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $5Xk79.stargateFetch)(startMessageConfig.variationId ? `${startMessageConfig.stargateUrl}${$175a1c1c29f80349$var$startMessageWithVariationIdUrlTemplate.expand({
        messageId: startMessageConfig.messageId,
        variationId: startMessageConfig.variationId
    })}` : `${startMessageConfig.stargateUrl}${$175a1c1c29f80349$var$startMessageUrlTemplate.expand({
        messageId: startMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $5Xk79.pullResponseTextIfNotOk)).then($175a1c1c29f80349$var$handleStartStopMessageResponse);
}
async function $175a1c1c29f80349$var$stopMessageWithCoordination(stopMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: stopMessageConfig.cloudId,
        orgId: stopMessageConfig.orgId,
        workspaceId: stopMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $5Xk79.stargateFetch)(`${stopMessageConfig.stargateUrl}${$175a1c1c29f80349$var$stopMessageUrlTemplate.expand({
        messageId: stopMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $5Xk79.pullResponseTextIfNotOk)).then($175a1c1c29f80349$var$handleStartStopMessageResponse);
}
const $175a1c1c29f80349$var$userResponseUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
async function $175a1c1c29f80349$export$e1fd1449cf83c1f5(cloudId, stargateUrl, messageId, payload) {
    return (0, $5Xk79.stargateFetch)(`${stargateUrl}${$175a1c1c29f80349$var$userResponseUrlTemplate.expand({
        cloudId: cloudId,
        messageId: messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $5Xk79.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}
const $175a1c1c29f80349$var$markSeenAndFatigueUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
async function $175a1c1c29f80349$export$3683393f780c6905(seenMessageConfig) {
    const requestBody = {
        cloudId: seenMessageConfig.cloudId,
        orgId: seenMessageConfig.orgId,
        workspaceId: seenMessageConfig.workspaceId
    };
    return (0, $5Xk79.stargateFetch)(`${seenMessageConfig.stargateUrl}${$175a1c1c29f80349$var$markSeenAndFatigueUrlTemplate.expand({
        messageId: seenMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $5Xk79.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}

});
parcelRegister("k8luc", function(module, exports) {

$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $3c659b536805a56f$export$da23bd36e2d631b);

var $9ACoj = parcelRequire("9ACoj");

var $TTRxY = parcelRequire("TTRxY");

var $labik = parcelRequire("labik");

var $7cTYp = parcelRequire("7cTYp");

var $4YUjU = parcelRequire("4YUjU");
const $3c659b536805a56f$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $3c659b536805a56f$export$da23bd36e2d631b extends (0, $4YUjU.ChoreographerPlugin) {
    constructor(env, metaMetricsData = {}){
        super((0, $TTRxY.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
    /**
	 * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
	 * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
	 * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
	 * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
	 * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
	 * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
	 * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
	 * actually fired off, and will keep just the log entries from which we can derive some actual value.
	 *
	 * @param event OperationalEventPayload
	 * @returns boolean
	 */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $TTRxY.MessageAction).START || event.action !== (0, $TTRxY.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $9ACoj.Choreographer).getInstance().getCurrentMessage() ?? (0, $9ACoj.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $3c659b536805a56f$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $labik.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $TTRxY.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
		 * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
		 * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
		 * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
		 * will block the subsequest start request attempt altogether), by checking the Choreographer's
		 * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
		 * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
		 */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $7cTYp.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
		 * Dispatch the request to start the message, and return the response, which will
		 * either be 'started' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $TTRxY.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $labik.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
		 * Dispatch the request to stop the message, and return the response, which will
		 * either be 'stopped' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $TTRxY.MessageDeliveryStatus).STOPPED;
    }
}

});
parcelRegister("9ACoj", function(module, exports) {

$parcel$export(module.exports, "Choreographer", () => $9286911f96545296$export$236158f15971c92e);

var $TTRxY = parcelRequire("TTRxY");

var $labik = parcelRequire("labik");

var $7cTYp = parcelRequire("7cTYp");

var $8HM6e = parcelRequire("8HM6e");
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $9286911f96545296$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $9286911f96545296$var$singleton;
class $9286911f96545296$export$236158f15971c92e {
    /**
	 * Static method to create and/or return a singleton of the choreographer API.
	 *
	 * @returns Shared instance of choreographer API.
	 */ static getInstance() {
        if (!$9286911f96545296$var$singleton) $9286911f96545296$var$singleton = new this();
        return $9286911f96545296$var$singleton;
    }
    constructor(){
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false
        };
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
	 * Enables the message queue, and logs which message everybody else is queueing up behind.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request blocking others.
	 * @param messageId Unique identifier for the messageId blocking others.
	 */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
	 * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
	 * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
	 * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
	 * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
	 * its startMessage request is processed.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request being queued.
	 * @param messageId Unique identifier for the messageId being queued.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
	 * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
	 * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
	 * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
	 * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
	 * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
	 */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
	 * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
	 * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
	 * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
	 * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
	 * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
	 *
	 * @param [plugin] An optional plugin instance
	 */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $TTRxY.MessageAction).START;
            const logger = new (0, $7cTYp.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $labik.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: this.state.currentMessage?.productId,
                blockedByMessageId: this.state.currentMessage?.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                }
            });
            resolve((0, $TTRxY.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
	 * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param AnalyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, $9286911f96545296$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
	 * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
	 *
	 * @param productId Unique identifier for the product being checked for a current message match.
	 * @param messageId Unique identifier for the messageId being checked for a current message match.
	 */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
	 * Returns the currentMessage object.
	 */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
	 * Returns the queueingBehindMessage object.
	 */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
	 * Clears the timeout that was established for the currently-displayed message.
	 */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
	 * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
	 *
	 * @param [exceptFor] An optional plugin instance.
	 */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
	 * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
	 */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
	 * A callback used to remove a plugin from the list of subscribers for the choreographer service.
	 *
	 * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
	 */ unregisterPlugin(productId) {
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (this.state.currentMessage?.productId === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
    }
    /**
	 * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
	 *
	 * @returns A value reflecting whether a message is currently being displayed on screen.
	 */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
	 * This function is intended for test cleanup purposes only, *not* to be called by external callers.
	 *
	 * @ignore
	 * @param productId Unique identifier for the product whose messages are being requested
	 * @returns A Map of IMessage objects, keyed by unique messageId strings.
	 */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
	 * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
	 * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
	 * or a message TTL timeout has expired.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        if ((0, $8HM6e.isChoreographerSuppressed)()) {
            if (this.hasMessageRecord(productId, messageId)) {
                const message = this.ensureMessageRecord(productId, messageId);
                const didStart = await message.start?.() ?? true;
                if (didStart) {
                    // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                    message.onStart?.();
                    return (0, $TTRxY.MessageDeliveryStatus).STARTED;
                }
                return (0, $TTRxY.MessageDeliveryStatus).CANCELED;
            }
            return (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED;
        }
        const debugLogger = new (0, $labik.DebugLogger)(productId, messageId);
        const actionSubject = (0, $TTRxY.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $7cTYp.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${this.state.queueingBehindMessage?.productId} ${this.state.queueingBehindMessage?.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                logger.blocked({
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await message.start?.() ?? true;
            if (didStart) {
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                message.onStart?.();
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $TTRxY.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $TTRxY.MessageDeliveryStatus).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        if ((0, $8HM6e.isChoreographerSuppressed)()) {
            if (this.hasMessageRecord(productId, messageId)) {
                const message = this.ensureMessageRecord(productId, messageId);
                const didStop = await message.stop?.() ?? true;
                if (didStop) {
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    message.onStop?.();
                    return (0, $TTRxY.MessageDeliveryStatus).STOPPED;
                }
                return (0, $TTRxY.MessageDeliveryStatus).CANCELED;
            }
            return (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED;
        }
        const debugLogger = new (0, $labik.DebugLogger)(productId, messageId);
        const actionSubject = (0, $TTRxY.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $7cTYp.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await message.stop?.() ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    message.onStop?.();
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $TTRxY.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $TTRxY.MessageDeliveryStatus).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
	 * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId Unique identifier to register as the product owner of this plugin.
	 * @param plugin A plugin instance to be registered with the choreographer instance.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
	 * Validates that a message record is present and ready to be retrieved and/or manipulated.
	 * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
	 *
	 * @param productId Unique identifier to retrieve map of IMessage objects.
	 * @param messageId Unique identifier for the messageId to be retrieved.
	 * @returns IMessage object for the requested productId/messageId combination.
	 */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
	 * Checks for the existance of a message record for a given productId/messageId combination.
	 *
	 * @param productId Unique identifier to check for a map of IMessage objects.
	 * @param messageId Unique identifier to check for within the map of productId IMessage objects.
	 * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
	 */ hasMessageRecord(productId, messageId) {
        return Boolean(this.state.messages.get(productId)?.has?.(messageId));
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
	 */ off(productId, messageId) {
        this.state.messages.get(productId)?.delete?.(messageId);
    }
}

});
parcelRegister("TTRxY", function(module, exports) {

$parcel$export(module.exports, "MessageEventType", () => $c5cd2ef964768afb$export$d33b097e0a285bc2);
$parcel$export(module.exports, "MessageDeliveryStatus", () => $c5cd2ef964768afb$export$f6a9504bc1305cf0);
$parcel$export(module.exports, "ProductIds", () => $c5cd2ef964768afb$export$7fb117db98868be6);
$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $c5cd2ef964768afb$export$dbe9e38c9d6f26d0);
$parcel$export(module.exports, "MessageAction", () => $c5cd2ef964768afb$export$865c0eaaa43d90f8);
const $c5cd2ef964768afb$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $c5cd2ef964768afb$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered'
};
var $c5cd2ef964768afb$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    return ProductIds;
}({});
const $c5cd2ef964768afb$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $c5cd2ef964768afb$export$dbe9e38c9d6f26d0 = [
    $c5cd2ef964768afb$export$94e85cf3348f045a.ENGAGEMENT,
    $c5cd2ef964768afb$export$94e85cf3348f045a.MARKETING
];
const $c5cd2ef964768afb$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $c5cd2ef964768afb$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};

});

parcelRegister("labik", function(module, exports) {

$parcel$export(module.exports, "DebugLogger", () => $df6e50e0e93de28e$export$21e6cc849c1dc1ab);
function $df6e50e0e93de28e$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $df6e50e0e93de28e$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($df6e50e0e93de28e$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $df6e50e0e93de28e$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($df6e50e0e93de28e$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $df6e50e0e93de28e$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. log.info and log.verbose, which are functions that take an
	 * object of any key/value pairs, which will be merged with the productId
	 * and the messageId values passed to the constructor, and output via
	 * console.table.
	 *
	 * Example: debugLogger.log({
	 *   info: { foo: true },
	 *   verbose: {
	 *     foo: true,
	 *     bar: 123,
	 *     baz 'abc',
	 *     timestamp: performance.now()
	 *   },
	 * });
	 *
	 * @param messages Record<LoggingLevels, Record<string, unknown>> An object
	 * keyed by the desired log-level, with each value being an object of any
	 * key/value pairs to be output to console.table.
	 */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $df6e50e0e93de28e$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. trace.info and trace.verbose, which are functions that take
	 * a string to be used as the label for a stack trace via console.trace.
	 *
	 * Example: debugLogger.trace({
	 *   info: 'This is a stack trace',
	 *   verbose: `This is a stack trace with a much more verbose message which
	 * contains data about the ${productId} and ${messageId} within my function,
	 * invoked at ${performance.now()}ms`,
	 * });
	 *
	 * @param messages Record<LoggingLevels, string> An object keyed by the
	 * desired log-level, with each value being a string to be output as the
	 * label to console.trace.
	 */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $df6e50e0e93de28e$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}

});

parcelRegister("7cTYp", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $d9e69a5d0cc0dc3b$export$efa9a398d6368992);

var $TTRxY = parcelRequire("TTRxY");
class $d9e69a5d0cc0dc3b$export$efa9a398d6368992 {
    /**
	 * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
	 *
	 * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
	 * @param actionSubjectId Unique messageId to be logged with this even.
	 * @param metricsData Additional data from plugin to be sent with event for metrics logging.
	 * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
	 * @param [plugin] An optional plugin instance.
	 */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
    /**
	 * Send operational event to the Analytics web client for logging/metrics.
	 *
	 * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
	 */ sendOperationalEvent(action, additionalAttributes) {
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if (plugin?.shouldLogEvent?.(event) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
}

});

parcelRegister("8HM6e", function(module, exports) {

$parcel$export(module.exports, "isChoreographerSuppressed", () => $d93850280d469418$export$a0c8fa5038db1b93);

var $iEN9D = parcelRequire("iEN9D");
function $d93850280d469418$export$a0c8fa5038db1b93() {
    return (0, $iEN9D.default).initializeCompleted() && (0, $iEN9D.default).getExperimentValue('post-office_ipm_choreographer_new_tenants', 'supressChoreographer', false);
}

});


parcelRegister("4YUjU", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPlugin", () => $05d317f1a3b9d082$export$71324a662782c710);

var $buAWB = parcelRequire("buAWB");
var $iZhen = parcelRequire("iZhen");

var $9ACoj = parcelRequire("9ACoj");
class $05d317f1a3b9d082$export$71324a662782c710 {
    /**
	 * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
	 * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
	 * between individual products for tracking purposes.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @param env The environment type for the product, to be used for analytics events.
	 * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
	 * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
	 */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
		 * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
		 * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
		 * .on, .onStart, and .onStop function registrations.
		 *
		 * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
		 * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
		 * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
		 * in the plugin, and would continue blocking messages.
		 *
		 * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
		 * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
		 * whether or not an actual start or stop callback was registered by the consumer.
		 */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
    /**
	 * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
	 */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
	 * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
	 * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
	 * container to be present, or checks with some external API to tell it whether a message is being displayed, or
	 * anything else. The logic is up to the consumer to implement, if something custom is desired.
	 *
	 * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
	 */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
	 * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
	 */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
	 * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
	 */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
	 * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ disable() {
        this.state.isDisabled = true;
    }
    /**
	 * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ enable() {
        this.state.isDisabled = false;
    }
    /**
	 * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
	 * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
	 *
	 * @param messageId The messageId for the message to be started through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message start request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(messageId, additionalData = {}) {
        return (0, $9ACoj.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this);
    }
    /**
	 * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
	 *
	 * @param messageId The messageId for the message to be stopped through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message stop request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(messageId, additionalData = {}) {
        return (0, $9ACoj.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 */ on(messageId, options = {}) {
        return (0, $9ACoj.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 */ onStart(messageId, startCallback) {
        return (0, $9ACoj.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 */ onStop(messageId, stopCallback) {
        return (0, $9ACoj.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
	 */ off(messageId) {
        return (0, $9ACoj.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    /**
	 * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId) {
        return (0, $9ACoj.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
	 * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
	 *
	 * @param env environment type used to create the analytics client
	 * @returns AnalyticsWebClient instance
	 */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $buAWB.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $iZhen.originType).WEB
        });
        return analyticsClient;
    }
}

});


const $da88f8f66d8f0f0a$export$3288b14b6745c572 = 204;
const $da88f8f66d8f0f0a$export$c09e7ea0fc79f34f = 409;
const $da88f8f66d8f0f0a$export$974c37534b0191b1 = 503;

parcelRegister("5Xk79", function(module, exports) {

$parcel$export(module.exports, "errorIfNotOk", () => $4c2fd435c53be241$export$4adbd37839ed7718);
$parcel$export(module.exports, "pullResponseTextIfNotOk", () => $4c2fd435c53be241$export$2ba4cde277adb6b1);
$parcel$export(module.exports, "stargateFetch", () => $4c2fd435c53be241$export$317bcea84a3bea48);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $2qBHI = parcelRequire("2qBHI");
const $4c2fd435c53be241$export$1f86472c1374185a = 3;
const $4c2fd435c53be241$export$a2d611d5c7be4bb1 = 0.1;
const $4c2fd435c53be241$export$957d605a51548b59 = 2;
const $4c2fd435c53be241$export$80aa83cae6a6c290 = 1000;
async function $4c2fd435c53be241$export$4adbd37839ed7718(response) {
    if (!response.ok) // We use the response body for two reasons:
    // 1. To ensure that we consume the response body, so that it gets reported on in Chrome DevTools
    // 2. It could have some useful information relevant to the error
    throw Error(`${response.status}: ${await response.text()}`);
    return response;
}
async function $4c2fd435c53be241$export$2ba4cde277adb6b1(response) {
    if (!response.ok) await response.text();
    return response;
}
function $4c2fd435c53be241$export$317bcea84a3bea48(input, reqOptions) {
    return $4c2fd435c53be241$var$fetchWithRetry({
        input: input,
        reqOptions: reqOptions,
        numRetries: 0,
        maxRetries: $4c2fd435c53be241$export$1f86472c1374185a,
        waitTimeMs: $4c2fd435c53be241$export$80aa83cae6a6c290,
        backoffFn: $4c2fd435c53be241$export$924aee1254634401
    });
}
function $4c2fd435c53be241$var$fetchWithRetry({ input: input, reqOptions: reqOptions, numRetries: numRetries = 0, maxRetries: maxRetries = 0, waitTimeMs: waitTimeMs = 0, backoffFn: backoffFn = $4c2fd435c53be241$export$924aee1254634401 }) {
    if (numRetries > maxRetries) throw new Error(`Failed to fetch ${input}: Max retries exceeded`);
    const options = {
        ...reqOptions,
        credentials: (0, $2qBHI.default).includes(location.host) ? 'include' : 'same-origin'
    };
    const retryAttempt = ()=>new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($4c2fd435c53be241$var$fetchWithRetry({
                    input: input,
                    reqOptions: reqOptions,
                    numRetries: numRetries + 1,
                    maxRetries: maxRetries,
                    waitTimeMs: backoffFn(waitTimeMs),
                    backoffFn: backoffFn
                }));
            }, waitTimeMs);
        });
    return fetch(input, options).then((response)=>{
        if (response.status >= 500 && response.status <= 599) return retryAttempt();
        return response;
    }).catch(()=>{
        return retryAttempt();
    });
}
function $4c2fd435c53be241$export$924aee1254634401(waitTimeMs) {
    const nextWaitTime = waitTimeMs * $4c2fd435c53be241$export$957d605a51548b59;
    const jitter = nextWaitTime * $4c2fd435c53be241$export$a2d611d5c7be4bb1 * Math.random();
    return nextWaitTime + jitter;
}

});
parcelRegister("2qBHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $269377431b5cba8d$export$2e2bcd8739ae039);
var $269377431b5cba8d$export$2e2bcd8739ae039 = [
    // Bitbucket Pipelines domains (is an iframe and require CORS)
    'bitbucket-pipelines.dev.public.atl-paas.net',
    'bitbucket-pipelines.staging.public.atl-paas.net',
    'bitbucket-pipelines.prod.public.atl-paas.net'
];

});





parcelRegister("5pZVQ", function(module, exports) {

$parcel$export(module.exports, "EngagementProvider", () => $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c);
/* eslint-disable max-lines */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f8l56 = parcelRequire("f8l56");

var $bxYf9 = parcelRequire("bxYf9");

var $8rCP3 = parcelRequire("8rCP3");

var $dyczo = parcelRequire("dyczo");

var $hDX9C = parcelRequire("hDX9C");
var $bvUB1 = parcelRequire("bvUB1");

var $TTRxY = parcelRequire("TTRxY");
var $kmPbm = parcelRequire("kmPbm");

var $1gxex = parcelRequire("1gxex");

var $6DQWS = parcelRequire("6DQWS");

var $kvwcw = parcelRequire("kvwcw");

var $1V1R5 = parcelRequire("1V1R5");

var $7CfdH = parcelRequire("7CfdH");

var $kjEZw = parcelRequire("kjEZw");

var $jch2y = parcelRequire("jch2y");
const $63ee8f5ffbbe7d5e$var$MAX_EVENT_QUEUE_SIZE = 100;
const $63ee8f5ffbbe7d5e$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $63ee8f5ffbbe7d5e$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $63ee8f5ffbbe7d5e$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $63ee8f5ffbbe7d5e$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($f8l56)))(payload, trigger);
    });
}
function $63ee8f5ffbbe7d5e$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $hDX9C.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $63ee8f5ffbbe7d5e$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $63ee8f5ffbbe7d5e$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $63ee8f5ffbbe7d5e$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $1gxex.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $1gxex.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $63ee8f5ffbbe7d5e$var$fireExposureEvent($63ee8f5ffbbe7d5e$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $1gxex.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions?.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $TTRxY.MessageDeliveryStatus).STARTED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $63ee8f5ffbbe7d5e$var$fireExposureEvent($63ee8f5ffbbe7d5e$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $kjEZw.setCurrent)(eventMapping));
        }
    } else {
        $63ee8f5ffbbe7d5e$var$fireExposureEvent($63ee8f5ffbbe7d5e$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $kjEZw.setCurrent)(eventMapping));
    }
}
class $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c extends (0, $5uXOq.Component) {
    static{
        this.componentConfig = new Map();
    }
    static{
        this.childContextTypes = {
            subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
            setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
        };
    }
    static{
        this.defaultProps = {
            eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($dyczo)))
        };
    }
    static{
        /*
	 * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
	 * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
	 */ this.hasInitializedAtLeastOneEngagementProvider = false;
    }
    constructor(props){
        super(props), this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $kvwcw.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $63ee8f5ffbbe7d5e$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        }, this.onEvent = (event)=>{
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $63ee8f5ffbbe7d5e$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $1V1R5.default)({
                eventName: $63ee8f5ffbbe7d5e$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $7CfdH.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $63ee8f5ffbbe7d5e$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if (eventMapping.component?.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $63ee8f5ffbbe7d5e$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        }, this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $63ee8f5ffbbe7d5e$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        }, this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        }, this.getComponentCoordinationOptions = (componentConfig)=>{
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean(this.props.coordinationOptions?.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig?.messageType ? // regardless of the EngagementProvider's coordinationOptions
                (0, $kmPbm.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        }, this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        }, this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        }, this.removeComponentConfig = (configId)=>{
            if ($63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $6DQWS.sendUIEvent).bind(null, analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $6DQWS.sendScreenEvent).bind(null, analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $6DQWS.sendOperationalEvent).bind(null, analyticsClientInstance);
        this.analyticsEventQueue = new (0, $jch2y.default)($63ee8f5ffbbe7d5e$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(// TODO: create metric for this with Metal
        ()=>{});
    }
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $1gxex.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $TTRxY.MessageDeliveryStatus).STOPPED : (0, $TTRxY.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $kjEZw.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
            channel: "*",
            onEvent: this.onEvent,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
                channel: "engagement",
                onEvent: this.onEngagementEvent,
                children: this.props.children
            })
        });
    }
}

});
parcelRegister("kmPbm", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $349a22efab51e753$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "wrapComponentForChoreographer", () => $349a22efab51e753$export$51d40de083bcc6e7);
$parcel$export(module.exports, "wrapToggleableComponentForChoreographer", () => $349a22efab51e753$export$7c574bc7a8b74124);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $TTRxY = parcelRequire("TTRxY");
const $349a22efab51e753$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions?.enableChoreographer) && props?.messageType !== undefined && (0, $TTRxY.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $349a22efab51e753$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $349a22efab51e753$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};

});

parcelRegister("6DQWS", function(module, exports) {

$parcel$export(module.exports, "sendScreenEvent", () => $e2229a045a8d1e70$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $e2229a045a8d1e70$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $e2229a045a8d1e70$export$e5f89b51c6d4e36b);
function $e2229a045a8d1e70$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $e2229a045a8d1e70$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $e2229a045a8d1e70$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("kvwcw", function(module, exports) {

$parcel$export(module.exports, "getBrowserInfo", () => $a57e7d3f26bcd5b0$export$6c724a6ffa2dc3e1);
const $a57e7d3f26bcd5b0$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $a57e7d3f26bcd5b0$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $a57e7d3f26bcd5b0$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $a57e7d3f26bcd5b0$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $a57e7d3f26bcd5b0$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $a57e7d3f26bcd5b0$export$cda2203640e08931;
}

});

parcelRegister("1V1R5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2790c6d4b1743589$export$2e2bcd8739ae039);
// @ts-nocheck
const $2790c6d4b1743589$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $2790c6d4b1743589$export$2e2bcd8739ae039 = $2790c6d4b1743589$var$createCustomEvent;

});

parcelRegister("jch2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e7ede0d10dc16ca$export$2e2bcd8739ae039);
class $1e7ede0d10dc16ca$export$2e2bcd8739ae039 {
    constructor(maxSize){
        this.queue = [];
        this.maxSize = maxSize;
    }
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
}

});



parcelRegister("j7rCb", function(module, exports) {

$parcel$export(module.exports, "setCurrent", () => $89d30012ddef3b50$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $89d30012ddef3b50$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $89d30012ddef3b50$export$1dc361b277327f88);

var $5uXOq = parcelRequire("5uXOq");

var $fVdZG = parcelRequire("fVdZG");

var $adSzG = parcelRequire("adSzG");

var $cRRE7 = parcelRequire("cRRE7");
let $89d30012ddef3b50$var$CURRENT_PHASE = (0, $fVdZG.PHASE).PAINT;
const $89d30012ddef3b50$export$5f80f094fd31fffd = (phase)=>{
    $89d30012ddef3b50$var$CURRENT_PHASE = phase;
    (0, $adSzG.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $89d30012ddef3b50$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: (0, $cRRE7.createSubscribe)((0, $adSzG.LISTENERS)),
    currentValue: ()=>$89d30012ddef3b50$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $89d30012ddef3b50$export$5f80f094fd31fffd((0, $fVdZG.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$89d30012ddef3b50$export$5f80f094fd31fffd((0, $fVdZG.PHASE).PAINT)
    }
});
const $89d30012ddef3b50$export$1dc361b277327f88 = ()=>{
    const v = (0, $5uXOq.useContext)($89d30012ddef3b50$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("fVdZG", function(module, exports) {

$parcel$export(module.exports, "PHASE", () => $42cd1e694b8e78ec$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $42cd1e694b8e78ec$export$4831ef3968ea94ef);
const $42cd1e694b8e78ec$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $42cd1e694b8e78ec$export$4831ef3968ea94ef = new Map();

});

parcelRegister("adSzG", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", () => $c4a06b1b1597f883$export$81b9c458a026d68f);
const $c4a06b1b1597f883$export$81b9c458a026d68f = [];

});

parcelRegister("cRRE7", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", () => $b8fa4315e8c49344$export$364097d812234b3f);
const $b8fa4315e8c49344$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});


parcelRegister("bCf8q", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", () => $323c58521b366879$export$c73a6a6f0bf7d425);
$parcel$export(module.exports, "isLoaderError", () => $323c58521b366879$export$16a03aca4a3508b4);
const $323c58521b366879$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $323c58521b366879$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$323c58521b366879$export$6aa69c1258005366]: true
    });
    return error;
};
const $323c58521b366879$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($323c58521b366879$export$6aa69c1258005366);

});

parcelRegister("7hSN4", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $7741fbdbff529fad$export$256c542058532d6f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $5uXOq = parcelRequire("5uXOq");

var $7AnOd = parcelRequire("7AnOd");

var $7In2L = parcelRequire("7In2L");
class $7741fbdbff529fad$export$256c542058532d6f extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        }, this.hydrationFallback = null, this.mounted = false, this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $5uXOq.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7In2L.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7In2L.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $7AnOd.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("7AnOd", function(module, exports) {

$parcel$export(module.exports, "getExport", () => $6ff86d172f86baa4$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $6ff86d172f86baa4$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $6ff86d172f86baa4$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $6ff86d172f86baa4$export$62bf630d0de3d781);

var $jJo8A = parcelRequire("jJo8A");
const $6ff86d172f86baa4$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $6ff86d172f86baa4$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $6ff86d172f86baa4$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $6ff86d172f86baa4$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("jJo8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $826166571ec93640$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $826166571ec93640$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("7In2L", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", () => $2bba2aa329f941bd$export$c33990e84065970c);

var $5uXOq = parcelRequire("5uXOq");
const $2bba2aa329f941bd$export$c33990e84065970c = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});


parcelRegister("5poak", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $472a1d8a4f6b2e6c$export$9ba3fe09d15de47b);

var $5uXOq = parcelRequire("5uXOq");

var $dwdrq = parcelRequire("dwdrq");
const $472a1d8a4f6b2e6c$export$9ba3fe09d15de47b = (0, $5uXOq.createContext)({
    subscribe: ()=>(0, $dwdrq.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("dwdrq", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", () => $07eaf0b5e178e983$export$276c7dbda7675aec);
const $07eaf0b5e178e983$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};

});


parcelRegister("kxZPA", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => $f5d25d622251412b$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $f5d25d622251412b$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $f5d25d622251412b$export$488013bae63b21da);

var $a6rDZ = parcelRequire("a6rDZ");

var $ddkdN = parcelRequire("ddkdN");

var $fVdZG = parcelRequire("fVdZG");

var $7AnOd = parcelRequire("7AnOd");
var $jJo8A = parcelRequire("jJo8A");

var $jdTx8 = parcelRequire("jdTx8");

var $WOtQc = parcelRequire("WOtQc");

var $fCMWS = parcelRequire("fCMWS");

var $atSTR = parcelRequire("atSTR");

var $qkBMj = parcelRequire("qkBMj");

var $aoIf8 = parcelRequire("aoIf8");

var $bCf8q = parcelRequire("bCf8q");
function $f5d25d622251412b$var$lazyProxy(loader, { defer: defer = (0, $fVdZG.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $7AnOd.isNodeEnvironment)();
    const dataLazyId = (0, $jJo8A.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/ban-types
    const LazyInternal = isServer ? (0, $WOtQc.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $jdTx8.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $atSTR.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $ddkdN.getConfig)();
                return (0, $aoIf8.retry)(loader, {
                    delay: (0, $fCMWS.RETRY_DELAY),
                    factor: (0, $fCMWS.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $7AnOd.displayNameFromId)(moduleId)})`;
    /**
	 * Allows getting module chunks urls
	 */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $ddkdN.getConfig)();
        return (0, $a6rDZ.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
	 * Allows imperatively preload/ prefetch the module chunk asset
	 */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $fVdZG.PHASE).PAINT ? (0, $fCMWS.PRIORITY).HIGH : (0, $fCMWS.PRIORITY).LOW);
        return (0, $qkBMj.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $f5d25d622251412b$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $fVdZG.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $fVdZG.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $fVdZG.PHASE).LAZY
    }
};
function $f5d25d622251412b$export$c952e5f94576010e(loader, opts) {
    return $f5d25d622251412b$var$lazyProxy(loader, {
        ...$f5d25d622251412b$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $f5d25d622251412b$export$291dd592399bdafa(loader, opts) {
    return $f5d25d622251412b$var$lazyProxy(loader, {
        ...$f5d25d622251412b$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $f5d25d622251412b$export$488013bae63b21da(loader, opts) {
    return $f5d25d622251412b$var$lazyProxy(loader, {
        ...$f5d25d622251412b$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}

});
parcelRegister("a6rDZ", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", () => $2075c274ba019639$export$303f43e55cf1ef2f);
const $2075c274ba019639$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("ddkdN", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $215feff881673676$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $215feff881673676$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("7Ewwd")).MODE);

var $7Ewwd = parcelRequire("7Ewwd");
const $215feff881673676$var$DEFAULT_CROSS_ORIGIN = undefined;
const $215feff881673676$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $215feff881673676$var$DEFAULT_MODE = (0, $7Ewwd.MODE).HYDRATE;
const $215feff881673676$var$DEFAULT_RETRY = 2;
const $215feff881673676$var$config = {
    crossOrigin: $215feff881673676$var$DEFAULT_CROSS_ORIGIN,
    manifest: $215feff881673676$var$DEFAULT_MANIFEST,
    mode: $215feff881673676$var$DEFAULT_MODE,
    retry: $215feff881673676$var$DEFAULT_RETRY
};
const $215feff881673676$export$44487a86467333c3 = ()=>$215feff881673676$var$config;
const $215feff881673676$export$940a7873bb071df8 = (nextConfig)=>{
    $215feff881673676$var$config.crossOrigin = nextConfig.crossOrigin ?? $215feff881673676$var$DEFAULT_CROSS_ORIGIN;
    $215feff881673676$var$config.manifest = nextConfig.manifest ?? $215feff881673676$var$DEFAULT_MANIFEST;
    $215feff881673676$var$config.mode = nextConfig.mode ?? $215feff881673676$var$DEFAULT_MODE;
    $215feff881673676$var$config.retry = nextConfig.retry ?? $215feff881673676$var$DEFAULT_RETRY;
};

});
parcelRegister("7Ewwd", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $ad15fad8d44b1229$export$e48589d9e4824227);
const $ad15fad8d44b1229$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("jdTx8", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", () => $1afeb489bc604bb9$export$6898b5504b58699a);

var $5uXOq = parcelRequire("5uXOq");

var $ddkdN = parcelRequire("ddkdN");
var $7Ewwd = parcelRequire("7Ewwd");

var $fVdZG = parcelRequire("fVdZG");

var $5poak = parcelRequire("5poak");

var $j7rCb = parcelRequire("j7rCb");

var $cEm1b = parcelRequire("cEm1b");

var $7In2L = parcelRequire("7In2L");

var $bCf8q = parcelRequire("bCf8q");

var $2IUgd = parcelRequire("2IUgd");

var $oq2LV = parcelRequire("oq2LV");

var $lO9oD = parcelRequire("lO9oD");
function $1afeb489bc604bb9$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $5uXOq.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $fVdZG.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $fVdZG.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $5uXOq.useContext)((0, $cEm1b.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $bCf8q.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $lO9oD.useSubscription)({
            context: (0, $5poak.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $fVdZG.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $lO9oD.useSubscription)({
            context: (0, $j7rCb.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $5uXOq.useContext)((0, $7In2L.LazySuspenseContext));
        (0, $5uXOq.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $fVdZG.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $ddkdN.getConfig)().mode === (0, $7Ewwd.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oq2LV.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2IUgd.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("cEm1b", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $fb9d2138d0a4f430$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $fb9d2138d0a4f430$export$8146ab57a3f7a7cb);

var $5uXOq = parcelRequire("5uXOq");
const $fb9d2138d0a4f430$export$e2d53c0cbedd2710 = {
    current: null
};
const $fb9d2138d0a4f430$export$8146ab57a3f7a7cb = (0, $5uXOq.createContext)($fb9d2138d0a4f430$export$e2d53c0cbedd2710);

});

parcelRegister("2IUgd", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $d6ce82b512d53993$export$ca5b8fbc835d95e4);

var $5uXOq = parcelRequire("5uXOq");

var $7AnOd = parcelRequire("7AnOd");
const $d6ce82b512d53993$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $7AnOd.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), {
            ...props,
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("oq2LV", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", () => $935294f441ec99ac$export$d55db778a3e1446b);

var $5uXOq = parcelRequire("5uXOq");

var $cEm1b = parcelRequire("cEm1b");

var $5poak = parcelRequire("5poak");

var $7In2L = parcelRequire("7In2L");
function $935294f441ec99ac$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $935294f441ec99ac$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $5uXOq.useRef)(null);
    const { current: ssrDomNodes } = (0, $5uXOq.useRef)(content || []);
    const profilerContext = (0, $5uXOq.useContext)((0, $cEm1b.ProfilerContext)).current;
    const waitContext = (0, $5uXOq.useContext)((0, $5poak.WaitContext));
    const suspenseContext = (0, $5uXOq.useContext)((0, $7In2L.LazySuspenseContext));
    (0, $5uXOq.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($935294f441ec99ac$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $935294f441ec99ac$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $935294f441ec99ac$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});

parcelRegister("lO9oD", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $7755a72a55b4f109$export$368b4214baeb914c);

var $5uXOq = parcelRequire("5uXOq");
function $7755a72a55b4f109$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $5uXOq.useContext)(context);
    (0, $5uXOq.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("WOtQc", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", () => $3c9928cdf43ed0ec$export$eb2e4b04351cdd9e);

var $5uXOq = parcelRequire("5uXOq");

var $a6rDZ = parcelRequire("a6rDZ");

var $ddkdN = parcelRequire("ddkdN");

var $fVdZG = parcelRequire("fVdZG");

var $7In2L = parcelRequire("7In2L");

var $7AnOd = parcelRequire("7AnOd");

var $bCf8q = parcelRequire("bCf8q");
function $3c9928cdf43ed0ec$var$load(moduleId, loader) {
    try {
        return (0, $7AnOd.getExport)(loader());
    } catch (err) {
        throw (0, $bCf8q.createLoaderError)(err);
    }
}
function $3c9928cdf43ed0ec$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const Resolved = ssr ? $3c9928cdf43ed0ec$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $5uXOq.useContext)((0, $7In2L.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $ddkdN.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $fVdZG.PHASE).LAZY && (0, $a6rDZ.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("link", {
                key: url,
                rel: defer === (0, $fVdZG.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            })), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("fCMWS", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", () => $a5cf4b862e654127$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $a5cf4b862e654127$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $a5cf4b862e654127$export$ba64c908e55507fe);
const $a5cf4b862e654127$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $a5cf4b862e654127$export$a339266ad71b2447 = 300;
const $a5cf4b862e654127$export$ba64c908e55507fe = 1;

});

parcelRegister("atSTR", function(module, exports) {

$parcel$export(module.exports, "createDeferred", () => $133a960512c1fe96$export$e673efccd97e4223);
const $133a960512c1fe96$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("qkBMj", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", () => $0ca34b961c7287e8$export$25bad4aa00c45355);

var $a6rDZ = parcelRequire("a6rDZ");

var $dwdrq = parcelRequire("dwdrq");

var $ddkdN = parcelRequire("ddkdN");

var $cEm1b = parcelRequire("cEm1b");

var $7AnOd = parcelRequire("7AnOd");

var $fCMWS = parcelRequire("fCMWS");

var $5VuPF = parcelRequire("5VuPF");
function $0ca34b961c7287e8$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $ddkdN.getConfig)();
    const assets = (0, $a6rDZ.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $5VuPF.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $0ca34b961c7287e8$var$fakePromise = {
    then: ()=>$0ca34b961c7287e8$var$fakePromise,
    catch: ()=>$0ca34b961c7287e8$var$fakePromise,
    finally: ()=>$0ca34b961c7287e8$var$fakePromise
};
function $0ca34b961c7287e8$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $5VuPF.insertLinkTag)(href, rel));
        return $0ca34b961c7287e8$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $0ca34b961c7287e8$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $dwdrq.noopCleanup;
}
function $0ca34b961c7287e8$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $7AnOd.isNodeEnvironment)()) return 0, $dwdrq.noopCleanup;
    (0, $cEm1b.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $fCMWS.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $0ca34b961c7287e8$export$3af04dbcb01bad4d,
        $0ca34b961c7287e8$export$1046fd6a49d5e7a,
        $0ca34b961c7287e8$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $dwdrq.noopCleanup;
}

});
parcelRegister("5VuPF", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", () => $f90e93988869ca21$export$6610512821c8a4ce);

var $dwdrq = parcelRequire("dwdrq");

var $ddkdN = parcelRequire("ddkdN");

var $cEm1b = parcelRequire("cEm1b");
function $f90e93988869ca21$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $dwdrq.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $ddkdN.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $cEm1b.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("aoIf8", function(module, exports) {

$parcel$export(module.exports, "retry", () => $3a7c17a9826ee760$export$9369b12211e1fce4);
const $3a7c17a9826ee760$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $3a7c17a9826ee760$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $3a7c17a9826ee760$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $3a7c17a9826ee760$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $3a7c17a9826ee760$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $3a7c17a9826ee760$var$calculateDelay(context, policy);
        if (delay) await $3a7c17a9826ee760$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});


parcelRegister("2aljs", function(module, exports) {

$parcel$export(module.exports, "default", () => $21c50eeb436ec60e$export$2e2bcd8739ae039);

var $8tutR = parcelRequire("8tutR");

var $2gGKS = parcelRequire("2gGKS");

var $ffH38 = parcelRequire("ffH38");

var $cW5DS = parcelRequire("cW5DS");

var $fL1td = parcelRequire("fL1td");
function $21c50eeb436ec60e$var$pushOrUnshiftByCaptureGroup(arr, node) {
    if (node.segmentPattern.includes('(') && node.segmentPattern.includes(')')) // if the segmentPattern has capturing group, it's more specific
    // so we place it at the beginning of the array
    arr.unshift(node);
    else // otherwise place at the end of the array
    arr.push(node);
}
// Find matching nodes by segment
// sort the nodes by specificity
function $21c50eeb436ec60e$var$matchChildren(node, segments) {
    // how do we define specificity? This is a tricky question.
    // the specificity goes like this:
    // 1. if the segment is an exact match, of course it's the most specific
    // 2. the rest is regex match, within the regex match, we have to consider:
    // 		2.1 the length of segments and if node has descendants. /jira/:id/summary is more specific than /jira/:id if the request URL is /jira/123/summary
    // 3 after checking the length, we have to consider if the segmentPattern has any capturing group. /jira/:id(\d+) is more specific than /jira/:id
    //
    // This is not a comprehensive solution to the specificity problem
    // I will use production urls to verify this heuristic
    const exactMatch = []; // segment is an exact match e.g. /jira matches /jira
    const lengthMatch = []; // check #2.1 from the above comment
    const rest = [];
    const { children: children } = node;
    // treat url segment as empty string if it's undefined
    // possible if we have optional segmentPattern
    const segment = segments[node.level] || '';
    // check if there is next segment
    const hasNextSegment = segments.length > node.level;
    for(const segmentPattern in children)if (Object.prototype.hasOwnProperty.call(children, segmentPattern)) {
        const child = children[segmentPattern];
        if (segment === segmentPattern) // we have exact segment match
        exactMatch.push(child);
        else {
            const regex = (0, $ffH38.pathToRegexp)(segmentPattern, [], {
                end: true,
                strict: true,
                sensitive: false
            });
            if (regex.test(segment)) {
                const nodeAhasChildren = Object.keys(child.children).length > 0;
                if (hasNextSegment && nodeAhasChildren) // if there is a next segment, we should prioritize nodes with children
                $21c50eeb436ec60e$var$pushOrUnshiftByCaptureGroup(lengthMatch, child);
                else if (!hasNextSegment && !nodeAhasChildren) // if there is no next segment, we should prioritize nodes without children
                $21c50eeb436ec60e$var$pushOrUnshiftByCaptureGroup(lengthMatch, child);
                else $21c50eeb436ec60e$var$pushOrUnshiftByCaptureGroup(rest, child);
            }
        }
    }
    return [
        ...exactMatch,
        ...lengthMatch,
        ...rest
    ];
}
function $21c50eeb436ec60e$var$recursivelyFindOptionalNodes(node, queryParams = {}) {
    const { segmentPattern: segmentPattern, children: children, routes: routes } = node;
    if (segmentPattern.endsWith('?')) {
        const maybeMatchedRoute = $21c50eeb436ec60e$var$matchRoutesByQuery(routes, queryParams);
        if (maybeMatchedRoute) return maybeMatchedRoute;
        for(const key in children){
            if (Object.prototype.hasOwnProperty.call(children, key)) return $21c50eeb436ec60e$var$recursivelyFindOptionalNodes(children[key]);
        }
    }
}
function $21c50eeb436ec60e$var$matchRoutesByQuery(routes, queryParamObject) {
    if (routes.length === 0) return null;
    // why do we sort the routes by query length?
    // because we want to match the most specific route first
    // and we assume that the more query params a route has, the more specific it is
    // of course, this is a heuristic and is prehaps not true in all cases but good enough for now
    const sortedRoutes = routes.sort((a, b)=>{
        const aQueryLength = a.query?.length || 0;
        const bQueryLength = b.query?.length || 0;
        if (bQueryLength === aQueryLength) {
            const aOrder = a.__unsafeOrder || 0;
            const bOrder = b.__unsafeOrder || 0;
            return aOrder - bOrder;
        }
        return bQueryLength - aQueryLength;
    });
    const filterRoutes = sortedRoutes.filter((route)=>{
        // if route has no query, anything query param will match
        if (route.query === undefined) return true;
        // we will get a real match from the execRouteMatching function later
        const fakeMatch = {
            params: {},
            query: {},
            isExact: false,
            path: '',
            url: ''
        };
        return !!(0, $2gGKS.default)(route.query, queryParamObject, fakeMatch);
    });
    if (filterRoutes.length) // return the first (most specific) route that matches the query
    return filterRoutes[0];
    return null;
}
const $21c50eeb436ec60e$var$findRoute = (tree, p, queryParams = {}, basePath)=>{
    const pathname = p.replace(basePath, '');
    // split the pathname into segments
    // e.g. /jira/projects/123 => ['', 'jira', 'projects', '123']
    const segments = pathname.split('/');
    // remove the first empty string
    if (segments[0] === '') segments.shift();
    // remove the last empty string
    if (segments[segments.length - 1] === '') segments.pop();
    // a first-in-first-out stack to keep track of the nodes we need to visit
    // start with the root node
    const stack = [
        tree.root
    ];
    let count = 0;
    const maxCount = 2000; // to prevent infinite loop
    // when we exacust the stack and can't find a match, means nothing matches
    while(stack.length > 0 && count < maxCount){
        count += 1;
        // pop the first node from the stack
        const node = stack.shift();
        // to make TypeScript happy. It's impossible to have a null node
        if (!node) return null;
        // if the node is a InvariantRoute, it means we have traversed its children and cannot find a higher specificity match
        // we should return this route
        if (!(node instanceof (0, $fL1td.Node))) // we found a match
        return node;
        const { children: children, routes: routes, level: level } = node;
        let maybeMatchedRoute = null;
        let shouldMatchChildren = true;
        if (Object.keys(children).length === 0) {
            // we've reached the end of a branch
            if (!routes.length) throw new Error('It should have a route at the end of a branch.');
            // let's match query
            maybeMatchedRoute = $21c50eeb436ec60e$var$matchRoutesByQuery(routes, queryParams);
            if (maybeMatchedRoute) {
                // do we have more segments to match with?
                if (segments.length > level) // we have more segments to match but this branch doesn't have any children left
                // let's check if the route has `exact: true`.
                {
                    if (maybeMatchedRoute.exact) // let's go to another branch.
                    maybeMatchedRoute = null;
                }
            }
        } else if (segments.length === level) // we've reached the end of the segments
        // does the node have a route?
        {
            if (routes.length) // let's match query
            maybeMatchedRoute = $21c50eeb436ec60e$var$matchRoutesByQuery(routes, queryParams);
        } else if (segments.length < level) {
            // we've exceeded the segments and shouldn't match children anymore
            shouldMatchChildren = false;
            // we check if this node and its children are optional
            // e.g. `/:a?/:b?/:c?` matches `/`
            // we check if `/:a?` node has a route, if `/:b?` node has a route, and if `/:c?` node has a route
            // if any of them has a route, we have a match
            maybeMatchedRoute = $21c50eeb436ec60e$var$recursivelyFindOptionalNodes(node, queryParams);
        } else {
            // there are more segments to match and this node has children
            // we need to check if this node has a route that has `exact: false`
            // if it has, we have a potential match. We will unshift it to the stack.
            // we will continue to check the children of this node to see if we can find a more specific match
            // let's match query
            const lowSpecifityRoute = $21c50eeb436ec60e$var$matchRoutesByQuery(routes, queryParams);
            if (lowSpecifityRoute && !lowSpecifityRoute.exact) // we have a potential match
            stack.unshift(lowSpecifityRoute);
        }
        // yay, we found a match
        if (maybeMatchedRoute) return maybeMatchedRoute;
        if (shouldMatchChildren) {
            // if we haven't found a match, let's check the current node's children
            const nodes = $21c50eeb436ec60e$var$matchChildren(node, segments);
            // add potential matched children to the stack
            stack.unshift(...nodes);
        }
    // go back to the beginning of the loop, pop out the next node from the stack, and repeat
    }
    return null;
};
function $21c50eeb436ec60e$var$getRouteMatch(route, pathname, queryParamObject, basePath) {
    if (route) {
        const matchedRoute = (0, $8tutR.default)(route, pathname, queryParamObject, basePath);
        if (matchedRoute) return matchedRoute;
    }
    return null;
}
const $21c50eeb436ec60e$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $cW5DS.parse)(queryParams) : queryParams;
    // fast return if there is no route or only one route
    if (routes.length === 0) return null;
    if (routes.length === 1) return $21c50eeb436ec60e$var$getRouteMatch(routes[0], pathname, queryParamObject, basePath);
    const tree = (0, $fL1td.treeify)(routes);
    const route = $21c50eeb436ec60e$var$findRoute(tree, pathname, queryParamObject, basePath) || tree.fallbackRoute;
    return $21c50eeb436ec60e$var$getRouteMatch(route, pathname, queryParamObject, basePath);
};
const $21c50eeb436ec60e$export$64cff351ed093433 = (tree, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $cW5DS.parse)(queryParams) : queryParams;
    const route = $21c50eeb436ec60e$var$findRoute(tree, pathname, queryParamObject, basePath) || tree.fallbackRoute;
    return $21c50eeb436ec60e$var$getRouteMatch(route, pathname, queryParamObject, basePath);
};
var $21c50eeb436ec60e$export$2e2bcd8739ae039 = $21c50eeb436ec60e$var$matchRoute;

});
parcelRegister("8tutR", function(module, exports) {

$parcel$export(module.exports, "default", () => $44f8d5f5c5d45e1d$export$2e2bcd8739ae039);

var $2vhrK = parcelRequire("2vhrK");

var $2gGKS = parcelRequire("2gGKS");
/* This should match what react-router does to compute a root match. */ const $44f8d5f5c5d45e1d$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $44f8d5f5c5d45e1d$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $2vhrK.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $44f8d5f5c5d45e1d$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $2gGKS.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = {
        ...pathMatch,
        query: {}
    };
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $44f8d5f5c5d45e1d$export$2e2bcd8739ae039 = $44f8d5f5c5d45e1d$var$execRouteMatching;

});
parcelRegister("2vhrK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d8644e8f87d8833$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $ffH38 = parcelRequire("ffH38");
const $4d8644e8f87d8833$var$cache = {};
const $4d8644e8f87d8833$var$cacheLimit = 10000;
let $4d8644e8f87d8833$var$cacheCount = 0;
function $4d8644e8f87d8833$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $4d8644e8f87d8833$var$cache[cacheKey] || ($4d8644e8f87d8833$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $ffH38.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($4d8644e8f87d8833$var$cacheCount < $4d8644e8f87d8833$var$cacheLimit) {
        pathCache[path] = result;
        $4d8644e8f87d8833$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $4d8644e8f87d8833$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) // eslint-disable-next-line no-param-reassign
    options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $4d8644e8f87d8833$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === '/' && url === '' ? '/' : url,
            isExact: isExact,
            params: keys.reduce((memo, key, index)=>{
                // eslint-disable-next-line no-param-reassign
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $4d8644e8f87d8833$export$2e2bcd8739ae039 = $4d8644e8f87d8833$var$matchPath;

});
parcelRegister("ffH38", function(module, exports) {

$parcel$export(module.exports, "pathToRegexp", () => $b8265e704acafc1f$export$71304158c7e35877);
// Taken from https://github.com/pillarjs/path-to-regexp/blob/v6.2.1/src/index.ts
// To address version mismatch with root package.json
/**
 * Tokenizer results.
 */ /**
 * Tokenize input string.
 */ function $b8265e704acafc1f$var$lexer(str) {
    const tokens = [];
    let i = 0;
    while(i < str.length){
        const char = str[i];
        if (char === '*' || char === '+' || char === '?') {
            tokens.push({
                type: 'MODIFIER',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '\\') {
            tokens.push({
                type: 'ESCAPED_CHAR',
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === '{') {
            tokens.push({
                type: 'OPEN',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '}') {
            tokens.push({
                type: 'CLOSE',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ':') {
            let name = '';
            let j = i + 1;
            while(j < str.length){
                const code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError(`Missing parameter name at ${i}`);
            tokens.push({
                type: 'NAME',
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === '(') {
            let count = 1;
            let pattern = '';
            let j = i + 1;
            if (str[j] === '?') throw new TypeError(`Pattern cannot start with "?" at ${j}`);
            while(j < str.length){
                if (str[j] === '\\') {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ')') {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === '(') {
                    count++;
                    if (str[j + 1] !== '?') throw new TypeError(`Capturing groups are not allowed at ${j}`);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError(`Unbalanced pattern at ${i}`);
            if (!pattern) throw new TypeError(`Missing pattern at ${i}`);
            tokens.push({
                type: 'PATTERN',
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: 'CHAR',
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: 'END',
        index: i,
        value: ''
    });
    return tokens;
}
function $b8265e704acafc1f$export$98e6a39c04603d36(str, options = {}) {
    const tokens = $b8265e704acafc1f$var$lexer(str);
    const { prefixes: prefixes = './' } = options;
    const defaultPattern = `[^${$b8265e704acafc1f$var$escapeString(options.delimiter || '/#?')}]+?`;
    const result = [];
    let key = 0;
    let i = 0;
    let path = '';
    const tryConsume = (type)=>{
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    const mustConsume = (type)=>{
        const value = tryConsume(type);
        if (value !== undefined) return value;
        const { type: nextType, index: index } = tokens[i];
        throw new TypeError(`Unexpected ${nextType} at ${index}, expected ${type}`);
    };
    const consumeText = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
        let result = '';
        let value;
        // eslint-disable-next-line no-cond-assign -- ERROR TO BE FIXED
        while(value = tryConsume('CHAR') || tryConsume('ESCAPED_CHAR'))result += value;
        return result;
    };
    while(i < tokens.length){
        const char = tryConsume('CHAR');
        const name = tryConsume('NAME');
        const pattern = tryConsume('PATTERN');
        if (name || pattern) {
            let prefix = char || '';
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = '';
            }
            if (path) {
                result.push(path);
                path = '';
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: '',
                pattern: pattern || defaultPattern,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        const value = char || tryConsume('ESCAPED_CHAR');
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = '';
        }
        const open = tryConsume('OPEN');
        if (open) {
            const prefix = consumeText();
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const name = tryConsume('NAME') || '';
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const pattern = tryConsume('PATTERN') || '';
            const suffix = consumeText();
            mustConsume('CLOSE');
            result.push({
                name: name || (pattern ? key++ : ''),
                pattern: name && !pattern ? defaultPattern : pattern,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        mustConsume('END');
    }
    return result;
}
function $b8265e704acafc1f$export$ef7acd7185315e22(str, options) {
    return $b8265e704acafc1f$export$5b9bad9e403cf3d9($b8265e704acafc1f$export$98e6a39c04603d36(str, options), options);
}
function $b8265e704acafc1f$export$5b9bad9e403cf3d9(tokens, options = {}) {
    const reFlags = $b8265e704acafc1f$var$flags(options);
    const { encode: encode = (x)=>x, validate: validate = true } = options;
    // Compile all the tokens into regexps.
    // eslint-disable-next-line array-callback-return -- ERROR TO BE FIXED
    const matches = tokens.map((token)=>{
        if (typeof token === 'object') return new RegExp(`^(?:${token.pattern})$`, reFlags);
    });
    return (data)=>{
        let path = '';
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            const optional = token.modifier === '?' || token.modifier === '*';
            const repeat = token.modifier === '*' || token.modifier === '+';
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError(`Expected "${token.name}" to not repeat, but got an array`);
                if (value.length === 0) {
                    // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
                    if (optional) continue;
                    throw new TypeError(`Expected "${token.name}" to not be empty`);
                }
                for(let j = 0; j < value.length; j++){
                    const segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError(`Expected all "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number') {
                const segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError(`Expected "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                path += token.prefix + segment + token.suffix;
                continue;
            }
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (optional) continue;
            const typeOfMessage = repeat ? 'an array' : 'a string';
            throw new TypeError(`Expected "${token.name}" to be ${typeOfMessage}`);
        }
        return path;
    };
}
function $b8265e704acafc1f$export$4659b591c19bdf3d(str, options) {
    const keys = [];
    const re = $b8265e704acafc1f$export$71304158c7e35877(str, keys, options);
    return $b8265e704acafc1f$export$968e97c88708237a(re, keys, options);
}
function $b8265e704acafc1f$export$968e97c88708237a(re, keys, options = {}) {
    const { decode: decode = (x)=>x } = options;
    return function(pathname) {
        const m = re.exec(pathname);
        if (!m) return false;
        const { 0: path, index: index } = m;
        const params = Object.create(null);
        for(let i = 1; i < m.length; i++){
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (m[i] === undefined) continue;
            const key = keys[i - 1];
            if (key.modifier === '*' || key.modifier === '+') params[key.name] = m[i].split(key.prefix + key.suffix).map((value)=>decode(value, key));
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $b8265e704acafc1f$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 */ function $b8265e704acafc1f$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 */ function $b8265e704acafc1f$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    let index = 0;
    let execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: '',
            suffix: '',
            modifier: '',
            pattern: ''
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $b8265e704acafc1f$var$arrayToRegexp(paths, keys, options) {
    const parts = paths.map((path)=>$b8265e704acafc1f$export$71304158c7e35877(path, keys, options).source);
    return new RegExp(`(?:${parts.join('|')})`, $b8265e704acafc1f$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $b8265e704acafc1f$var$stringToRegexp(path, keys, options) {
    return $b8265e704acafc1f$export$9a9303716def6456($b8265e704acafc1f$export$98e6a39c04603d36(path, options), keys, options);
}
function $b8265e704acafc1f$export$9a9303716def6456(tokens, keys, options = {}) {
    const { strict: strict = false, start: start = true, end: end = true, encode: encode = (x)=>x, delimiter: delimiter = '/#?', endsWith: endsWith = '' } = options;
    const endsWithRe = `[${$b8265e704acafc1f$var$escapeString(endsWith)}]|$`;
    const delimiterRe = `[${$b8265e704acafc1f$var$escapeString(delimiter)}]`;
    let route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for (const token of tokens)if (typeof token === 'string') route += $b8265e704acafc1f$var$escapeString(encode(token));
    else {
        const prefix = $b8265e704acafc1f$var$escapeString(encode(token.prefix));
        const suffix = $b8265e704acafc1f$var$escapeString(encode(token.suffix));
        if (token.pattern) {
            if (keys) keys.push(token);
            if (prefix || suffix) {
                if (token.modifier === '+' || token.modifier === '*') {
                    const mod = token.modifier === '*' ? '?' : '';
                    route += `(?:${prefix}((?:${token.pattern})(?:${suffix}${prefix}(?:${token.pattern}))*)${suffix})${mod}`;
                } else route += `(?:${prefix}(${token.pattern})${suffix})${token.modifier}`;
            } else if (token.modifier === '+' || token.modifier === '*') route += `((?:${token.pattern})${token.modifier})`;
            else route += `(${token.pattern})${token.modifier}`;
        } else route += `(?:${prefix}${suffix})${token.modifier}`;
    }
    if (end) {
        if (!strict) route += `${delimiterRe}?`;
        route += !options.endsWith ? '$' : `(?=${endsWithRe})`;
    } else {
        const endToken = tokens[tokens.length - 1];
        const isEndDelimited = typeof endToken === 'string' ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += `(?:${delimiterRe}(?=${endsWithRe}))?`;
        if (!isEndDelimited) route += `(?=${delimiterRe}|${endsWithRe})`;
    }
    return new RegExp(route, $b8265e704acafc1f$var$flags(options));
}
function $b8265e704acafc1f$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $b8265e704acafc1f$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $b8265e704acafc1f$var$arrayToRegexp(path, keys, options);
    return $b8265e704acafc1f$var$stringToRegexp(path, keys, options);
}

});


parcelRegister("2gGKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5f2dd3fcedbb7f3$export$2e2bcd8739ae039);
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $c5f2dd3fcedbb7f3$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? {
        ...pathMatch,
        query: queryMatch
    } : null;
}
var $c5f2dd3fcedbb7f3$export$2e2bcd8739ae039 = $c5f2dd3fcedbb7f3$var$matchQuery;

});


parcelRegister("cW5DS", function(module, exports) {

$parcel$export(module.exports, "parse", () => $ef80e68b9fc9ecd8$export$98e6a39c04603d36);
// Source: https://github.com/unshiftio/querystringify/blob/2.2.0/index.js
// Purpose: Eliminate dependencies from `@atlassian/match-route` for micro-optimization
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $ef80e68b9fc9ecd8$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
function $ef80e68b9fc9ecd8$export$98e6a39c04603d36(query) {
    const parser = /([^=?#&]+)=?([^&]*)/g;
    const result = {};
    let part;
    while(part = parser.exec(query)){
        var key = $ef80e68b9fc9ecd8$var$decode(part[1]), value = $ef80e68b9fc9ecd8$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}

});

parcelRegister("fL1td", function(module, exports) {

$parcel$export(module.exports, "Node", () => $6a809f226c37e2e0$export$85c928794f8d04d4);
$parcel$export(module.exports, "treeify", () => $6a809f226c37e2e0$export$3d862f7d2d0026e7);
/* eslint-disable max-classes-per-file */ class $6a809f226c37e2e0$export$85c928794f8d04d4 {
    constructor(level, segmentPattern){
        this.children = {};
        this.routes = [];
        this.level = level;
        this.segmentPattern = segmentPattern;
    }
}
class $6a809f226c37e2e0$export$7fbedc92909ed28e {
    constructor(){
        // fallback route is the routes that match everything.
        // this is normally useful for 404 pages
        // we specifically handle this route for performance reason
        // because if we put it into the tree, it will always get traversed and has the least specificity.
        this.fallbackRoute = null;
        this.root = new $6a809f226c37e2e0$export$85c928794f8d04d4(0, '');
    }
    insert(segmentPatterns, route) {
        let current = this.root;
        for(let i = 0; i < segmentPatterns.length; i++){
            const segmentPattern = segmentPatterns[i];
            if (!current.children[segmentPattern]) current.children[segmentPattern] = new $6a809f226c37e2e0$export$85c928794f8d04d4(i + 1, segmentPattern);
            current = current.children[segmentPattern];
        }
        current.routes.push(route);
    }
}
const $6a809f226c37e2e0$var$trim = (segmentPatterns)=>{
    // remove the first empty string
    if (segmentPatterns[0] === '') segmentPatterns.shift();
    // remove the last empty string
    if (segmentPatterns[segmentPatterns.length - 1] === '') segmentPatterns.pop();
};
const $6a809f226c37e2e0$export$3d862f7d2d0026e7 = (routes)=>{
    const tree = new $6a809f226c37e2e0$export$7fbedc92909ed28e();
    routes.forEach((route)=>{
        if (typeof route.path !== 'string' || route.path === '' || route.path === '/*' || route.path === '*') {
            if (tree.fallbackRoute) throw new Error('There should be only one route that mates everything.');
            tree.fallbackRoute = route;
            return;
        }
        // the regex will match ":projectType(software|software/c|servicedesk|core)"
        // it handles the case where we have multiple segments in a capture group such as "software/c"
        // the regex can be improved to handle more general cases, however let's keep it simple for now
        const match = /:projectType\(([a-z|]*software\/c[a-z|]*)\)/.exec(route.path);
        if (match) {
            // `match` looks like [":projectType(software|software/c|servicedesk|core)", "software|software/c|servicedesk|core" ...]
            const segment = match[0];
            const captureGroup = match[1];
            captureGroup.split('|').forEach((projectType)=>{
                // we craete several branches, e.g.
                // /jira/:projectType(software|software/c)/foo
                // becauses
                // - /jira/software/foo
                // - /jira/software/c/foo
                // although they appear in different position in the tree, they should share the same route
                const path = route.path.replace(segment, projectType);
                const segmentPatterns = path.split('/');
                $6a809f226c37e2e0$var$trim(segmentPatterns);
                tree.insert(segmentPatterns, route);
            });
        } else {
            const segmentPatterns = route.path.split('/');
            $6a809f226c37e2e0$var$trim(segmentPatterns);
            tree.insert(segmentPatterns, route);
        }
    });
    return tree;
};

});


parcelRegister("9E7Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d201f329142c2c2$export$2e2bcd8739ae039);

var $bhUJ4 = parcelRequire("bhUJ4");

var $ibWJJ = parcelRequire("ibWJJ");
const $6d201f329142c2c2$var$DEFAULT_TIMING = {
    initialPollInterval: 5000,
    idleTimeout: 30000,
    multiplierCallback: (x)=>x + x
};
class $6d201f329142c2c2$export$2e2bcd8739ae039 {
    /**
	 * Callback for sending a 'track' analytics event. This callback should either be the
	 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
	 * The data for the dwell event will be passed to this method for sending.
	 *
	 * @callback trackCallback
	 * @param {Object} eventData - the base event data that will be added to the track event.
	 */ /**
	 * Creates and initialises the DwellTimeHelper.
	 *
	 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
	 * the event.
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * Additional dwell time attributes will be appended to this data. Note that you don't need to
	 * include the 'action' property, as this will be added automatically.
	 * @param {?string} searchSessionId - a unique identifier for the related search session.
	 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
	 * timing used for measuring dwell time. The following values are possible:
	 * - initialPollInterval: how long to wait before the first dwell milestone event
	 * is fired (in seconds). Default = 5.
	 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
	 * event. Default = 2.
	 * - idleTimeout: how long to wait for no user activity before pausing
	 * the dwell timer (in seconds). Default = 30s.
	 */ constructor(trackCallback, eventData, searchSessionId, timingOptions){
        /**
	 * Starts the dwell timer. This method should be called upon the initial page load.
	 */ this.start = ()=>{
            this.browserInteractionTime.startTimer();
            this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                timeInMilliseconds: this._timing.initialPollInterval,
                multiplier: this._timing.multiplierCallback
            });
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', this._onBeforeUnload);
        };
        /**
	 * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
	 * finalise a dwell measurement without starting a new one. When switching to a new page in a
	 * single-page app, use newPage instead.
	 */ this.stop = ()=>{
            if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
            this.browserInteractionTime.stopTimer();
        };
        /**
	 * Send the final dwell event and reinitialise the dwell timer for a new page.
	 * This method should be called whenever a new page is switched to in a single-page app context.
	 *
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * @param {?string} searchSessionId - the new search session ID.
	 */ this.newPage = (eventData, searchSessionId)=>{
            (0, $ibWJJ.validateDwellBaseEvent)(eventData);
            this.stop();
            this.browserInteractionTime.reset();
            this.setEventData(eventData);
            this.setSearchSessionId(searchSessionId);
            this.start();
        };
        this.setEventData = (eventData)=>{
            this._eventData = eventData;
        };
        this.getEventData = ()=>this._eventData;
        this.setSearchSessionId = (searchSessionId)=>{
            this._searchSessionId = searchSessionId;
        };
        this.getSearchSessionId = ()=>this._searchSessionId;
        this.destroy = ()=>{
            this.browserInteractionTime.destroy();
            if (typeof window !== 'undefined') window.removeEventListener('beforeunload', this._onBeforeUnload);
        };
        this._onBeforeUnload = ()=>{
            this.stop();
            this.destroy();
        };
        this._sendDwellEvent = (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: timeInMilliseconds,
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $ibWJJ.validateDwellBaseEvent)(eventData);
        this._trackCallback = trackCallback;
        this._eventData = eventData;
        this._searchSessionId = searchSessionId;
        this._timing = {
            ...$6d201f329142c2c2$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this.browserInteractionTime = new (0, $bhUJ4.default)({
            idleTimeoutMs: this._timing.idleTimeout,
            checkCallbacksIntervalMs: 500
        });
    }
}

});

parcelRegister("6Lg6A", function(module, exports) {

$parcel$export(module.exports, "LazyWait", () => $cbd15d2aa1b9d641$export$7bf6cf03fd32cddb);

var $5uXOq = parcelRequire("5uXOq");

var $5poak = parcelRequire("5poak");
const $cbd15d2aa1b9d641$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $5uXOq.useContext)((0, $5poak.WaitContext));
    const value = (0, $5uXOq.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $5uXOq.useRef)(new Set());
    const api = (0, $5uXOq.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $5uXOq.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5poak.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("lGgkA", function(module, exports) {

$parcel$export(module.exports, "LooselyLazy", () => $fb5c81c3481f1496$export$33c5f161e1d4706);

var $14COT = parcelRequire("14COT");

var $ddkdN = parcelRequire("ddkdN");

var $adSzG = parcelRequire("adSzG");
var $j7rCb = parcelRequire("j7rCb");

var $7AnOd = parcelRequire("7AnOd");
const $fb5c81c3481f1496$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $ddkdN.setConfig)(config);
        (0, $adSzG.LISTENERS).length = 0;
        (0, $j7rCb.setCurrent)(0);
        if (!(0, $7AnOd.isNodeEnvironment)()) (0, $14COT.collect)();
    }
};

});
parcelRegister("14COT", function(module, exports) {

$parcel$export(module.exports, "collect", () => $978a626ba3d81e71$export$bb44f104e3c54dae);

var $ddkdN = parcelRequire("ddkdN");
var $7Ewwd = parcelRequire("7Ewwd");

var $fVdZG = parcelRequire("fVdZG");

var $jM6DK = parcelRequire("jM6DK");

var $89lw9 = parcelRequire("89lw9");
const $978a626ba3d81e71$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $ddkdN.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $7Ewwd.MODE).RENDER ? (0, $jM6DK.cloneElements)(markers[i], lazyBegin) : (0, $89lw9.refElements)(markers[i], lazyBegin);
        if ((0, $fVdZG.COLLECTED).has(lazyBegin)) (0, $fVdZG.COLLECTED).get(lazyBegin).push(value);
        else (0, $fVdZG.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("jM6DK", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $4f61859029d09f51$export$c42217d53a7ebafb);
const $4f61859029d09f51$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("89lw9", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $3e418ca48259b973$export$c69443129766a7fc);
const $3e418ca48259b973$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});



parcelRegister("5NkCx", function(module, exports) {

$parcel$export(module.exports, "default", () => $693fcf9674734d10$export$2e2bcd8739ae039);
// @ts-ignore no types for this package :(

var $awmeS = parcelRequire("awmeS");

var $ibWJJ = parcelRequire("ibWJJ");
const $693fcf9674734d10$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
class $693fcf9674734d10$export$2e2bcd8739ae039 {
    /**
	 * Callback for sending a 'track' analytics event. This callback should either be the
	 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
	 * The data for the dwell event will be passed to this method for sending.
	 *
	 * @callback trackCallback
	 * @param {Object} eventData - the base event data that will be added to the track event.
	 */ /**
	 * Creates and initialises the DwellTimeHelper.
	 *
	 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
	 * the event.
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * Additional dwell time attributes will be appended to this data. Note that you don't need to
	 * include the 'action' property, as this will be added automatically.
	 * @param {?string} searchSessionId - a unique identifier for the related search session.
	 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
	 * timing used for measuring dwell time. The following values are possible:
	 * - initialPollInterval: how long to wait before the first dwell milestone event
	 * is fired (in seconds). Default = 5.
	 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
	 * event. Default = 2.
	 * - idleTimeout: how long to wait for no user activity before pausing
	 * the dwell timer (in seconds). Default = 30s.
	 * @param {?DwellTimeHelperOptions} dwellTimeHelperOptions - options provided to customise behaviour
	 * of the helper.
	 * - iframeDwell = enable detection of activity in iframes.
	 */ constructor(trackCallback, eventData, searchSessionId, timingOptions, dwellTimeHelperOptions){
        this.timeMeInitialized = false;
        /**
	 * Starts the dwell timer. This method should be called upon the initial page load.
	 */ this.start = ()=>{
            if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
            this.timeMeInitialized = true;
            this._initDwellTimeCounterAndPolling();
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                this.stop();
            });
        };
        /**
	 * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
	 * finalise a dwell measurement without starting a new one. When switching to a new page in a
	 * single-page app, use newPage instead.
	 */ this.stop = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).stopAllTimers();
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).resetAllRecordedPageTimes();
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).timeElapsedCallbacks = [];
            this.timeMeInitialized = false;
        };
        /**
	 * Send the final dwell event and reinitialise the dwell timer for a new page.
	 * This method should be called whenever a new page is switched to in a single-page app context.
	 *
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * @param {?string} searchSessionId - the new search session ID.
	 */ this.newPage = (eventData, searchSessionId)=>{
            (0, $ibWJJ.validateDwellBaseEvent)(eventData);
            this.stop();
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._initDwellTimeCounterAndPolling();
        };
        /**
	 * This is a modified version of timeit's original listForIdleEvents function,
	 * which also listens to events inside same-origin iframes (such as Confluence whiteboards and databases).
	 * https://github.com/jasonzissman/TimeMe.js/blob/master/timeme.js#L338
	 */ this._listForIdleEvents = ()=>{
            document.addEventListener('mousemove', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
            });
            document.addEventListener('keyup', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
            });
            document.addEventListener('touchstart', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
            });
            window.addEventListener('scroll', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
            });
            /**
		 * Find all same origin iframes (same origin allow access to contentWindow.document)
		 * and add event listeners to them too.
		 */ const iframes = document.getElementsByTagName('iframe');
            for(let i = 0; i < iframes.length; i++){
                const iframe = iframes[i];
                try {
                    iframe?.contentWindow?.document.addEventListener('mousemove', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('keyup', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('touchstart', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
                    });
                } catch (e) {
                // do nothing: We don't want to listen to cross-origin iframes
                }
            }
            setInterval(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).isUserCurrentlyIdle !== true) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).checkIdleState();
                    // This ensures the timer continues when switching between the iframe and the rest of the page
                    (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).startTimer();
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).checkIdleStateRateMs);
        };
        this._initDwellTimeCounterAndPolling = ()=>{
            // If iframeDwell is enabled, override the listener for idle events to also listen to events in iframes.
            if (this._dwellTimeHelperOptions?.iframeDwell) (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).listForIdleEvents = this._listForIdleEvents;
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).initialize({
                idleTimeoutInSeconds: this._timing.idleTimeout
            });
            this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
        };
        this._pollDwellTime = (pollTime, searchSessionId, eventData)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                this._sendDwellEvent(eventData, searchSessionId, false);
                this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
            });
        };
        this._sendDwellEvent = (eventData, searchSessionId, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).getTimeOnCurrentPageInMilliseconds(),
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                containers: eventData.containers,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $ibWJJ.validateDwellBaseEvent)(eventData);
        this._trackCallback = trackCallback;
        this._eventData = eventData;
        this._searchSessionId = searchSessionId;
        this._timing = {
            ...$693fcf9674734d10$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this._dwellTimeHelperOptions = dwellTimeHelperOptions;
    }
}

});

const $af03419a6de12610$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $af03419a6de12610$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $af03419a6de12610$export$13f57c02915787b3 = 'atlaskit-portal';

const $edbbaf000cbe1dd7$export$ed5835cc67e87f72 = 'akPortalMount';
const $edbbaf000cbe1dd7$export$80816bd900e5bd00 = 'akPortalUnmount';

var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $ff8b18549b2c06bf$export$d6830277b06edd6 = 'normal';
const $ff8b18549b2c06bf$export$4f8f13a66ae77bdd = '--color';
const $ff8b18549b2c06bf$export$e9244ec13bd422b5 = '--bg-color';
const $ff8b18549b2c06bf$export$97e78d9745006c11 = '--bg-color-hover';
const $ff8b18549b2c06bf$export$291d63757828f290 = '--bg-color-active';


$parcel$global.rlb("2Lfdl")
//# sourceMappingURL=shared~vendor~atlassian~ar.11ab6ee9.js.map
